import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { computeFinalResult } from "../../Utils/computeFinalResult";
import { transformAwardSnapshot } from "../../Utils/transformAwardSnapshot";
import { getMissingDocsFromSnapshot } from "../../Utils/getMissingDocsFromSnapshot";
import axiosInstance from "../../services/authWrapper";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import {
  calculateEffortRate,
  getCustomIncomeDetails,
  haveValue,
  shouldDeductNextView,
  isDefaulter,
  toast,
  amlKycChecks,
  getFieldForPolicies,
  calculateFinalScore,
  getRentPercentage,
  getCustomIncome,
  getUserDisplayName,
  getIdentityDetails,
  tenantHasMissingDniNie,
  formatPropertyAddress,
  toTitleCase,
  resolveIncomeSelection,
  DEBUG_CALCULATION,
  calculateOverlayScore,
} from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import AwardPropertyPopup from "./AwardPropertyPopup";
import { Link, useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import CloseIcon from "../../assets/img/closeIcon.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import UnLinkIcon from "../../assets/img/unlink-icon.svg";

import Loader from "../Loader";
import LoadingSpinner from "../LoadingSpinner";
import SuccessAwardedPropModal from "./SuccessAwardedPropModal";
import ServingPromptModal from "../../pages/landlord/profile-request/ServingPromptModal";
import PurchaseInsurancePopup from "./PurchaseInsurance";
import AwardInsuranceConfirmPopup from "./AwardInsuranceConfirmPopup";
import AwardInsuranceProcessingModal from "./AwardInsuranceProcessingModal";
import SkorProtectActivatedPopup from "./SkorProtectActivatedPopup";
import moment from "moment";
import { IoStopwatchOutline } from "react-icons/io5";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  CheckIcon,
  DocIcon,
  DownloadIcon,
  OutlineShieldIcon,
  PencilEditIcon,
  ShieldIcon,
} from "../../helper/svgHelper";
import RiskAssessmentReport from "./RiskAssessmentReport";
import InsuranceReviewModal from "./InsuranceReviewModal";
import InsuranceSimulationErrorsModal from "./InsuranceSimulationErrorsModal";
import InviteTenantModal from "./InviteTenantModal";
import {
  getSelectedTenantIds,
  getSelectedProfilesFromSelections,
  getSelectionModelFromSelections,
  getSelectionsFromProfiles,
  isParticipantSelected,
  isApplicationFullySelected,
  isApplicationPartiallySelected,
  getGuarantorIdsForEntry,
  getSimulationCacheKey,
} from "./LinkedPropertiesSelectionHelpers";
import { useSelectionModel } from "./useSelectionModel";
import "./LinkedPropertiesPopup.css";
import SkorProtectBadge from "../SkorProtectBadge/SkorProtectBadge";
import InsuranceShieldIcon from "./InsuranceShieldIcon";
import socket from "../../socket";
import constants from "../../Utils/constants";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";
import { getProfileReminders } from "../../services/sharedService";
import PropertyHistoryTimeline from "./PropertyHistoryTimeline";
import VacatePropertyModal from "./VacatePropertyModal";
import SaveAwardedChangesModal from "./SaveAwardedChangesModal";
import { ClockIcon as SkorClockIcon } from "../../pages/skor-protect/SkorProtectIcons";
import { getInsuranceReportStatus } from "../../Utils/insuranceReportStatus";

const checkIsProfilePending = (tenant, profile) => {
  if (!tenant) return false;
  if (profile?.pendingDecision) return true;
  return tenant?.tenant_extra_field_id?.landlord_ids_for_forensic_notification?.some(
    (i) => i?.profile_id === profile?._id
  );
};

const GuarantorSubRow = ({
  guarantor,
  rent,
  user,
  _t,
  deaWorkspace,
  handleOpenProfile,
  assignPropData,
  isApplication,
  sharedProfileId,
  parentTenantId,
  isGuarantorSelected,
  onToggleGuarantor,
  isDisabled,
}) => {
  if (!guarantor) return null;
  const incomeSelection = resolveIncomeSelection(
    assignPropData?.income_selection,
    assignPropData?.tenantid?._id
  );
  const guarantorIncomeSelection =
    incomeSelection?.[assignPropData?.tenantid?._id]?.guarantor_sources ??
    incomeSelection?.guarantor_sources;

  const guarantorIncomeObj = getCustomIncomeDetails(
    guarantor,
    user,
    _t,
    guarantorIncomeSelection?.[guarantor?._id],
    undefined,
    undefined,
    deaWorkspace,
    assignPropData?.custom_income_sources
  );
  const guarantorIncome = guarantorIncomeObj?.amount ?? 0;
  const effortRate = getRentPercentage(guarantorIncome, rent)?.roundValue ?? 0;

  return (
    <div
      className={`${isApplication ? "bg-white" : ""} guarantor-sub-row d-flex align-items-center cursor-pointer w-100 `}
    >
      {sharedProfileId && onToggleGuarantor && (
        <div
          className={`checkboxWrapper d-flex align-items-center justify-content-center ${
            isDisabled ? "checkboxWrapperDisabled" : ""
          }`}
          style={{ marginRight: 8 }}
        >
          <label className="custom-gap-3 custom-checkbox mb-0">
            <input
              type="checkbox"
              checked={!!isGuarantorSelected}
              disabled={isDisabled}
              onChange={() =>
                onToggleGuarantor(
                  sharedProfileId,
                  parentTenantId,
                  guarantor?._id
                )
              }
            />
            <span className="custom-checkmark" />
          </label>
        </div>
      )}
      <div className="guarantor-sub-row-avatar-wrapper position-relative">
        <img src={"/images/user-shield.svg"} alt="Guarantor" />
      </div>
      <div
        className="guarantor-details-wrapper ms-2 w-100"
        onClick={() => handleOpenProfile(guarantor, assignPropData?._id)}
      >
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center gap-2">
            <h6 className="guarantor-name mb-0">
              {getUserDisplayName(guarantor)}
            </h6>
            <span className="guarantor-tag">
              {_t("guarantor", "Guarantor")}
            </span>
          </div>
        </div>
        <div className="guarantor-income-details text-start">
          {_t("income", "Income")}: {guarantorIncome} €/{_t("mo", "mo")}{" "}
          <span className="mx-1">·</span> {_t("effortRate", "Effort rate")}:{" "}
          {effortRate}%
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="14"
        viewBox="0 0 8 13"
        fill="none"
        className="arrow-icon ms-auto"
      >
        <path
          d="M1 12L7 6.5L1 1"
          stroke="#A3A3A3"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

const LinkedPropertiesPopup = ({
  detailsShow,
  setDetailsShow,
  setPropData,
  property,
  tanentData,
  handleSaveChanges,
  saveTanentLoading,
  setSelectedTanents,
  selectedTanents,
  searchText,
  setSearchText,
  onPropertyAward,
  setPreselectedTanents,
  setsaveTanentLoading,
  loadData,
  onTenantLinked,
  currentLang,
  onEditProperty,
}) => {
  const LINKED_REPORT_CACHE_PREFIX = "linked-report-cache-";
  const LINKED_REPORT_CACHE_TTL_MS = 10 * 60 * 1000;
  const { _t } = useTranslator();

  const STATUS_STYLES = {
    yellow: {
      backgroundColor: "#FFFBEC",
      color: "#E1BB20",
      textColor: "#61380A",
      border: ".1389vw solid #F2E09B",
      text: _t("manualReview"),
      img: "/images/warning.svg",
      fw: "600",
      deaIndividualText: _t("reviewDea"),
    },
    grey: {
      backgroundColor: "#F7F7F7",
      color: "#253837",
      border: ".1389vw solid #E6E6E6",
      text: _t("selectTenantsToCheckApproval"),
      fw: "500",
      deaIndividualText: _t("notFoundDea"),
    },
    green: {
      backgroundColor: "#F2FBE9",
      color: "#82CF3F",
      textColor: "#0C4B25",
      border: ".1389vw solid #DAECC8",
      text: _t("approved"),
      img: "/images/tick-new.svg",
      fw: "600",
      deaIndividualText: _t("eligibleDea"),
    },
    red: {
      backgroundColor: "#FFE2E2",
      color: "#FF3C3C",
      border: ".1389vw solid #EB9B9C",
      text: _t("notApproved"),
      img: "/images/notApproved.svg",
      fw: "600",
      deaIndividualText: _t("hardFailDea"),
    },
  };
  const isPropertyAwarded = property?.is_awarded;
  const isCoverageUnderReview =
    property?.coverage_review?.status === "under_review";
  const policyStartDate =
    property?.insurance_data?.policy_start_date ||
    property?.insurance_data?.simulationPayload?.fechaEfectoPoliza ||
    property?.skor_protect_data?.skor_protect_initiated;
  const policyEndDate =
    property?.insurance_data?.policy_end_date ||
    (policyStartDate
      ? moment(policyStartDate, [moment.ISO_8601, "DD/MM/YYYY"])
          .add(1, "year")
          .toISOString()
      : null);
  const formatPolicyDate = (date) =>
    date
      ? moment(date, [moment.ISO_8601, "DD/MM/YYYY"]).format("DD/MM/YYYY")
      : null;
  const isAwardSnapshotProcessing =
    property?.award_snapshot_info?.status === "processing";
  const isAwardSnapshotCompleted =
    property?.award_snapshot_info?.status === "completed";
  const isPropertyBlocked =
    ["waiting_for_payment", "waiting_for_rental_contract"]?.includes(
      property?.skor_protect_data?.skor_protect_status
    ) ||
    property?.insurance_beneficiary_payment_data?.payment_link_status ===
      "waiting_for_payment";
  const persistedBlockingSelections = [
    "waiting_for_payment",
    "waiting_for_rental_contract",
  ].includes(property?.skor_protect_data?.skor_protect_status)
    ? property?.skor_protect_data?.selections
    : property?.insurance_beneficiary_payment_data?.selections;
  const blockingSelections = persistedBlockingSelections?.length
    ? persistedBlockingSelections
    : null;

  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const authContext = useContext(AuthContext);
  const landLordContext = useContext(LandLordContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const getInitialSharedProfileIds = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlIds = urlParams.getAll("sharedprofileid");
    if (urlIds.length > 0) {
      sessionStorage.setItem("awardSelectedTenants", JSON.stringify(urlIds));
      return urlIds;
    }
    const storedIds = sessionStorage.getItem("awardSelectedTenants");
    if (storedIds) {
      const parsedIds = JSON.parse(storedIds);
      sessionStorage.removeItem("awardSelectedTenants");
      return parsedIds;
    }
    return [];
  };
  const initialSharedProfileIdsRef = useRef(getInitialSharedProfileIds());
  const recommendationRunIdRef = useRef(0);
  const { user, setLoading } = authContext;
  const {
    awardProperty,
    updateAwardedPropertySelections,
    multiPropUnAward,
    getShareProfilesForProperty,
    updatePropertyDetails,
    customPolicyDetails,
    deaWorkspace,
    almondWorkspace,
    checkInsuranceDocumentStatus,
    runInsuranceSimulation,
    checkMutuaConsents,
    unlinkApplicationFromProperty,
    editSharedProfile,
    initiateSkorProtect,
    cancelSkorProtect,
    cancelInsuranceBeneficiaryPayment,
    resendInsuranceBeneficiaryPaymentLink,
    getProfileResolutionStatus,
  } = landLordContext;
  const runIdRef = useRef(0);
  const resolutionCacheRef = useRef({});

  const getResolvedMissingDocsResult = async (profileId) => {
    if (!haveValue(profileId)) return null;
    if (!resolutionCacheRef.current[profileId]) {
      resolutionCacheRef.current[profileId] = (async () => {
        try {
          const res = await getProfileResolutionStatus(profileId, "documents");
          return res?.isResolved ? { missingCount: 0, missingDocs: [] } : null;
        } catch (err) {
          console.log("Failed to fetch profile resolution status", err);
          return null;
        }
      })();
    }
    return resolutionCacheRef.current[profileId];
  };

  const [awardPopupModal, setAwardPopupModal] = useState(false);
  const [insuracePopupModal, setInsuracePopupModal] = useState(false);
  const [usedForPurchaseInsurance, setUsedForPurchaseInsurance] =
    useState(null);
  const [awardEditProtectionData, setAwardEditProtectionData] = useState(null);
  const [showAwardInsurancePopup, setShowAwardInsurancePopup] = useState(false);
  const [isInsuranceSimulationSuccess, setIsInsuranceSimulationSuccess] =
    useState(false);
  const [isInsuranceNotInsurable, setIsInsuranceNotInsurable] = useState(false);
  const [insuranceErrorStatus, setInsuranceErrorStatus] = useState(null);
  const [insuranceErrorCode, setInsuranceErrorCode] = useState(null);
  const [insuranceErrorCodes, setInsuranceErrorCodes] = useState([]);
  const [insuranceErrorMessage, setInsuranceErrorMessage] = useState(null);
  const [insuranceValidationMessages, setInsuranceValidationMessages] =
    useState([]);
  const [simulatedInsuranceCost, setSimulatedInsuranceCost] = useState(null);
  const [
    simulatedInsuranceCoverageMonths,
    setSimulatedInsuranceCoverageMonths,
  ] = useState(null);
  const [simulatedPricingPreview, setSimulatedPricingPreview] = useState(null);
  const [preFilledInsuranceDocument, setPreFilledInsuranceDocument] =
    useState(null);
  const [propertyShareProfiles, setPropertyShareProfiles] = useState([]);
  const [profileReminderDates, setProfileReminderDates] = useState({});

  useEffect(() => {
    const tenantIds = [
      ...(propertyShareProfiles ?? []),
      ...(tanentData ?? []),
    ].flatMap((profile) => {
      const tenant = profile?.tenantid || profile?.tenant_id || profile?.tenant;
      const directTenantId = tenant?.is_outdated ? tenant?._id : null;
      const participantIds = (
        profile?.application_id?.participants ||
        profile?.application?.participants ||
        []
      )
        .filter((participant) => participant?.tenant_info?.is_outdated)
        .map((participant) => participant?.tenant_info?._id);

      return [directTenantId, ...participantIds].filter(Boolean);
    });
    const uniqueTenantIds = [...new Set(tenantIds)];

    if (!uniqueTenantIds.length) {
      setProfileReminderDates({});
      return;
    }

    let cancelled = false;
    Promise.all(
      uniqueTenantIds.map(async (tenantId) => {
        try {
          const response = await getProfileReminders(tenantId);
          return [tenantId, response?.data?.[0]?.sent_at];
        } catch {
          return [tenantId, null];
        }
      })
    ).then((reminders) => {
      if (!cancelled) {
        setProfileReminderDates(
          Object.fromEntries(reminders.filter(([, sentAt]) => sentAt))
        );
      }
    });

    return () => {
      cancelled = true;
    };
  }, [propertyShareProfiles, tanentData]);

  const renderOutdatedStatus = (tenantId) => {
    const reminderSentAt = profileReminderDates[tenantId];
    return (
      <div className="outdatedProfileStatus">
        <span
          className={reminderSentAt ? "updateRequestedBadge" : "outdatedBadge"}
          title={
            reminderSentAt
              ? `${_t("reminderSent", "Reminder sent")} ${moment(reminderSentAt)
                  .locale(currentLang?.startsWith("es") ? "es" : "en-gb")
                  .fromNow()}`
              : undefined
          }
        >
          {reminderSentAt
            ? _t("profileUpdateRequested", "Update requested")
            : _t("outdated")}
        </span>
      </div>
    );
  };

  const {
    selectionModel,
    selectedTenant,
    setSelectionModel,
    toggleDirectTenant,
    toggleParticipant,
    toggleAllParticipantsInApp,
    toggleAllEntries,
    toggleGuarantor,
    allTenantIds,
  } = useSelectionModel({
    propertyShareProfiles,
    resetStateCallback: () => {
      setGiveInsurance(false);
      // Keep risk assessment modal open – it will regenerate via effect below
    },
  });

  const [totalCombinedIncome, setToalCombinedIncome] = useState(0);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showUnAwardSuccessPopup, setShowUnAwardSuccessPopup] = useState(false);
  const [showVacatePropertyPopup, setShowVacatePropertyPopup] = useState(false);
  const [showSaveAwardChangesPopup, setShowSaveAwardChangesPopup] =
    useState(false);
  const [isVacatingProperty, setIsVacatingProperty] = useState(false);
  const [successTenant, setSuccessTenant] = useState([]);
  const [propertyBlockedSelectedTenants, setPropertyBlockedSelectedTenants] =
    useState([]);
  const [propertyAwardedSelectedTenant, setPropertyAwardedSelectedTenant] =
    useState([]);
  const blockedSelectionsForRequests =
    blockingSelections ??
    getSelectionsFromProfiles(propertyBlockedSelectedTenants);
  const purchaseInsuranceSelectedTenants = awardEditProtectionData
    ? awardEditProtectionData.selectedTenants
    : isPropertyAwarded
      ? property?.selections?.length > 0
        ? getSelectedProfilesFromSelections(
            property.selections,
            propertyShareProfiles
          )
        : propertyAwardedSelectedTenant
      : isPropertyBlocked
        ? getSelectedProfilesFromSelections(
            blockedSelectionsForRequests,
            propertyShareProfiles
          )
        : selectedTenant;
  const [linkingTenantIds, setLinkingTenantIds] = useState([]);
  const [unlinkingTenantIds, setUnlinkingTenantIds] = useState([]);
  const [isBulkUnlinking, setIsBulkUnlinking] = useState(false);
  const [servingPromptModal, setServingPromptModal] = useState(false);
  const [servingPromptModalURL, setServingPromptModalURL] = useState("");
  const [currentProfile, setCurrentProfile] = useState(null);
  const [rent, setRent] = useState(property?.report_rent ?? 0);
  const [propertyRentError, setPropertyRentError] = useState(false);
  const [tenantResults, setTenantResults] = useState({});
  const [guarantorResults, setGuarantorResults] = useState({});
  const [deaResult, setDeaResult] = useState([]);
  const [allDeaResult, setAllDeaResult] = useState({});
  const [statusStyle, setStatusStyle] = useState(STATUS_STYLES.grey);
  const [giveInsurance, setGiveInsurance] = useState(false);
  const [resultLoader, setResultLoader] = useState(false);
  const [finalRenderedResult, setFinalRenderedResult] = useState(null);
  const [finalScoreModelData, setFinalScoreModelData] = useState(null);
  const [finalEffortRate, setFinalEffortRate] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const [showRiskAssessmentReportModal, setShowRiskAssessmentReportModal] =
    useState(false);
  const wasRiskAssessmentReportModalOpenRef = useRef(false);
  const [riskReportData, setRiskReportData] = useState();
  const [lastShowAddGuarantor, setLastShowAddGuarantor] = useState(false);
  const [lastVerdict, setLastVerdict] = useState(null);
  const [lastRecommendationFlags, setLastRecommendationFlags] = useState({});

  const handleCloseRiskAssessmentReportModal = () => {
    setShowRiskAssessmentReportModal(false);
    setRiskReportData(null);
    setPendingSnapshotReportOpen(false);
    if (isViewingSnapshotReport) {
      setIsViewingSnapshotReport(false);
      setHistorySnapshotEventId(null);
      if (isPropertyAwarded) {
        loadSnapshotProfiles();
      } else {
        fetchShareProfileData(false, false);
      }
    }
  };
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const [simulationLoading, setSimulationLoading] = useState(false);
  const simulationCacheRef = useRef({});
  const lastSimulationKeyRef = useRef(null);
  const actualInsuranceRetryRef = useRef(null);
  const [actualInsuranceRetryLoading, setActualInsuranceRetryLoading] =
    useState(false);
  const [insuranceSimulationErrorModal, setInsuranceSimulationErrorModal] =
    useState(false);
  const [insuranceSimulationErrors, setInsuranceSimulationErrors] = useState(
    []
  );
  const [simulationDidNotRun, setSimulationDidNotRun] = useState(false);
  const [simulationPropertyErrors, setSimulationPropertyErrors] = useState([]);
  const [simulationConsentErrors, setSimulationConsentErrors] = useState([]);
  const [insuranceSimulationProcessing, setInsuranceSimulationProcessing] =
    useState(false);
  const isDeaRulesActivated =
    user?.current_workspace?.dea_rules_activated === true && deaWorkspace;
  //   const isRecommendationRulesActivated =
  //     !isDeaRulesActivated && !almondWorkspace;
  const isRecommendationRulesActivated =
    user?.current_workspace?.recommendation_rules_activated === true;
  const [showInsuranceReviewModal, setShowInsuranceReviewModal] =
    useState(false);
  const [openApplicationIds, setOpenApplicationIds] = useState({});
  const [isDownloadDocList, setIsDownloadDocList] = useState(false);
  const [lastToastTime, setLastToastTime] = useState(null);
  const TOAST_BUFFER_MS = 2000;
  const [skorProtectCountdown, setSkorProtectCountdown] = useState("");
  const [skorProtectLoading, setSkorProtectLoading] = useState(false);
  const [skorProtectInsuranceLoading, setSkorProtectInsuranceLoading] =
    useState(false);
  const [pendingSkorProtectPropertyId, setPendingSkorProtectPropertyId] =
    useState(null);
  const [insuranceBeneficiaryCountdown, setInsuranceBeneficiaryCountdown] =
    useState("");
  const [insuranceBeneficiaryLoading, setInsuranceBeneficiaryLoading] =
    useState(false);
  const [resendBeneficiaryLinkLoading, setResendBeneficiaryLinkLoading] =
    useState(false);
  const [beneficiaryLinkSent, setBeneficiaryLinkSent] = useState(false);
  // const [pendingSkorProtectPropertyId, setPendingSkorProtectPropertyId] = useState(null);
  const [showSkorProtectActivatedPopup, setShowSkorProtectActivatedPopup] =
    useState(false);
  const [linkedApplicationIds, setLinkedApplicationIds] = useState([]);
  const [snapshotLoadFailed, setSnapshotLoadFailed] = useState(false);
  const [showHistoryView, setShowHistoryView] = useState(false);
  const [pendingSnapshotReportOpen, setPendingSnapshotReportOpen] =
    useState(false);
  const [isViewingSnapshotReport, setIsViewingSnapshotReport] = useState(false);
  const [historySnapshotEventId, setHistorySnapshotEventId] = useState(null);
  const [isEditingAwarded, setIsEditingAwarded] = useState(false);
  const [savingAwardEdits, setSavingAwardEdits] = useState(false);
  const selectionModelBeforeEditRef = useRef(null);
  const awardedSelectionBeforeEditRef = useRef([]);
  const linkedProfilesBeforeEditRef = useRef(null);
  const propertyShareProfilesBeforeEditRef = useRef([]);
  const selectedTenantIdsBeforeEditRef = useRef([]);

  const isAwardedLocked = isPropertyAwarded && !isEditingAwarded;
  const hasActiveNonPaymentInsurance = ["contracted", "confirmed"].includes(
    property?.insurance_data?.status
  );
  const hasActiveSkorProtect = haveValue(property?.skor_protect_data?._id);
  const hasExistingAwardProtection =
    hasActiveNonPaymentInsurance || hasActiveSkorProtect;

  useEffect(() => {
    const initiatedAt = property?.skor_protect_data?.skor_protect_initiated;
    if (
      !initiatedAt ||
      property?.skor_protect_data?.skor_protect_status !== "waiting_for_payment"
    ) {
      setSkorProtectCountdown("");
      return;
    }
    const deadlineMs = new Date(initiatedAt).getTime() + 48 * 60 * 60 * 1000;
    const tick = () => {
      const remaining = deadlineMs - Date.now();
      if (remaining <= 0) {
        setSkorProtectCountdown("00:00:00");
        return;
      }
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      setSkorProtectCountdown(
        `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
      );
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [property?.skor_protect_data]);

  useEffect(() => {
    const initiatedAt =
      property?.insurance_beneficiary_payment_data?.payment_link_initiated_at;
    if (
      !initiatedAt ||
      property?.insurance_beneficiary_payment_data?.payment_link_status !==
        "waiting_for_payment"
    ) {
      setInsuranceBeneficiaryCountdown("");
      return;
    }
    const deadlineMs = new Date(initiatedAt).getTime() + 24 * 60 * 60 * 1000;
    const tick = () => {
      const remaining = deadlineMs - Date.now();
      if (remaining <= 0) {
        setInsuranceBeneficiaryCountdown("00:00:00");
        return;
      }
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      setInsuranceBeneficiaryCountdown(
        `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
      );
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [property?.insurance_beneficiary_payment_data]);

  // useEffect(() => {
  //   if (!haveValue(pendingSkorProtectPropertyId)) return;

  //   const handleStatus = async (data) => {
  //     if (data?.property_id !== pendingSkorProtectPropertyId) return;
  //     setPendingSkorProtectPropertyId(null);
  //     await loadData();
  //     if (data?.status !== "success") {
  //       toast.error(_t("insurancePolicyFailed"));
  //     }
  //   };

  //   socket.on("contract_insurance_status", handleStatus);
  //   return () => socket.off("contract_insurance_status", handleStatus);
  // }, [pendingSkorProtectPropertyId]);

  const handleSkorProtectAward = async (selections = allTenantIds) => {
    setSkorProtectLoading(true);
    try {
      await initiateSkorProtect({
        property_id: property?._id,
        selections,
      });
      await loadData();
    } catch (err) {
      toast.error(_t("errorInitiatingSkorProtect"));
    } finally {
      setSkorProtectLoading(false);
    }
  };

  const handleCancelSkorProtect = async () => {
    setSkorProtectLoading(true);
    try {
      await cancelSkorProtect(property?._id);
      await loadData();
    } catch (err) {
      toast.error(_t("errorCancellingSkorProtect"));
    } finally {
      setSkorProtectLoading(false);
    }
  };

  const handleSkorProtectUpload = async () => {
    setSkorProtectInsuranceLoading(true);
    try {
      setUsedForPurchaseInsurance("skorProtect");
      setInsuracePopupModal(true);
    } catch (err) {
      toast.error(_t("failedToLoadInsuranceData"));
    } finally {
      setSkorProtectInsuranceLoading(false);
    }
  };

  const handleSkorProtectInsuranceSuccess = async () => {
    // setPendingSkorProtectPropertyId(property?._id);
    await loadData();
    setInsuracePopupModal(false);
    setUsedForPurchaseInsurance(null);
    setShowAwardInsurancePopup(false);
    setShowSkorProtectActivatedPopup(true);
  };

  const handleonInsuranceSendPaymentLinkSuccess = async () => {
    await loadData();
    setInsuracePopupModal(false);
    setAwardEditProtectionData(null);
    setShowAwardInsurancePopup(false);
  };

  const handleCancelInsuranceBeneficiaryPayment = async () => {
    setInsuranceBeneficiaryLoading(true);
    try {
      await cancelInsuranceBeneficiaryPayment(property?._id);
      await loadData();
    } catch (err) {
      toast.error(_t("errorCancellingInsurancePayment"));
    } finally {
      setInsuranceBeneficiaryLoading(false);
    }
  };

  const handleResendInsuranceBeneficiaryPaymentLink = async () => {
    setResendBeneficiaryLinkLoading(true);
    try {
      await resendInsuranceBeneficiaryPaymentLink(property?._id);
      toast.success(_t("paymentLinkResentSuccessfully"));
      setBeneficiaryLinkSent(true);
    } catch (err) {
      toast.error(_t("errorResendingPaymentLink"));
    } finally {
      setResendBeneficiaryLinkLoading(false);
    }
  };

  useEffect(() => {
    const currentKey = getSimulationCacheKey(allTenantIds, rent);
    const cached = simulationCacheRef.current[currentKey];
    if (cached && currentKey === lastSimulationKeyRef.current) {
      setIsInsuranceSimulationSuccess(cached.isInsurable);
      setIsInsuranceNotInsurable(cached.isNotInsurable === true);
      setInsuranceErrorStatus(cached.errorStatus ?? null);
      setInsuranceErrorCode(cached.errorCode ?? null);
      setInsuranceErrorCodes(cached.errorCodes ?? []);
      setInsuranceErrorMessage(cached.errorMessage ?? null);
      setInsuranceValidationMessages(cached.validationMessages ?? []);
      setSimulatedInsuranceCost(cached.insuranceCost ?? null);
      setSimulatedInsuranceCoverageMonths(cached.coverageMonths ?? null);
      setSimulatedPricingPreview(cached.pricingPreview ?? null);
      setPreFilledInsuranceDocument(cached.preFilledDocument ?? null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
    } else {
      setIsInsuranceSimulationSuccess(false);
      setIsInsuranceNotInsurable(false);
      setInsuranceErrorStatus(null);
      setInsuranceErrorCode(null);
      setInsuranceErrorCodes([]);
      setInsuranceErrorMessage(null);
      setInsuranceValidationMessages([]);
      setSimulatedInsuranceCost(null);
      setSimulatedInsuranceCoverageMonths(null);
      setSimulatedPricingPreview(null);
      setPreFilledInsuranceDocument(null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
    }
  }, [allTenantIds, rent]);

  const isInsuranceEnabledWorkspace = true;
  // ["UY5I2V"].includes(
  //   user?.current_workspace?.uuid
  // );

  useEffect(() => {
    const initialIds = initialSharedProfileIdsRef.current;

    if (initialIds?.length > 0 && propertyShareProfiles?.length > 0) {
      const idSet = new Set(initialIds);
      const filteredEntries = propertyShareProfiles.filter((item) =>
        idSet.has(item._id)
      );

      initialSharedProfileIdsRef.current = [];

      setSelectionModel(
        filteredEntries.map((entry) => {
          const appDetails = getApplicationDetails(entry);
          if (appDetails?.hasApplication) {
            return {
              sharedProfileId: entry._id,
              type: "application",
              applicationId: entry?.application_id?._id,
              participants: (entry?.application_id?.participants || []).map(
                (p) => ({
                  tenantId: p?.tenant_info?._id || p?.id,
                  guarantorIds:
                    p?.tenant_info?.gurantor_id?.map((g) => g._id) || [],
                })
              ),
            };
          }
          return {
            sharedProfileId: entry._id,
            type: "tenant",
            tenantId: entry?.tenantid?._id || entry?.tenant_id?._id,
            guarantorIds: entry?.tenantid?.gurantor_id?.map((g) => g._id) || [],
          };
        })
      );
    }
  }, [propertyShareProfiles]);

  useEffect(() => {
    if (isViewingSnapshotReport || isEditingAwarded) return;

    const persistedSelections = isPropertyAwarded
      ? property?.selections
      : isPropertyBlocked
        ? blockingSelections
        : null;

    if (!persistedSelections?.length || !propertyShareProfiles?.length) {
      return;
    }

    const reconstructedModel = (property.selections || []).flatMap((sel) => {
      if (sel.tenant) {
        const sharedProfile = propertyShareProfiles.find(
          (sp) => sp?.tenantid?._id === sel.tenant
        );
        if (!sharedProfile) return [];
        return [
          {
            sharedProfileId: sharedProfile._id,
            type: "tenant",
            tenantId: sel.tenant,
            guarantorIds: sel.guarantors || [],
          },
        ];
      }
      if (sel.application) {
        const sharedProfile = propertyShareProfiles.find(
          (sp) => sp?.application_id?._id === sel.application
        );
        if (sharedProfile) {
          return [
            {
              sharedProfileId: sharedProfile._id,
              type: "application",
              applicationId: sel.application,
              participants: (sel.participants || []).map((p) => ({
                tenantId: p.tenant,
                guarantorIds: p.guarantors || [],
              })),
            },
          ];
        }
        return (sel.participants || [])
          .map((p) => {
            const tenantProfile = propertyShareProfiles.find(
              (sp) => sp?.tenantid?._id === p.tenant
            );
            if (!tenantProfile) return null;
            return {
              sharedProfileId: tenantProfile._id,
              type: "tenant",
              tenantId: p.tenant,
              guarantorIds: p.guarantors || [],
            };
          })
          .filter(Boolean);
      }
      return [];
    });

    setSelectionModel(reconstructedModel);
  }, [
    isPropertyAwarded,
    isEditingAwarded,
    property?.selections,
    propertyShareProfiles,
  ]);

  useEffect(() => {
    // Awarded properties are read-only in the overview. Their saved snapshot is
    // enough to render the sidebar, so do not recalculate recommendations just
    // because the persisted tenant selection was restored. A report request is
    // the only read-only flow that should calculate on demand.
    if (isAwardedLocked && !pendingSnapshotReportOpen) {
      recommendationRunIdRef.current += 1;
      setFinalRenderedResult(null);
      return;
    }

    if (!isRecommendationRulesActivated) {
      if (DEBUG_CALCULATION) {
        console.log(
          "[renderFinalResult useEffect] SKIP — recommendation rules NOT activated"
        );
      }
      setFinalRenderedResult(null);
      return;
    }

    if (!selectedTenant || selectedTenant.length === 0) {
      if (DEBUG_CALCULATION) {
        console.log("[renderFinalResult useEffect] SKIP — no selectedTenant");
      }
      setFinalRenderedResult(null);
      return;
    }

    if (resultLoader) {
      if (DEBUG_CALCULATION) {
        console.log(
          "[renderFinalResult useEffect] SKIP — resultLoader is true"
        );
      }
      return;
    }
    if (!tenantResults || Object.keys(tenantResults).length === 0) {
      if (DEBUG_CALCULATION) {
        console.log("[renderFinalResult useEffect] SKIP — no tenantResults");
      }
      return;
    }

    if (DEBUG_CALCULATION) {
      console.log(
        "[renderFinalResult useEffect] RUNNING — calling renderFinalResult, tenantResults keys:",
        Object.keys(tenantResults).length
      );
    }

    recommendationRunIdRef.current += 1;
    const currentRunId = recommendationRunIdRef.current;

    const timer = setTimeout(() => {
      try {
        // ❗ Ignore stale runs
        if (recommendationRunIdRef.current !== currentRunId) return;

        const res = renderFinalResult();

        if (recommendationRunIdRef.current !== currentRunId) return;

        setFinalRenderedResult(res);
      } catch (e) {
        console.log(e);
      } finally {
        // ❗ Prevent stale loader reset
        if (recommendationRunIdRef.current === currentRunId) {
        }
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [
    tenantResults,
    guarantorResults,
    selectedTenant,
    giveInsurance,
    resultLoader,
    enabled,
    isRecommendationRulesActivated,
    isAwardedLocked,
    pendingSnapshotReportOpen,
  ]);

  const fetchShareProfileData = async (showLoading = false, setList = true) => {
    try {
      if (showLoading) {
        setsaveTanentLoading(true);
      }

      const data = await getShareProfilesForProperty(property?._id);
      const liveProfiles = data?.sharedProfiles ?? [];

      linkedProfilesBeforeEditRef.current = liveProfiles;
      setPropertyShareProfiles(liveProfiles);
      if (data?.sharedProfiles) {
        const dataArray = Array.isArray(data.sharedProfiles)
          ? data.sharedProfiles
          : [];

        const updatedData = dataArray.flatMap((item) => {
          const application = item?.application_id;
          const tenant = item?.tenant_id || item?.tenantid;
          if (application?.participants?.length > 0) {
            return application.participants.map((participant) => {
              const tenantInfo = participant?.tenant_info;
              return {
                label: getUserDisplayName(tenantInfo),
                value: tenantInfo?._id,
              };
            });
          }
          return {
            label: tenant?.fname + " " + (tenant?.lname ?? ""),
            value: tenant?._id,
          };
        });

        setPreselectedTanents(updatedData);

        if (setList) {
          setSelectedTanents(updatedData.map((item) => item.value));
        }
      }
    } catch (error) {
      console.log("Failed to fetch data", error);
    } finally {
      if (showLoading) {
        setsaveTanentLoading(false);
      }
    }
  };

  const loadSnapshotProfiles = async () => {
    setSnapshotLoadFailed(false);
    setsaveTanentLoading(true);
    try {
      const res = await axiosInstance.post(
        `${process.env.REACT_APP_SERVER_URL}/users/award-snapshot`,
        { propertyId: property?._id }
      );
      const snapshotData = res.data?.data;
      const profiles = transformAwardSnapshot(snapshotData);

      // Build entity ID → shared profile ID mapping from live data to fix
      // any snapshot profiles that lack a shared_profiles entry in the snapshot
      const entityToSharedProfileId = {};
      linkedProfilesBeforeEditRef.current = null;
      try {
        const liveData = await getShareProfilesForProperty(property?._id);
        const liveSharedProfiles = liveData?.sharedProfiles ?? [];
        linkedProfilesBeforeEditRef.current = liveSharedProfiles;
        liveSharedProfiles.forEach((sp) => {
          if (sp.application_id?._id) {
            entityToSharedProfileId[sp.application_id._id] = sp._id;
          }
          if (sp.tenantid?._id) {
            entityToSharedProfileId[sp.tenantid._id] = sp._id;
          }
        });
        profiles.forEach((profile) => {
          const entityId = profile.tenantid?._id || profile.application_id?._id;
          if (entityId && entityToSharedProfileId[entityId]) {
            profile._id = entityToSharedProfileId[entityId];
          }
        });
      } catch (e) {
        console.log("Failed to fetch live share profiles for ID mapping", e);
      }

      const snapshotCreatedAt = property?.award_snapshot_info?.created_at;

      profiles.forEach((profile) => {
        const tenantData = profile.tenantid;
        if (tenantData) {
          tenantData._snapshotMissingDocs = getMissingDocsFromSnapshot(
            tenantData,
            deaWorkspace,
            snapshotCreatedAt
          );
          if (tenantData.gurantor_id) {
            tenantData.gurantor_id.forEach((g) => {
              if (g && typeof g === "object") {
                g._snapshotMissingDocs = getMissingDocsFromSnapshot(
                  g,
                  deaWorkspace,
                  snapshotCreatedAt
                );
              }
            });
          }
        }
        if (profile.application_id?.participants) {
          profile.application_id.participants.forEach((p) => {
            if (p.is_deleted || p.deleted) return;
            const pt = p.tenant_info;
            if (pt) {
              pt._snapshotMissingDocs = getMissingDocsFromSnapshot(
                pt,
                deaWorkspace,
                snapshotCreatedAt
              );
              if (pt.gurantor_id) {
                pt.gurantor_id.forEach((g) => {
                  if (g && typeof g === "object") {
                    g._snapshotMissingDocs = getMissingDocsFromSnapshot(
                      g,
                      deaWorkspace,
                      snapshotCreatedAt
                    );
                  }
                });
              }
            }
          });
        }
      });

      setPropertyShareProfiles(profiles);
    } catch (error) {
      setSnapshotLoadFailed(true);
      await fetchShareProfileData(false, false);
    } finally {
      setsaveTanentLoading(false);
    }
  };

  const processSnapshotProfilesFromHistory = async (profiles) => {
    const entityToSharedProfileId = {};
    try {
      const liveData = await getShareProfilesForProperty(property?._id);
      const liveSharedProfiles = liveData?.sharedProfiles ?? [];
      liveSharedProfiles.forEach((sp) => {
        if (sp.application_id?._id) {
          entityToSharedProfileId[sp.application_id._id] = sp._id;
        }
        if (sp.tenantid?._id) {
          entityToSharedProfileId[sp.tenantid._id] = sp._id;
        }
      });
      profiles.forEach((profile) => {
        const entityId = profile.tenantid?._id || profile.application_id?._id;
        if (entityId && entityToSharedProfileId[entityId]) {
          profile._id = entityToSharedProfileId[entityId];
        }
      });
    } catch (e) {
      console.log("Failed to fetch live share profiles for ID mapping", e);
    }

    const snapshotCreatedAt = property?.award_snapshot_info?.created_at;

    profiles.forEach((profile) => {
      const tenantData = profile.tenantid;
      if (tenantData) {
        tenantData._snapshotMissingDocs = getMissingDocsFromSnapshot(
          tenantData,
          deaWorkspace,
          snapshotCreatedAt
        );
        if (tenantData.gurantor_id) {
          tenantData.gurantor_id.forEach((g) => {
            if (g && typeof g === "object") {
              g._snapshotMissingDocs = getMissingDocsFromSnapshot(
                g,
                deaWorkspace,
                snapshotCreatedAt
              );
            }
          });
        }
      }
      if (profile.application_id?.participants) {
        profile.application_id.participants.forEach((p) => {
          if (p.is_deleted || p.deleted) return;
          if (!p.consent_status) p.consent_status = "accepted";
          const pt = p.tenant_info;
          if (pt) {
            pt._snapshotMissingDocs = getMissingDocsFromSnapshot(
              pt,
              deaWorkspace,
              snapshotCreatedAt
            );
            if (pt.gurantor_id) {
              pt.gurantor_id.forEach((g) => {
                if (g && typeof g === "object") {
                  g._snapshotMissingDocs = getMissingDocsFromSnapshot(
                    g,
                    deaWorkspace,
                    snapshotCreatedAt
                  );
                }
              });
            }
          }
        });
      }
    });

    return profiles;
  };

  useEffect(() => {
    if (DEBUG_CALCULATION) {
      console.log(
        "[policyCalc useEffect] TRIGGERED — isDea:",
        isDeaRulesActivated,
        "isRec:",
        isRecommendationRulesActivated,
        "selectedTenant:",
        selectedTenant?.length,
        "hasCustomPolicy:",
        haveValue(customPolicyDetails?.scoringConfig) &&
          haveValue(customPolicyDetails?.overlayConfig) &&
          haveValue(customPolicyDetails?.policyConfig)
      );
    }
    // Restoring an awarded property's persisted selections must not trigger the
    // policy/recommendation engine while the sidebar is in read-only mode.
    // Editing and an explicit report request still calculate as before.
    if (isAwardedLocked && !pendingSnapshotReportOpen) {
      runIdRef.current += 1;
      setResultLoader(false);
      return;
    }

    setStatusStyle(STATUS_STYLES.grey);
    if (!isDeaRulesActivated && !isRecommendationRulesActivated) {
      if (DEBUG_CALCULATION) {
        console.log(
          "[policyCalc useEffect] NO rules activated → calling getStatusStyle fallback"
        );
      }
      setTenantResults({});
      setGuarantorResults({});
      setDeaResult([]);
      setFinalRenderedResult(null);
      getStatusStyle();
      return;
    }

    if (
      selectedTenant?.length > 0 &&
      haveValue(customPolicyDetails?.scoringConfig) &&
      haveValue(customPolicyDetails?.overlayConfig) &&
      haveValue(customPolicyDetails?.policyConfig)
    ) {
      if (DEBUG_CALCULATION) {
        console.log(
          "[policyCalc useEffect] GOING IN IF → calling policyCalculate, isDeaRulesActivated:",
          isDeaRulesActivated
        );
      }
      console.log("GOING IN IF");
      runIdRef.current += 1;
      const currentRunId = runIdRef.current;

      // Optional: Clear previous results

      //Remove later

      if (isDeaRulesActivated) {
        setTenantResults({});
        setGuarantorResults({});

        setDeaResult([]);

        policyCalculate(currentRunId);
      } else {
        setTenantResults({});
        setGuarantorResults({});
        policyCalculate(currentRunId);
        // getStatusStyle();
      }
    }
  }, [
    selectedTenant,
    customPolicyDetails,
    rent,
    giveInsurance,
    user,
    isDeaRulesActivated,
    isRecommendationRulesActivated,
    isAwardedLocked,
    pendingSnapshotReportOpen,
  ]);

  useEffect(() => {
    if (!pendingSnapshotReportOpen) return;
    if (resultLoader) return;

    if (!isDeaRulesActivated && !isRecommendationRulesActivated) {
      if (!selectedTenant || selectedTenant.length === 0) return;
      setPendingSnapshotReportOpen(false);
      generateReport();
      return;
    }

    if (!tenantResults || Object.keys(tenantResults).length === 0) return;

    const { result } = computeFinalResult({
      tenantResults,
      selectedTenant,
      customPolicyDetails,
      giveInsurance,
      finalEffortRate,
      enabled,
      deaWorkspace,
      user,
      lastVerdict,
      lastRecommendationFlags,
      STATUS_STYLES,
      translate: _t,
      isReport: true,
      guarantorResults,
    });
    setRiskReportData(result);
    setShowRiskAssessmentReportModal(true);
    setPendingSnapshotReportOpen(false);
  }, [
    pendingSnapshotReportOpen,
    resultLoader,
    tenantResults,
    selectedTenant,
    isDeaRulesActivated,
    isRecommendationRulesActivated,
  ]);

  // Keep risk assessment modal open and regenerate report when selection changes
  useEffect(() => {
    const didJustOpen =
      showRiskAssessmentReportModal &&
      !wasRiskAssessmentReportModalOpenRef.current;
    wasRiskAssessmentReportModalOpenRef.current = showRiskAssessmentReportModal;

    if (!showRiskAssessmentReportModal || didJustOpen) return;
    if (isAwardedLocked && !pendingSnapshotReportOpen) return;
    if (!isRecommendationRulesActivated) return;
    if (!selectedTenant || selectedTenant.length === 0) {
      setShowRiskAssessmentReportModal(false);
      setRiskReportData(null);
      return;
    }
    if (resultLoader) return;
    if (!tenantResults || Object.keys(tenantResults).length === 0) return;

    const newReport = renderFinalResult(true);
    if (newReport) {
      setRiskReportData(newReport);
    }
  }, [
    showRiskAssessmentReportModal,
    tenantResults,
    guarantorResults,
    selectedTenant,
    giveInsurance,
    enabled,
    finalEffortRate,
    resultLoader,
    isRecommendationRulesActivated,
    isAwardedLocked,
    pendingSnapshotReportOpen,
  ]);

  useEffect(() => {
    if (isPropertyAwarded) {
      loadSnapshotProfiles();
    } else if (!haveValue(searchText)) {
      fetchShareProfileData(true, true);
    }
  }, [isPropertyAwarded]);

  useEffect(() => {
    if (!awardPopupModal && isViewingSnapshotReport) {
      setIsViewingSnapshotReport(false);
      setHistorySnapshotEventId(null);
      if (isPropertyAwarded) {
        loadSnapshotProfiles();
      } else {
        fetchShareProfileData(false, false);
      }
    }
  }, [awardPopupModal, isViewingSnapshotReport]);

  useEffect(() => {
    const filteredData = getName();
    if (haveValue(searchText) && filteredData?.length > 0) {
      const initialOpenIds = {};
      filteredData.forEach((item) => {
        const applicationDetails = getApplicationDetails(item);
        if (applicationDetails?.hasApplication) {
          initialOpenIds[item?._id] = true;
        }
      });
      setOpenApplicationIds(initialOpenIds);
    }
  }, [searchText, propertyShareProfiles]);

  useEffect(() => {
    const persistedSelections = isPropertyAwarded
      ? property?.selections
      : isPropertyBlocked
        ? blockingSelections
        : null;
    if (!persistedSelections?.length) return;

    const appSelections = persistedSelections.filter((s) => s.application);
    if (appSelections.length === 0) return;

    setOpenApplicationIds((prev) => {
      const updated = { ...prev };
      appSelections.forEach((sel) => {
        const sharedProfile = propertyShareProfiles.find(
          (sp) => String(sp?.application_id?._id) === String(sel.application)
        );
        if (sharedProfile?._id) {
          updated[sharedProfile._id] = true;
        }
      });
      return updated;
    });
  }, [
    isPropertyAwarded,
    isPropertyBlocked,
    property?.selections,
    blockingSelections,
    propertyShareProfiles,
  ]);

  useEffect(() => {
    setRent(property?.report_rent);
  }, [property]);

  useEffect(() => {
    if (!rent) {
      setPropertyRentError(true);
    } else {
      setPropertyRentError(false);
    }
  }, [rent]);

  useEffect(() => {
    if (!rent) {
      setPropertyRentError(true);
    } else {
      setPropertyRentError(false);
    }
  }, [rent]);

  useEffect(() => {
    if (!isDeaRulesActivated) {
      return;
    }

    if (deaResult?.length > 0) {
      setResultLoader(true);

      // ✅ Flatten dataset
      const allProfiles = deaResult.flatMap((tenant) => [
        tenant,
        ...(tenant?.guarantors || []),
      ]);

      const highPointProfile = allProfiles.reduce((max, current) => {
        if (!max) return current;

        return current?.DEA_SCORE?.finalScore > max?.DEA_SCORE?.finalScore
          ? current
          : max;
      }, null);

      const profilesHaveMissingDocs = allProfiles.some(
        (item) => item?.vals?.DOCUMENTATION > 0 && !item?.isResolved
      );

      const hasHardFailEntries = allProfiles.some(
        (item) => item?.errorEntries?.length > 0
      );

      const guarantorIdSet = new Set(
        deaResult.flatMap((tenant) =>
          (tenant?.guarantors || []).map((g) => g?._id).filter(Boolean)
        )
      );

      const haveMissingDniOrNie = allProfiles.some((item) => {
        if (guarantorIdSet.has(item?._id)) return false;
        const hasKycHardFail = (item?.errorEntries || []).some(
          ([, value]) => value?.label === "KYCHardFail"
        );
        if (guarantorIdSet.has(item?._id)) return !hasKycHardFail;
        return tenantHasMissingDniNie(item) && !hasKycHardFail;
      });

      // 🎯 SAME DECISION LOGIC — aligned with ReportOverview.jsx:305-325
      // ReportOverview uses tenantHasMissingDniNie per profile and excludes
      // KYCHardFail duplicates; keep same here and block green only on
      // genuine missing DNI/NIE (not already hard-failed).
      if (hasHardFailEntries) {
        setStatusStyle(STATUS_STYLES.red);
      } else if (
        highPointProfile?.DEA_SCORE?.finalScore > 4 &&
        !profilesHaveMissingDocs &&
        !haveMissingDniOrNie
      ) {
        setStatusStyle(STATUS_STYLES.green);
      } else {
        setStatusStyle(STATUS_STYLES.yellow);
      }

      setResultLoader(false);
    }
  }, [deaResult, isDeaRulesActivated]);

  async function policyCalculate(currentRunId) {
    setResultLoader(true);
    try {
      let tenantIncomeSum = 0;
      let guarantorIncomeSum = 0;
      const tempGuarantorResults = {};

      //   #NOTE: if the (selectedTenant) which is a sharedProfile is an application tyep
      // then we check if it is an application then we use each participant from the application

      let selectedSharedProfiles = selectedTenant
        .flatMap((s) => {
          const application = s?.application_id;
          if (application?.participants?.length > 0) {
            return application?.participants.map((participant) => {
              return {
                ...s,
                tenantid: participant?.tenant_info,
              };
            });
          } else {
            return s;
          }
        })
        .filter((sp) => sp.tenantid);

      if (selectionModel.length > 0) {
        const selectedIds = getSelectedTenantIds(selectionModel);
        selectedSharedProfiles = selectedSharedProfiles.filter((p) =>
          selectedIds.includes(p?.tenantid?._id)
        );
      }

      // ---- SAME INCOME LOGIC ----
      for (let entry of selectedSharedProfiles) {
        const incomeSelection = resolveIncomeSelection(
          entry?.income_selection,
          entry?.tenantid?._id
        );
        const tenantInfo = entry?.tenantid;

        const tenantIncome = getCustomIncomeDetails(
          tenantInfo,
          user,
          _t,
          incomeSelection?.tenant_source,
          undefined,
          undefined,
          deaWorkspace,
          entry?.custom_income_sources
        );

        const tenantIncomeAmount = tenantIncome?.amount ?? 0;
        tenantInfo._localIncome = tenantIncomeAmount;
        tenantIncomeSum += tenantIncomeAmount;

        let guarantors = tenantInfo?.gurantor_id || [];
        if (selectionModel.length > 0) {
          const selGuarantorIds = getGuarantorIdsForEntry(
            selectionModel,
            entry?._id,
            entry?.tenantid?._id
          );
          guarantors = guarantors.filter((g) =>
            selGuarantorIds.includes(g?._id)
          );
        }
        const guarantorIncomeSelection =
          incomeSelection?.[entry?.tenantid?._id]?.guarantor_sources ??
          incomeSelection?.guarantor_sources;

        const guarantorResults = await Promise.all(
          guarantors.map(async (g) => {
            const guarantorIncomeObj = getCustomIncomeDetails(
              g,
              user,
              _t,
              guarantorIncomeSelection?.[g?._id],
              undefined,
              undefined,
              deaWorkspace,
              entry?.custom_income_sources
            );

            const guarantorIncome = guarantorIncomeObj?.amount ?? 0; // ✅ FIXED

            // 🔹 Step A: guarantor-only effort rate
            const guarantorOnlyEffortRate =
              guarantorIncome > 0
                ? (getRentPercentage(guarantorIncome, rent)?.roundValue ?? 0)
                : 0;

            // 🔹 Step B: scoring
            const gMissingDocsResult = await getResolvedMissingDocsResult(
              g?._id
            );
            const gTemp = await getFieldForPolicies(
              g,
              user,
              guarantorOnlyEffortRate,
              giveInsurance,
              deaWorkspace,
              gMissingDocsResult
            );

            const gScoreResult = await calculateFinalScore(
              customPolicyDetails.scoringConfig,
              customPolicyDetails.overlayConfig,
              customPolicyDetails.policyConfig,
              gTemp
            );

            const guarantorScore = gScoreResult?.finalScore ?? 0;
            const gErrors = Object.entries(gTemp).filter(
              ([_, value]) => value?.isHardFail === true
            );
            const label = getUserDisplayName(g);

            gTemp.label = label;
            g._localIncome = guarantorIncome;
            gScoreResult.errorEntries = gErrors;
            gScoreResult.isHardFail = gErrors?.length > 0;

            tempGuarantorResults[g?._id] = {
              ...gScoreResult,
              vals: gTemp,
              _id: g?._id,
              tenantData: {
                documentNumber: getIdentityDetails(g, g?.onfido_user_kyc)
                  ?.value,
                dob: tenantInfo?.dob,
                income: guarantorIncome,
                is_outdated: !!g?.is_outdated,
                lastUpdatedAt:
                  g?.profile_renewed_at ||
                  g?.profile_completed_at ||
                  g?.created_at ||
                  null,
              },
              label,
              isGuarantor: true,
              role: "guarantor",
            };

            // 🔹 Step C: weight
            let weight = 1;

            if (guarantorScore < 65) {
              weight = 0.6;
            } else if (guarantorScore <= 80) {
              weight = 0.75;
            }

            // 🔹 Custom hook
            const shouldUseGuarantorIncome = true;

            return shouldUseGuarantorIncome ? guarantorIncome * weight : 0;
          })
        );

        // 🔹 Final sum
        guarantorIncomeSum += guarantorResults.reduce(
          (sum, val) => sum + val,
          0
        );
      }

      const totalIncome = tenantIncomeSum + guarantorIncomeSum;

      if (DEBUG_CALCULATION) {
        console.log(
          "[policyCalculate] tenantIncomeSum:",
          tenantIncomeSum,
          "guarantorIncomeSum:",
          guarantorIncomeSum,
          "totalIncome:",
          totalIncome,
          "rent:",
          rent
        );
      }

      // #NOTE: showing both tenants and guarantor's total combined incomes
      setToalCombinedIncome(totalIncome);

      const finalEffortRate =
        getRentPercentage(totalIncome, rent)?.roundValue ?? "0";

      if (DEBUG_CALCULATION) {
        console.log(
          "[policyCalculate] finalEffortRate:",
          finalEffortRate,
          "type:",
          typeof finalEffortRate
        );
      }

      const resultDea = [];
      const tempTenantResults = {};

      //   #NOTE: if the (selectedTenant) which is a sharedProfile is an application tyep
      // then we check if it is an application then we use each participant from the application

      let profiles = selectedTenant
        .flatMap((s) => {
          const application = s?.application_id;
          if (application?.participants?.length > 0) {
            return application?.participants.map((participant) => {
              return {
                ...s,
                tenantid: participant?.tenant_info,
              };
            });
          } else {
            return s;
          }
        })
        .filter((sp) => sp.tenantid);

      if (selectionModel.length > 0) {
        const selectedIds = getSelectedTenantIds(selectionModel);
        profiles = profiles.filter((p) =>
          selectedIds.includes(p?.tenantid?._id)
        );
      }

      for (let entry of profiles) {
        console.log("entry", entry);
        if (runIdRef.current !== currentRunId) return;

        try {
          // ===== TENANT =====
          const tenantMissingDocsResult = await getResolvedMissingDocsResult(
            entry?.tenantid?._id
          );
          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace,
            tenantMissingDocsResult
          );

          if (runIdRef.current !== currentRunId) return;

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([_, value]) => value?.isHardFail === true
          );

          let guarantorOutsideSpain = false;
          let checkGuarantors = entry?.tenantid?.gurantor_id || [];
          if (selectionModel.length > 0) {
            const selGuarIds = getGuarantorIdsForEntry(
              selectionModel,
              entry?._id,
              entry?.tenantid?._id
            );
            checkGuarantors = checkGuarantors.filter((g) =>
              selGuarIds.includes(g?._id)
            );
          }
          for (let g of checkGuarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;
            if (forensicData) {
              for (let key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }
            if (guarantorOutsideSpain) break;
          }
          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              { isHardFail: true, label: "guarantorLivingOutsideSpain" },
            ]);
          }

          // ===== GUARANTORS (NEW) =====
          let guarantors = entry?.tenantid?.gurantor_id || [];
          if (selectionModel.length > 0) {
            const selGIds = getGuarantorIdsForEntry(
              selectionModel,
              entry?._id,
              entry?.tenantid?._id
            );
            guarantors = guarantors.filter((g) => selGIds.includes(g?._id));
          }

          const guarantorResults = [];

          for (let g of guarantors) {
            const gMissingDocsResult = await getResolvedMissingDocsResult(
              g?._id
            );
            const gTemp = await getFieldForPolicies(
              g,
              user,
              finalEffortRate,
              giveInsurance,
              deaWorkspace,
              gMissingDocsResult
            );

            const gScore = calculateOverlayScore(
              gTemp.EFFORT_RATE_SCORE,
              gTemp.TENURE,
              gTemp.EMPLOYMENT_PREDICTABILITY,
              gTemp.SECTOR_CYCLICALITY,
              gTemp.EMPLOYER_STABILITY
            );

            const gErrors = Object.entries(gTemp).filter(
              ([_, value]) => value?.isHardFail === true
            );

            guarantorResults.push({
              ...g,
              DEA_SCORE: gScore,
              errorEntries: gErrors,
              vals: gTemp,
              isResolved: !!gMissingDocsResult,
            });
          }

          // ===== LABEL (UNCHANGED) =====
          const label = getUserDisplayName(entry?.tenantid);

          if (entry?.tenantid) {
            entry.tenantid.label = label;
          }

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;
          // ===== PUSH (ONLY ADDITION = guarantors) =====
          resultDea.push({
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,
            guarantors: guarantorResults, // ✅ NEW FIELD
            isResolved: !!tenantMissingDocsResult,
          });
          // ===== EXISTING SCORING (UNCHANGED) =====
          const result = await calculateFinalScore(
            customPolicyDetails.scoringConfig,
            customPolicyDetails.overlayConfig,
            customPolicyDetails.policyConfig,
            temp
          );
          if (runIdRef.current !== currentRunId) return;

          result.errorEntries = errorEntries;
          result.isHardFail = errorEntries?.length > 0;

          if (DEBUG_CALCULATION) {
            console.log(
              "[policyCalculate] tenant:",
              entry?.tenantid?.label || "unknown",
              "errorEntries:",
              errorEntries,
              "isHardFail:",
              result.isHardFail,
              "finalScore:",
              result.finalScore
            );
          }

          const tenantId = entry?.tenantid?._id;
          const tenantReportData = {
            documentNumber: getIdentityDetails(
              entry?.tenantid,
              entry?.tenantid?.onfido_user_kyc
            )?.value,
            dob: entry?.tenantid?.dob,
            income: entry?.tenantid?._localIncome,
            displayEffortRate: getRentPercentage(
              entry?.tenantid?._localIncome,
              rent
            )?.roundValue,
            is_outdated: !!entry?.tenantid?.is_outdated,
            lastUpdatedAt:
              entry?.tenantid?.profile_renewed_at ||
              entry?.tenantid?.profile_completed_at ||
              entry?.tenantid?.created_at ||
              null,
          };
          tempTenantResults[tenantId] = {
            ...result,
            vals: temp,
            _id: tenantId,
            tenantData: tenantReportData,
            label: entry?.tenantid?.label,
          };
        } catch (err) {
          if (runIdRef.current !== currentRunId) return;
          console.error("Unexpected error:", err);
        }
      }
      if (DEBUG_CALCULATION) {
        console.log(
          "[policyCalculate] FINAL → tenantResults:",
          JSON.stringify(tempTenantResults, null, 2)
        );
        console.log(
          "[policyCalculate] FINAL → finalEffortRate:",
          finalEffortRate
        );
        console.log(
          "[policyCalculate] FINAL → isDeaRulesActivated:",
          isDeaRulesActivated,
          "isRecommendationRulesActivated:",
          isRecommendationRulesActivated
        );
      }
      setTenantResults(tempTenantResults);
      setGuarantorResults(tempGuarantorResults);
      setDeaResult(resultDea);
      setFinalEffortRate(finalEffortRate);
    } catch (err) {
      console.log(err);
    } finally {
      if (runIdRef.current === currentRunId) {
        setResultLoader(false);
      }
    }
  }

  const processAssignPropData = async () => {
    const resultDeaObject = {};
    const allEntires = getName();

    await Promise.all(
      allEntires.map(async (entry) => {
        try {
          // ===== INDIVIDUAL ENTRY INCOME =====
          const incomeSelection = resolveIncomeSelection(
            entry?.income_selection,
            entry?.tenantid?._id
          );

          const tenantInfo = entry?.tenantid;

          const tenantIncome = getCustomIncomeDetails(
            tenantInfo,
            user,
            _t,
            incomeSelection?.tenant_source,
            undefined,
            undefined,
            deaWorkspace,
            entry?.custom_income_sources
          );

          let tenantIncomeSum = tenantIncome?.amount ?? 0;

          // ===== GUARANTOR INCOME =====
          let guarantors = tenantInfo?.gurantor_id || [];

          if (selectionModel.length > 0) {
            const selectedIds = getGuarantorIdsForEntry(
              selectionModel,
              entry?._id,
              entry?.tenantid?._id
            );

            guarantors = guarantors.filter((g) => selectedIds.includes(g?._id));
          }

          const guarantorIncomeSelection =
            incomeSelection?.[entry?.tenantid?._id]?.guarantor_sources ??
            incomeSelection?.guarantor_sources;

          let guarantorIncomeSum = 0;

          for (const g of guarantors) {
            const guarantorIncome = getCustomIncomeDetails(
              g,
              user,
              _t,
              guarantorIncomeSelection?.[g?._id],
              undefined,
              undefined,
              deaWorkspace,
              entry?.custom_income_sources
            );

            guarantorIncomeSum += guarantorIncome?.amount ?? 0;
          }

          // ===== INDIVIDUAL EFFORT RATE =====
          const totalIncome = tenantIncomeSum + guarantorIncomeSum;

          const finalEffortRate =
            getRentPercentage(totalIncome, rent)?.roundValue ?? "0";
          //   console.log("DEBUG finalEffortRate", finalEffortRate);

          // ===== TENANT =====
          const tenantMissingDocsResult = await getResolvedMissingDocsResult(
            entry?.tenantid?._id
          );

          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace,
            tenantMissingDocsResult
          );

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([key, value]) => value?.isHardFail === true
          );

          // ===== GUARANTOR OUTSIDE SPAIN =====
          let guarantorOutsideSpain = false;

          for (const g of guarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;

            if (forensicData) {
              for (const key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }

            if (guarantorOutsideSpain) break;
          }

          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              {
                isHardFail: true,
                label: "guarantorLivingOutsideSpain",
              },
            ]);
          }

          // ===== GUARANTORS =====
          const guarantorResults = await Promise.all(
            guarantors.map(async (g) => {
              try {
                const gMissingDocsResult = await getResolvedMissingDocsResult(
                  g?._id
                );

                const gTemp = await getFieldForPolicies(
                  g,
                  user,
                  finalEffortRate,
                  giveInsurance,
                  deaWorkspace,
                  gMissingDocsResult
                );

                const gScore = calculateOverlayScore(
                  gTemp.EFFORT_RATE_SCORE,
                  gTemp.TENURE,
                  gTemp.EMPLOYMENT_PREDICTABILITY,
                  gTemp.SECTOR_CYCLICALITY,
                  gTemp.EMPLOYER_STABILITY
                );

                const gErrors = Object.entries(gTemp).filter(
                  ([_, value]) => value?.isHardFail === true
                );

                return {
                  ...g,
                  DEA_SCORE: gScore,
                  errorEntries: gErrors,
                  vals: gTemp,
                };
              } catch (err) {
                console.error("Guarantor error:", err);
                return null;
              }
            })
          );

          // ===== LABEL =====
          const label = getUserDisplayName(entry?.tenantid);

          if (entry?.tenantid) {
            entry.tenantid.label = label;
          }

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;

          // ===== FINAL OBJECT =====
          resultDeaObject[entry?._id] = {
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,
            guarantors: guarantorResults.filter(Boolean),

            // Optional: useful for debugging
            totalIncome,
            finalEffortRate,
          };
        } catch (err) {
          console.error("Unexpected error:", err);
        }
      })
    );

    setAllDeaResult(resultDeaObject);
  };

  const handleChangeRent = (e) => {
    const value = e.target.value;

    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setRent(value);
      setPropertyRentError(false);
    }
  };

  const handleBlurRent = async () => {
    if (!rent) {
      setPropertyRentError(true);
      return;
    }
    await updatePropertyDetails(property?._id, {
      report_rent: rent ?? "",
    });
    loadData();
  };

  useEffect(() => {
    const ids = (propertyShareProfiles ?? [])
      .map((p) => p?.application_id?._id)
      .filter(Boolean);
    setLinkedApplicationIds(ids);
  }, [propertyShareProfiles]);

  useEffect(() => {
    if (isAwardedLocked) {
      setAllDeaResult({});
      return;
    }

    if (propertyShareProfiles?.length > 0) {
      setAllDeaResult({});
      processAssignPropData();
    }
  }, [propertyShareProfiles, rent, isAwardedLocked]);

  useEffect(() => {
    if (!isPropertyBlocked) {
      setPropertyBlockedSelectedTenants([]);
      return;
    }

    const skorProtectIsBlocking = [
      "waiting_for_payment",
      "waiting_for_rental_contract",
    ].includes(property?.skor_protect_data?.skor_protect_status);

    const blockingData = skorProtectIsBlocking
      ? (property?.skor_protect_data ?? {})
      : (property?.insurance_beneficiary_payment_data ?? {});

    if (blockingData.selections?.length > 0) {
      setPropertyBlockedSelectedTenants(
        getSelectedProfilesFromSelections(
          blockingData.selections,
          propertyShareProfiles,
          { filterParticipants: false }
        )
      );
      return;
    }

    // Read-only compatibility for blocking records created before the API
    // adopted the same nested `selections` structure as property awarding.
    if (blockingData.application_id) {
      const matched = (propertyShareProfiles ?? []).filter(
        (val) =>
          val?.application_id?._id === String(blockingData.application_id)
      );
      setPropertyBlockedSelectedTenants(matched);
      setSelectionModel(
        getSelectionModelFromSelections(
          getSelectionsFromProfiles(matched),
          propertyShareProfiles
        )
      );
      if (matched[0]?._id) {
        setOpenApplicationIds((prev) => ({
          ...prev,
          [matched[0]._id]: true,
        }));
      }
      return;
    }

    const blockedIds = blockingData.selected_tenants ?? [];
    if (blockedIds.length > 0) {
      const idSet = new Set(blockedIds.map(String));
      const matched = (propertyShareProfiles ?? []).filter((val) =>
        idSet.has(String(val?.tenantid?._id))
      );
      setPropertyBlockedSelectedTenants(matched);
      setSelectionModel(
        getSelectionModelFromSelections(
          getSelectionsFromProfiles(matched),
          propertyShareProfiles
        )
      );
    } else {
      setPropertyBlockedSelectedTenants([]);
    }
  }, [
    propertyShareProfiles,
    property?.skor_protect_data?.selected_tenants,
    property?.skor_protect_data?.application_id,
    property?.skor_protect_data?.selections,
    property?.skor_protect_data?.skor_protect_status,
    property?.insurance_beneficiary_payment_data?.payment_link_status,
    property?.insurance_beneficiary_payment_data?.application_id,
    property?.insurance_beneficiary_payment_data?.selected_tenants,
    property?.insurance_beneficiary_payment_data?.selections,
  ]);

  useEffect(() => {
    if (isPropertyAwarded) {
      if (isAwardSnapshotCompleted && haveValue(propertyShareProfiles)) {
        console.log();
        setPropertyAwardedSelectedTenant(propertyShareProfiles);
      } else if (haveValue(property?.selections)) {
        const selectedSharedProfiles = (property.selections || []).flatMap(
          (sel) => {
            if (sel.tenant) {
              const profile = propertyShareProfiles?.find(
                (val) => val?.tenantid?._id === sel.tenant
              );
              return profile ? [profile] : [];
            }
            if (sel.application) {
              const appProfile = propertyShareProfiles?.find(
                (val) => val?.application_id?._id === sel.application
              );
              if (appProfile) return [appProfile];
              return (sel.participants || [])
                .map((p) =>
                  propertyShareProfiles?.find(
                    (val) => val?.tenantid?._id === p.tenant
                  )
                )
                .filter(Boolean);
            }
            return [];
          }
        );

        setPropertyAwardedSelectedTenant(selectedSharedProfiles);
      } else if (property?.current_application) {
        setPropertyAwardedSelectedTenant(
          propertyShareProfiles?.filter(
            (val) => val?.application_id?._id === property?.current_application
          )
        );
      } else {
        const tempArr = propertyShareProfiles?.filter((val) =>
          property?.current_tenant?.includes(val?.tenantid?._id)
        );
        setPropertyAwardedSelectedTenant(tempArr);
      }
    }
  }, [isPropertyAwarded, propertyShareProfiles, property]);

  const calculateRentAmount = (fullinfo) => {
    const user_income_sources = resolveIncomeSelection(
      fullinfo?.income_selection,
      fullinfo?.tenantid?._id
    );
    // const gurantor_income_sources = user_income_sources?.guarantor_sources;
    const gurantor_income_sources =
      user_income_sources?.[fullinfo?.tenantid?._id]?.guarantor_sources ??
      user_income_sources?.guarantor_sources;

    const effortRateType =
      fullinfo?.effort_rate_data?.tenant?.effort_rate_type ??
      fullinfo?.tenantid?.effort_rate_type ??
      "tenant";

    const tInfo = fullinfo?.tenantid;

    const user_income = getCustomIncomeDetails(
      tInfo,
      user,
      _t,
      user_income_sources?.tenant_source,
      undefined,
      undefined,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = tInfo?.gurantor_id || [];

    if (selectionModel.length > 0) {
      const selectedGuarantorIds = getGuarantorIdsForEntry(
        selectionModel,
        fullinfo?._id,
        fullinfo?.tenantid?._id
      );
      allGurantors = allGurantors.filter((g) =>
        selectedGuarantorIds.includes(g?._id)
      );
    }

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            user,
            _t,
            gurantor_income_sources?.[gurantor?._id],
            undefined,
            undefined,
            deaWorkspace,
            fullinfo?.custom_income_sources
          );

          // if (!disabledIncomeSourcesIds?.includes(income?.all_sources?._id)) {
          //   if (["guarantor", "both"]?.includes(effortRateType)) {
          totalGurantorIncome += income?.amount || 0;
          //   }
          // }
          allGurantorIncomes.push(income);
        }
      });
    }

    // const userAmount = !disabledIncomeSourcesIds?.includes(
    //   user_income?.all_sources?._id
    // )
    //   ? +user_income?.amount
    //   : 0;
    const userAmount = +user_income?.amount + +totalGurantorIncome;

    // const combinedIncome = userAmount + +totalGurantorIncome;

    // const data = {
    //   ...fullinfo,
    //   rent_percentage: 35,
    // };
    // let temp_obj = calculateEffortRate(combinedIncome, user, data);

    // return !Number.isNaN(temp_obj?.effort_amount)
    //   ? Math.round(Number(temp_obj.effort_amount))
    //   : 0;

    return getRentPercentage(userAmount, rent)?.roundValue;
  };

  //   #TODO: this function is same defined in ProfileRow.jsx
  // we need to dedupe this function and make it reusable and place is it common
  const eachRentAmount = (fullinfo) => {
    const user_income_sources = resolveIncomeSelection(
      fullinfo?.income_selection,
      fullinfo?.tenantid?._id
    );
    const fallbackIncome = fullinfo?.useFallbackIncome;
    const useFallbackIncome =
      typeof fallbackIncome === "boolean" ? fallbackIncome : true;
    // const gurantor_income_sources = user_income_sources?.guarantor_sources;
    const gurantor_income_sources =
      user_income_sources?.[fullinfo?.tenantid?._id]?.guarantor_sources ??
      user_income_sources?.guarantor_sources;
    let profile_effort_rate_percentage =
      fullinfo?.effort_rate_data?.tenant?.effort_rate_percentage;
    if (!haveValue(profile_effort_rate_percentage)) {
      profile_effort_rate_percentage =
        user?.current_workspace?.default_effort_rate ?? 35;
    }
    const effortRateType =
      fullinfo?.effort_rate_data?.tenant?.effort_rate_type ??
      fullinfo?.tenantid?.effort_rate_type ??
      "tenant";

    const tInfo = fullinfo?.tenantid;
    const user_income = getCustomIncomeDetails(
      tInfo,
      user,
      _t,
      user_income_sources?.tenant_source,
      undefined,
      //   useFallbackIncome,
      true,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );

    // console.log("DEBUG, tId", tInfo?._id, " user_income:", user_income);

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = fullinfo?.tenantid?.gurantor_id || [];

    if (selectionModel.length > 0) {
      const selectedGuarantorIds = getGuarantorIdsForEntry(
        selectionModel,
        fullinfo?._id,
        fullinfo?.tenantid?._id
      );
      allGurantors = allGurantors.filter((g) =>
        selectedGuarantorIds.includes(g?._id)
      );
    }

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            user,
            _t,
            gurantor_income_sources?.[gurantor?._id],
            undefined,
            useFallbackIncome,
            deaWorkspace,
            fullinfo?.custom_income_sources
          );

          totalGurantorIncome += income?.amount || 0;
          allGurantorIncomes.push(income);
        }
      });
    }

    const userAmount = ["tenant", "both"]?.includes(effortRateType)
      ? +user_income?.amount
      : 0;

    const combinedIncome = userAmount + +totalGurantorIncome;

    const data = {
      ...fullinfo,
      rent_percentage: profile_effort_rate_percentage,
    };
    let temp_obj = calculateEffortRate(combinedIncome, user, data);

    return {
      combinedIncome,
      effort_rate: !Number.isNaN(temp_obj?.effort_amount)
        ? Math.round(Number(temp_obj.effort_amount))
        : 0,
      profile_effort_rate_percentage,
    };
  };
  const getTenantIncomeDetails = (fullinfo) => {
    return getCustomIncomeDetails(
      fullinfo?.tenantid,
      user,
      _t,
      resolveIncomeSelection(
        fullinfo?.income_selection,
        fullinfo?.tenantid?._id
      )?.tenant_source,
      undefined,
      undefined,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );
  };

  const checkAllTenantsHaveAcceptedSharing = (tenants) => {
    if (!tenants || tenants.length === 0) return false;

    return tenants.every((tenant) => {
      const applicationId = tenant?.application_id;
      if (!applicationId) return true;

      const participants = applicationId?.participants || [];
      if (participants.length === 0) return true;

      return participants.every(
        (participant) => participant?.consent_status === "accepted"
      );
    });
  };

  const generateReport = async () => {
    if (isAwardSnapshotProcessing) {
      return;
    }
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot generate report. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }
    setAwardPopupModal(true);
  };

  const handleAwardPropFlow = async () => {
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot award property. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }

    setLoading(true);
    try {
      const res = await awardProperty({
        property_id: property?._id,
        selections: allTenantIds,
      });
      if (res.status == "success") {
        toast.success(
          _t(
            "successWhileAwardingMultiPropAdminWillContactYou",
            "Success text when LL tries to award Multi tenant prop"
          )
        );
      }

      setShowSuccessPopup(true);
      if (setPropData) setPropData({});
      setSelectionModel([]);
      setSuccessTenant(res?.data || res);
    } catch (err) {
      toast.error(
        _t(
          "errorWhileAwardingMultiProp",
          "Error text when LL tries to award Multi tenant prop"
        )
      );
    } finally {
      setLoading(false);
    }
  };

  const clearExpiredLinkedReportCache = () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (!key.startsWith(LINKED_REPORT_CACHE_PREFIX)) return;

        const cachedValue = JSON.parse(sessionStorage.getItem(key));
        if (!cachedValue?.expiresAt || cachedValue.expiresAt <= Date.now()) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.log("Unable to clear linked report cache", error);
    }
  };

  const handleGenerateLinkedReport = (reportCacheData = {}) => {
    if (
      !haveValue(selectedTenant) ||
      selectedTenant.length === 0 ||
      isAwardSnapshotProcessing
    ) {
      return;
    }

    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot generate report. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }

    let queryParams = "";
    selectedTenant.forEach((tenantProfile) => {
      queryParams += `sharedprofileid=${tenantProfile?._id}&`;
    });

    queryParams += `rent=${rent || property?.report_rent || 0}`;

    if (haveValue(property?._id)) {
      queryParams += `&property=${property?._id}`;
    }

    const propertyName = `${property?.street || ""} ${
      Number.isNaN(parseInt(property?.street_number, 10))
        ? ""
        : String(parseInt(property?.street_number, 10))
    }${property?.floor_number ? `, ${property?.floor_number}` : ""}${
      property?.flat_number ? ` - ${property?.flat_number}` : ""
    }`.trim();

    if (haveValue(propertyName)) {
      queryParams += `&propName=${encodeURIComponent(propertyName)}`;
    }
    if (haveValue(property?.zip_code)) {
      queryParams += `&postalCode=${encodeURIComponent(property?.zip_code)}`;
    }
    if (haveValue(property?.city)) {
      queryParams += `&city=${encodeURIComponent(property?.city)}`;
    }

    const redirectUrl = window.location.pathname + window.location.search;
    queryParams += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;
    if (selectionModel.length > 0) {
      queryParams += `&selection=${encodeURIComponent(
        JSON.stringify(selectionModel)
      )}`;
    }

    if (isAwardSnapshotCompleted) {
      queryParams += `&awardSnapshotCompleted=true`;
    }

    if (haveValue(reportCacheData?.historyEventId)) {
      queryParams += `&historyEventId=${encodeURIComponent(reportCacheData.historyEventId)}`;
    }

    try {
      clearExpiredLinkedReportCache();
      const reportStateKey = `${LINKED_REPORT_CACHE_PREFIX}${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
      const linkedReportState = {
        ...reportCacheData,
        awardSnapshotCompleted: isAwardSnapshotCompleted,
        addressVal: {
          ...property,
          postcode: property?.postcode ?? property?.zip_code,
          muncipality: property?.muncipality ?? property?.city,
        },
        rent: rent || property?.report_rent || 0,
        sharedProfileCount: selectedTenant?.length ?? 0,
        combinedIncome: totalCombinedIncome,
        combinedEffortRate:
          haveValue(finalEffortRate) && !Number.isNaN(Number(finalEffortRate))
            ? `${finalEffortRate}%`
            : "No data",
        reportInsurableStatus: getInsuranceReportStatus({
          isInsurable: isInsuranceSimulationSuccess,
          isNotInsurable: isInsuranceNotInsurable,
        }),
        reportInsuranceErrorCode: insuranceErrorCode,
        reportInsuranceErrorCodes: insuranceErrorCodes,
        areAllSelectedTenantsInsurable,
        expiresAt: Date.now() + LINKED_REPORT_CACHE_TTL_MS,
      };

      sessionStorage.setItem(reportStateKey, JSON.stringify(linkedReportState));
      queryParams += `&reportStateKey=${encodeURIComponent(reportStateKey)}`;
    } catch (error) {
      console.log("Unable to cache linked report data", error);
    }

    window.open(
      `${haveValue(workspaceId) ? `/${workspaceId}` : ""}/linked-report-overview?${queryParams}`,
      "_blank"
    );
    // navigate(
    //   `${haveValue(workspaceId) ? `/${workspaceId}` : ""}/linked-report-overview?${queryParams}`,
    //   { state: { riskReportData } },
    // );
  };

  const normalizeTenantEntry = (item) => {
    const applicationData = item?.application_id || item?.application;

    return {
      ...item,
      application_id: applicationData,
      tenantid: item?.tenantid || item?.tenant_id || item?.tenant,
    };
  };

  const getProfileEntityKey = (item) => {
    const normalizedItem = normalizeTenantEntry(item);
    const applicationId = normalizedItem?.application_id?._id;
    if (applicationId) return `application:${applicationId}`;

    const tenantId = normalizedItem?.tenantid?._id || normalizedItem?.value;
    return tenantId ? `tenant:${tenantId}` : null;
  };

  const getSelectionEntityKey = (entry) => {
    if (entry?.type === "application" && entry?.applicationId) {
      return `application:${entry.applicationId}`;
    }
    if (entry?.type === "tenant" && entry?.tenantId) {
      return `tenant:${entry.tenantId}`;
    }
    return null;
  };

  const getSelectionEntryForProfile = (item) => {
    const normalizedItem = normalizeTenantEntry(item);
    const participants = normalizedItem?.application_id?.participants ?? [];

    if (normalizedItem?.application_id?._id) {
      return {
        sharedProfileId: normalizedItem?._id,
        type: "application",
        applicationId: normalizedItem.application_id._id,
        participants: participants
          .map((participant) => ({
            tenantId:
              participant?.tenant_info?._id ||
              participant?.tenant_id ||
              participant?.id,
            guarantorIds:
              participant?.tenant_info?.gurantor_id?.map(
                (guarantor) => guarantor?._id
              ) || [],
          }))
          .filter((participant) => participant.tenantId),
      };
    }

    const tenantId = normalizedItem?.tenantid?._id || normalizedItem?.value;
    if (!tenantId) return null;

    return {
      sharedProfileId: normalizedItem?._id,
      type: "tenant",
      tenantId,
      guarantorIds:
        normalizedItem?.tenantid?.gurantor_id?.map(
          (guarantor) => guarantor?._id
        ) || [],
    };
  };

  const getStagedSelectionEntryForProfile = (item) => {
    const entityKey = getProfileEntityKey(item);
    const originalEntry = awardedSelectionBeforeEditRef.current.find(
      (entry) => getSelectionEntityKey(entry) === entityKey
    );
    return originalEntry ?? getSelectionEntryForProfile(item);
  };

  const updateStagedTenantLink = (tenantData, shouldLink) => {
    const normalizedTenant = normalizeTenantEntry(tenantData);
    const entityKey = getProfileEntityKey(normalizedTenant);
    if (!entityKey) return;

    setPropertyShareProfiles((previousProfiles) => {
      const withoutTenant = previousProfiles.filter(
        (profile) => getProfileEntityKey(profile) !== entityKey
      );
      return shouldLink ? [...withoutTenant, normalizedTenant] : withoutTenant;
    });

    setSelectionModel((previousSelection) => {
      const withoutTenant = previousSelection.filter(
        (entry) => getSelectionEntityKey(entry) !== entityKey
      );
      if (!shouldLink) return withoutTenant;

      const selectionEntry =
        getStagedSelectionEntryForProfile(normalizedTenant);
      return selectionEntry
        ? [...withoutTenant, selectionEntry]
        : withoutTenant;
    });
  };

  const getName = () => {
    if (haveValue(searchText)) {
      const searchLower = searchText.toLowerCase();

      const filtered = (tanentData ?? [])
        .map(normalizeTenantEntry)
        .filter((item) => {
          const participants = item?.application_id?.participants ?? [];

          const participantMatch = participants.some(
            (p) =>
              p?.email?.toLowerCase()?.includes(searchLower) ||
              p?.name?.toLowerCase()?.includes(searchLower) ||
              getUserDisplayName(p?.tenant_info)
                ?.toLowerCase()
                ?.includes(searchLower)
          );

          const itemMatch =
            (item?.deleted &&
              _t("deletedUser", "Deleted user")
                ?.toLowerCase()
                ?.includes(searchLower)) ||
            item?.label?.toLowerCase()?.includes(searchLower) ||
            item?.sub_val?.toLowerCase()?.includes(searchLower) ||
            getUserDisplayName(item?.tenantid)
              ?.toLowerCase()
              ?.includes(searchLower);

          return participantMatch || itemMatch;
        });

      return filtered;
    }

    if (propertyBlockedSelectedTenants?.length > 0) {
      return propertyBlockedSelectedTenants;
    }

    if (isPropertyAwarded && !isEditingAwarded) {
      console.log(
        !!property?.current_application,
        "awardedTenantsLen=",
        propertyAwardedSelectedTenant?.length,
        "isCompleted=",
        isAwardSnapshotCompleted
      );
      if (isAwardSnapshotCompleted) {
        console.log(propertyShareProfiles?.length, ")");
        return propertyShareProfiles;
      }
      if (
        property?.current_application &&
        propertyAwardedSelectedTenant?.length === 0
      ) {
        const applicationEntry = propertyShareProfiles?.find(
          (val) => val?.application_id?._id === property?.current_application
        );

        if (applicationEntry) {
          return [applicationEntry];
        }
      }

      return propertyAwardedSelectedTenant;
    }

    return propertyShareProfiles;
  };

  const getApplicationDetails = (profileEntry) => {
    const participants =
      profileEntry?.application_id?.participants?.map((p) => ({
        ...p,
        isPrimary:
          !profileEntry?.application_id?.creator_deleted &&
          !p?.is_deleted &&
          !p.deleted &&
          p?.id === profileEntry?.application_id?.created_by,
      })) ?? [];
    const acceptedParticipants = participants.filter(
      (participant) =>
        !participant?.is_deleted &&
        !participant?.deleted &&
        participant?.consent_status === "accepted" &&
        participant?.tenant_info
    );
    const visibleParticipants = participants.filter(
      (participant) =>
        participant?.is_deleted ||
        participant?.deleted ||
        (participant?.consent_status === "accepted" && participant?.tenant_info)
    );
    const applicationMembers = visibleParticipants
      .map((participant) =>
        participant?.is_deleted || participant?.deleted
          ? _t("deletedUser", "Deleted user")
          : participant?.name
            ? participant?.name
            : getUserDisplayName(participant?.tenant_info)
      )
      .filter(Boolean);
    const primaryEntry = profileEntry?.application_id?.creator_deleted
      ? null
      : participants.find(
          (participant) =>
            participant?.id === profileEntry?.application_id?.created_by
        );
    const primaryParticipant =
      primaryEntry?.tenant_info ?? acceptedParticipants?.[0]?.tenant_info;

    return {
      applicationId: profileEntry?.application_id?._id,
      title: profileEntry?.application_id?.title,
      participants,
      acceptedParticipants,
      primaryName:
        primaryEntry?.is_deleted || primaryEntry?.deleted
          ? _t("deletedUser", "Deleted user")
          : primaryParticipant
            ? getUserDisplayName(primaryParticipant)
            : primaryEntry?.name,
      subtitleMembers: applicationMembers.slice(1, 3).join(", "),
      hasMoreMembers: applicationMembers.length > 3,
      hasApplication: participants.length > 0,
      skor_protect: profileEntry?.application_id?.skor_protect,
    };
  };

  const toggleApplicationAccordion = (sharedProfileId) => {
    setOpenApplicationIds((prev) => ({
      ...prev,
      [sharedProfileId]: !prev?.[sharedProfileId],
    }));
  };

  const handleCheckboxChange = (tenantData) => (e) => {
    toggleDirectTenant(tenantData, e.target.checked);
  };

  const getTenantId = (tenantData) =>
    tenantData?.tenantid?._id || tenantData?.value;

  const getTrackingId = (tenantData) => {
    const applicationId = tenantData?.application_id?._id;
    const tenantId = tenantData?.tenantid?._id || tenantData?.value;
    return applicationId ? applicationId : tenantId;
  };

  const handleTenantSelect = async (tenantData, selectStatus) => {
    if (isEditingAwarded) {
      updateStagedTenantLink(tenantData, selectStatus === "notSelected");
      return;
    }

    const trackingId = getTrackingId(tenantData);
    const isLinkAction = selectStatus === "notSelected";

    if (isLinkAction) {
      setLinkingTenantIds((prev) => [...prev, trackingId]);
    } else {
      setUnlinkingTenantIds((prev) => [...prev, trackingId]);
    }
    setEnabled(false);

    try {
      const applicationDetails = getApplicationDetails(tenantData);
      if (applicationDetails?.hasApplication) {
        if (selectStatus === "notSelected") {
          const response = await editSharedProfile(tenantData._id, {
            property_id: property?._id,
            status: "add",
          });
          if (!response) return;
          onTenantLinked?.();
        } else {
          const response = await editSharedProfile(tenantData._id, {
            property_id: property?._id,
            status: "remove",
          });
          if (!response) return;
        }
        await fetchShareProfileData(true, true);
      } else {
        const tenantId = getTenantId(tenantData);
        const updatedList =
          selectStatus === "notSelected"
            ? [...selectedTanents, tenantId]
            : selectedTanents.filter((val) => val !== tenantId);

        setSelectedTanents(updatedList);
        const saved = await handleSaveChanges(null, updatedList);
        if (!saved) return;
        await fetchShareProfileData(false, false);
      }
    } catch (error) {
      console.error("Error linking/unlinking tenant:", error);
    } finally {
      setLinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
      setUnlinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
    }
  };

  const handleUnLinkSingle = async (e, tenantData) => {
    if (isEditingAwarded) {
      updateStagedTenantLink(tenantData, false);
      return;
    }

    const trackingId = getTrackingId(tenantData);

    setUnlinkingTenantIds((prev) => [...prev, trackingId]);
    setEnabled(false);

    try {
      const applicationDetails = getApplicationDetails(tenantData);

      if (applicationDetails?.hasApplication) {
        await unlinkApplicationFromProperty({
          property_id: property?._id,
          application_id: applicationDetails?.applicationId,
        });
        await fetchShareProfileData(true, true);
      } else {
        const tenantId = getTenantId(tenantData);
        const temp = selectedTanents.filter((val) => val !== tenantId);
        setSelectedTanents(temp);
        await handleSaveChanges(e, temp);
        await fetchShareProfileData(false, true);
      }
    } catch (error) {
      console.error("Error unlinking tenant:", error);
      toast.error(
        _t("errorWhileUnlinkingTenant", "Error while unlinking tenant")
      );
    } finally {
      setUnlinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
    }
  };

  const handleSelectAllLinked = () => {
    toggleAllEntries(propertyShareProfiles);
  };

  const handleBulkUnlink = async (e) => {
    if (isBulkUnlinking) return;

    if (isEditingAwarded) {
      const selectedEntityKeys = new Set(
        selectionModel.map(getSelectionEntityKey).filter(Boolean)
      );
      const remainingProfiles = propertyShareProfiles.filter(
        (profile) => !selectedEntityKeys.has(getProfileEntityKey(profile))
      );
      setPropertyShareProfiles(remainingProfiles);
      setSelectionModel(
        remainingProfiles.map(getStagedSelectionEntryForProfile).filter(Boolean)
      );
      return;
    }

    setIsBulkUnlinking(true);
    const tenantsToUnlink = [...selectedTenant];
    try {
      for (const tenantData of tenantsToUnlink) {
        const trackingId = getTrackingId(tenantData);
        setUnlinkingTenantIds((prev) => [...prev, trackingId]);
        const applicationDetails = getApplicationDetails(tenantData);
        if (applicationDetails?.hasApplication) {
          await unlinkApplicationFromProperty({
            property_id: property?._id,
            application_id: applicationDetails?.applicationId,
          });
        } else {
          const tenantId = getTenantId(tenantData);
          const temp = selectedTanents.filter((val) => val !== tenantId);
          setSelectedTanents(temp);
          await handleSaveChanges(e, temp);
        }
        setUnlinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
      }
      await fetchShareProfileData(true, true);
      setSelectionModel([]);
    } catch (error) {
      console.error("Error bulk unlinking tenants:", error);
      toast.error(
        _t("errorWhileUnlinkingTenant", "Error while unlinking tenant")
      );
      setUnlinkingTenantIds([]);
    } finally {
      setIsBulkUnlinking(false);
    }
  };

  const handleUnAwardProperty = () => {
    if (isVacatingProperty) return;

    setIsVacatingProperty(true);
    setLoading(true);
    const send_data = {
      property_id: property?._id,
      notify_admin_of_active_insurance: hasActiveNonPaymentInsurance,
    };
    multiPropUnAward(send_data)
      .then((res) => {
        setShowVacatePropertyPopup(false);
        setShowUnAwardSuccessPopup(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsVacatingProperty(false);
        setLoading(false);
      });
  };

  const handleVacatePropertyClick = () => {
    setShowVacatePropertyPopup(true);
  };

  const handleReportAction = () => {
    if (isDeaRulesActivated) {
      generateReport();
    } else if (isRecommendationRulesActivated) {
      if (isAwardedLocked) {
        setPendingSnapshotReportOpen(true);
        return;
      }
      const generatedReport = renderFinalResult(true);
      setRiskReportData(generatedReport);
      setShowRiskAssessmentReportModal(true);
    } else {
      generateReport();
    }
  };

  const reportActionDisabled =
    (isAwardSnapshotProcessing ||
      !checkAllTenantsHaveAcceptedSharing(selectedTenant)) &&
    !isEditingAwarded;

  const hasAwardedTenantSelection =
    getSelectedTenantIds(selectionModel ?? []).length > 0;

  const handleEnterEditMode = async () => {
    selectionModelBeforeEditRef.current = selectionModel;
    propertyShareProfilesBeforeEditRef.current = propertyShareProfiles;
    selectedTenantIdsBeforeEditRef.current = [...selectedTanents];
    const currentAwardedSelections = allTenantIds;
    try {
      let liveProfiles = linkedProfilesBeforeEditRef.current;
      if (!Array.isArray(liveProfiles)) {
        const data = await getShareProfilesForProperty(property?._id);
        liveProfiles = data?.sharedProfiles ?? [];
      }
      linkedProfilesBeforeEditRef.current = liveProfiles;
      setPropertyShareProfiles(liveProfiles);

      const selections = currentAwardedSelections?.length
        ? currentAwardedSelections
        : property?.selections?.length
          ? property.selections
          : getSelectionsFromProfiles(
              propertyAwardedSelectedTenant?.length
                ? propertyAwardedSelectedTenant
                : liveProfiles
            );
      const awardedSelection = getSelectionModelFromSelections(
        selections ?? [],
        liveProfiles
      );
      awardedSelectionBeforeEditRef.current = awardedSelection;
      setSelectionModel(awardedSelection);
      setIsEditingAwarded(true);
    } catch (e) {
      console.log("Failed to load linked profiles for editing", e);
      setSelectionModel(selectionModelBeforeEditRef.current ?? []);
      setPropertyShareProfiles(propertyShareProfilesBeforeEditRef.current);
      awardedSelectionBeforeEditRef.current = [];
      linkedProfilesBeforeEditRef.current = null;
      propertyShareProfilesBeforeEditRef.current = [];
      selectedTenantIdsBeforeEditRef.current = [];
      setIsEditingAwarded(false);
    }
  };

  const handleCancelEdit = () => {
    setSelectionModel(selectionModelBeforeEditRef.current ?? []);
    setPropertyShareProfiles(propertyShareProfilesBeforeEditRef.current);
    awardedSelectionBeforeEditRef.current = [];
    propertyShareProfilesBeforeEditRef.current = [];
    selectedTenantIdsBeforeEditRef.current = [];
    setIsEditingAwarded(false);
  };

  const handleSaveAwardedEdits = async () => {
    if (!hasAwardedTenantSelection) {
      toast.error(_t("atLeastOneTenantIsRequired"));
      return false;
    }

    setSavingAwardEdits(true);
    try {
      const originalProfiles = linkedProfilesBeforeEditRef.current ?? [];
      const originalProfilesByKey = new Map(
        originalProfiles
          .map((profile) => [getProfileEntityKey(profile), profile])
          .filter(([key]) => key)
      );
      const currentProfilesByKey = new Map(
        propertyShareProfiles
          .map((profile) => [getProfileEntityKey(profile), profile])
          .filter(([key]) => key)
      );
      const removedProfiles = [...originalProfilesByKey.entries()]
        .filter(([key]) => !currentProfilesByKey.has(key))
        .map(([, profile]) => profile);
      const addedProfiles = [...currentProfilesByKey.entries()]
        .filter(([key]) => !originalProfilesByKey.has(key))
        .map(([, profile]) => profile);

      for (const profile of removedProfiles) {
        const applicationId =
          normalizeTenantEntry(profile)?.application_id?._id;
        if (applicationId) {
          await unlinkApplicationFromProperty({
            property_id: property?._id,
            application_id: applicationId,
          });
        }
      }

      for (const profile of addedProfiles) {
        const normalizedProfile = normalizeTenantEntry(profile);
        if (normalizedProfile?.application_id?._id) {
          await editSharedProfile(normalizedProfile?._id, {
            property_id: property?._id,
            status: "add",
          });
        }
      }

      const getDirectTenantIds = (profiles) =>
        profiles
          .map((profile) => {
            const normalizedProfile = normalizeTenantEntry(profile);
            if (normalizedProfile?.application_id?._id) return null;
            return normalizedProfile?.tenantid?._id || normalizedProfile?.value;
          })
          .filter(Boolean);
      const originalDirectTenantIds = getDirectTenantIds(originalProfiles);
      const currentDirectTenantIds = getDirectTenantIds(propertyShareProfiles);
      const originalDirectTenantIdSet = new Set(
        originalDirectTenantIds.map(String)
      );
      const directTenantLinksChanged =
        originalDirectTenantIds.length !== currentDirectTenantIds.length ||
        currentDirectTenantIds.some(
          (tenantId) => !originalDirectTenantIdSet.has(String(tenantId))
        );

      if (directTenantLinksChanged) {
        const finalSelectedTenantIds = [
          ...selectedTenantIdsBeforeEditRef.current.filter(
            (tenantId) => !originalDirectTenantIdSet.has(String(tenantId))
          ),
          ...currentDirectTenantIds,
        ];
        await handleSaveChanges(null, [...new Set(finalSelectedTenantIds)]);
      }

      await updateAwardedPropertySelections({
        property_id: property?._id,
        selections: allTenantIds,
        notify_admin_of_active_insurance: hasExistingAwardProtection,
      });
      toast.success(
        _t("changesSavedSuccessfully", "Changes saved successfully")
      );
      setIsEditingAwarded(false);
      await loadData();
      await fetchShareProfileData(false, true);
      await loadSnapshotProfiles();
      awardedSelectionBeforeEditRef.current = [];
      propertyShareProfilesBeforeEditRef.current = [];
      selectedTenantIdsBeforeEditRef.current = [];
      setShowSaveAwardChangesPopup(false);
      return true;
    } catch (err) {
      toast.error(_t("errorSavingChanges", "Error saving changes"));
      return false;
    } finally {
      setSavingAwardEdits(false);
    }
  };

  const handleSaveAwardedEditsClick = () => {
    if (!hasAwardedTenantSelection) {
      toast.error(_t("atLeastOneTenantIsRequired"));
      return;
    }

    setShowSaveAwardChangesPopup(true);
  };

  const handleConfirmAwardedEdits = async () => {
    // Existing Insurance and Skor Protect awards keep the previous edit flow:
    // keep this confirmation visible and loading until the award API finishes.
    if (hasExistingAwardProtection) {
      await handleSaveAwardedEdits();
      return;
    }

    // Unprotected properties move from this confirmation to processing/results.
    setShowSaveAwardChangesPopup(false);

    if (!isInsurableEnabledLandlord) {
      setShowAwardInsurancePopup(true);
      return;
    }

    const simulationResult = await runInsuranceSimulationHandler(
      "award-edit",
      true,
      true
    );

    // Validation failures use their dedicated modal.
    if (simulationResult?.blocked) return;
  };

  const handleOpenProfile = async (profile) => {
    const isProfilePending = checkIsProfilePending(
      profile?.tenantid ?? profile?.tenant_id,
      profile
    );

    if (isProfilePending) {
      return;
    }

    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(user, profile?._id);

      if (checkView) {
        setCurrentProfile(profile);
        setServingPromptModalURL("");
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${profile?._id}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenParticipantProfile = async (participant, sharedProfileId) => {
    const tenantId = participant?.tenant_info?._id;
    if (
      !tenantId ||
      !sharedProfileId ||
      participant?.tenant_info?.forensic_status !== "COMPLETED"
    ) {
      return;
    }
    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(
        user,
        sharedProfileId,
        tenantId
      );
      if (checkView) {
        setCurrentProfile({ _id: sharedProfileId });
        setServingPromptModalURL(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&tenant_id=${tenantId}`
        );
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&tenant_id=${tenantId}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenGuarantorProfile = async (guarantor, sharedProfileId) => {
    const guarantorId = guarantor?._id;
    if (!guarantorId || !sharedProfileId) {
      return;
    }
    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(
        user,
        sharedProfileId,
        guarantorId
      );
      if (checkView) {
        setCurrentProfile({ _id: sharedProfileId });
        setServingPromptModalURL(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&guarantor=${guarantorId}`
        );
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&guarantor=${guarantorId}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const areAllSelectedTenantsInsurable = useMemo(() => {
    const tenantsForInsurance =
      isPropertyAwarded && !isEditingAwarded
        ? propertyAwardedSelectedTenant
        : selectedTenant;
    if (!tenantsForInsurance || tenantsForInsurance.length === 0) {
      return false;
    }

    return tenantsForInsurance.every((tenant) => {
      const experianData =
        tenant?.tenantid?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.[
          "s:Body"
        ]?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

      return !isDefaulter(experianData);
    });
  }, [
    selectedTenant,
    propertyAwardedSelectedTenant,
    isPropertyAwarded,
    isEditingAwarded,
  ]);

  const areAllSelectedTenantsHaveClearedAmlChecks = useMemo(() => {
    if (!selectedTenant || selectedTenant.length === 0) {
      return false;
    }

    return selectedTenant.some((tenant) => {
      if (
        !haveValue(
          tenant?.tenantid?.onfido_user_kyc?.onfido_workflow_res?.object
            ?.status ??
            tenant?.tenantid?.onfido_user_kyc?.onfido_workflow_res?.status
        )
      ) {
        return false;
      }
      return !amlKycChecks(tenant?.tenantid);
    });
  }, [selectedTenant]);

  const getStatusStyle = () => {
    let finalStatus = null;
    if (selectedTenant?.length === 0) {
      finalStatus = STATUS_STYLES.grey;
    } else if (!areAllSelectedTenantsInsurable) {
      finalStatus = STATUS_STYLES.red;
    } else if (areAllSelectedTenantsHaveClearedAmlChecks) {
      finalStatus = STATUS_STYLES.yellow;
    } else {
      finalStatus = STATUS_STYLES.green;
    }
    if (DEBUG_CALCULATION) {
      console.log(
        "[getStatusStyle] selectedTenant:",
        selectedTenant?.length,
        "insurable:",
        areAllSelectedTenantsInsurable,
        "amlCleared:",
        areAllSelectedTenantsHaveClearedAmlChecks,
        "→ status:",
        finalStatus?.text
      );
    }
    setStatusStyle(finalStatus);
  };

  const checkInsuranceDocument = async () => {
    try {
      setCheckStatusLoading(true);
      const docStatusResponse = await checkInsuranceDocumentStatus(
        property?._id
      );

      if (haveValue(docStatusResponse?.policyDocument)) {
        await loadData();
        toast.success(_t("policyIsAvailableToDownlaod"));
      } else {
        toast.success(_t("insuranceIsInProcessPleaseWait"));
      }
    } catch (error) {
      toast.error(_t("failedToLoadStatus"));
    } finally {
      setCheckStatusLoading(false);
    }
  };

  const isInsurableEnabledLandlord =
    user?.current_workspace?.insurance_service_status;

  const hasMissingPropertyDetails =
    !property?.province ||
    !property?.muncipality ||
    !property?.postcode ||
    !property?.street ||
    !property?.street_number;

  // One link per selected profile entry — an application entry (multiple
  // participants) still yields a single link since ReportWrapper expands
  // its participants when the link is opened.
  const buildTenantReportLinks = (tenants) => {
    return tenants.map((tenantProfile) => {
      const sharedId = tenantProfile?._id;
      let queryParam = `sharedprofileid=${sharedId}`;
      return `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/${
        haveValue(workspaceId) ? workspaceId + "/" : ""
      }generatedReport/${sharedId}?${queryParam}`;
    });
  };

  // Insurance Handler starts
  const runInsuranceSimulationHandler = async (
    usedFor,
    showProcessingModal = false,
    forceRerun = false,
    showConfirmation = true
  ) => {
    actualInsuranceRetryRef.current = null;
    const isRiskAssessment = usedFor === "risk-assessment";
    if (!areAllSelectedTenantsInsurable) {
      setIsInsuranceNotInsurable(false);
      if (!isRiskAssessment) {
        setIsInsuranceSimulationSuccess(false);
        setInsuranceErrorStatus(constants.INSURANCE_ERROR_STATUS.ERROR);
        setInsuranceErrorCode(null);
        setInsuranceErrorCodes([]);
        setInsuranceErrorMessage(null);
        setInsuranceValidationMessages([]);
        if (showConfirmation) setShowAwardInsurancePopup(true);
      }
      return { isInsurable: false };
    }

    const selectedTenantRecords = selectedTenant.flatMap((selection) => {
      const participants = selection?.application_id?.participants;
      if (participants?.length > 0) {
        return participants
          .map((participant) => participant?.tenant_info)
          .filter(Boolean);
      }
      return [selection?.tenantid].filter(Boolean);
    });

    const tenantDetailErrors = selectedTenantRecords.flatMap((tenant) => {
      const kyc = tenant?.onfido_user_kyc?.onfido_doc_data || {};
      const identity = getIdentityDetails(
        tenant,
        tenant?.onfido_user_kyc,
        true
      );
      const hasStoredIdentityDocument =
        haveValue(tenant?.dni_nie) || haveValue(tenant?.passport_id);
      const missing = [];
      if (!identity?.type) missing.push(_t("documentType"));
      if (!hasStoredIdentityDocument) missing.push(_t("documentNumber"));
      if (!kyc?.first_name && !tenant?.fname && !tenant?.first_name) {
        missing.push(_t("firstName"));
      }
      if (!kyc?.last_name && !tenant?.lname && !tenant?.last_name) {
        missing.push(_t("lastName"));
      }
      if (!tenant?.dob && !tenant?.date_of_birth) {
        missing.push(_t("dateofbirth"));
      }
      if (!missing.length) return [];

      const tenantName = getUserDisplayName(
        tenant,
        tenant?.email || _t("tenant")
      );
      return [
        `${tenantName}: ${_t("missingTenantDetailsForInsurance")} ${missing.join(", ")}`,
      ];
    });

    if (showProcessingModal) {
      setInsuranceSimulationProcessing(true);
    }

    const cacheKey = getSimulationCacheKey(allTenantIds, rent);
    const cached = simulationCacheRef.current[cacheKey];
    if (
      cached &&
      !forceRerun &&
      cacheKey === lastSimulationKeyRef.current &&
      tenantDetailErrors.length === 0
    ) {
      const {
        isInsurable,
        isNotInsurable,
        errorStatus,
        insuranceCost,
        coverageMonths,
        pricingPreview,
        preFilledDocument,
      } = cached;
      setIsInsuranceSimulationSuccess(isInsurable);
      setIsInsuranceNotInsurable(isNotInsurable === true);
      setInsuranceErrorStatus(errorStatus ?? null);
      setInsuranceErrorCode(cached.errorCode ?? null);
      setInsuranceErrorCodes(cached.errorCodes ?? []);
      setInsuranceErrorMessage(cached.errorMessage ?? null);
      setInsuranceValidationMessages(cached.validationMessages ?? []);
      setSimulatedInsuranceCost(insuranceCost ?? null);
      setSimulatedInsuranceCoverageMonths(coverageMonths ?? null);
      setSimulatedPricingPreview(pricingPreview ?? null);
      setPreFilledInsuranceDocument(preFilledDocument ?? null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
      if (!isRiskAssessment && showConfirmation) {
        setShowAwardInsurancePopup(true);
      }
      if (showProcessingModal) {
        setInsuranceSimulationProcessing(false);
      }
      return { isInsurable };
    }

    const propertyErrors = [];

    try {
      if (!isRiskAssessment) {
        setSimulationLoading(true);
      }
      setIsInsuranceSimulationSuccess(false);
      setIsInsuranceNotInsurable(false);
      if (!forceRerun) {
        setInsuranceErrorStatus(null);
        setInsuranceErrorCode(null);
        setInsuranceErrorCodes([]);
        setInsuranceErrorMessage(null);
        setInsuranceValidationMessages([]);
      }
      setInsuranceSimulationErrors([]);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
      setSimulationDidNotRun(false);

      if (!property?.province) {
        propertyErrors.push(_t("province"));
      }
      if (!property?.muncipality) {
        propertyErrors.push(_t("municipality"));
      }
      if (!property?.postcode) {
        propertyErrors.push(_t("postCode"));
      }
      if (!property?.street) {
        propertyErrors.push(_t("streetName"));
      }
      if (!property?.street_number) {
        propertyErrors.push(_t("streetNumber"));
      }

      if (propertyErrors.length > 0) {
        setSimulationPropertyErrors(propertyErrors);
        setInsuranceSimulationErrors(propertyErrors);
        if (!isRiskAssessment) {
          setInsuranceSimulationErrorModal("property");
          setSimulationLoading(false);
          setSimulationDidNotRun(true);
          if (showProcessingModal) {
            setInsuranceSimulationProcessing(false);
          }
          return { blocked: true };
        }
      }

      const errors = [...tenantDetailErrors];

      const tenantIds = selectedTenant
        .flatMap((s) => {
          const application = s?.application_id;
          if (application?.participants?.length > 0) {
            return application.participants.map((p) => p?.tenant_info?._id);
          }
          return s?.tenantid?._id ? [s.tenantid._id] : [];
        })
        .filter(Boolean);

      const checkConsentResponse = await checkMutuaConsents(tenantIds);
      if (checkConsentResponse?.missingConsent?.length) {
        errors.push(
          ...checkConsentResponse.missingConsent.map(
            (t) => `${t.name} ${_t("hasMissingGrupoMutuaConsent")}`
          )
        );
      }

      if (errors.length > 0) {
        setSimulationConsentErrors(errors);
        setSimulationDidNotRun(true);
        if (!isRiskAssessment) {
          setInsuranceSimulationErrorModal(true);
          setInsuranceSimulationErrors(errors);
          setSimulationLoading(false);
          if (showProcessingModal) {
            setInsuranceSimulationProcessing(false);
          }
        }
        console.log(
          "Simulation not processed due to following errors:",
          errors
        );
        return { blocked: true };
      }

      setSimulationLoading(true);

      const payload = {
        propertyId: property?._id,
        property_rent: rent,
        lease_start_date: moment().format("DD/MM/YYYY"),
        policy_start_date: moment().format("DD/MM/YYYY"),
        selections: allTenantIds,
        prefilled_insurance_doc_urls: buildTenantReportLinks(selectedTenant),
      };
      const simulationResponse = await runInsuranceSimulation(payload);

      const isInsurable = simulationResponse?.success_res?.isInsurable === true;
      const isNotInsurable = simulationResponse?.not_insurable === true;
      const errorStatus =
        simulationResponse?.errorStatus ??
        (isInsurable ? null : constants.INSURANCE_ERROR_STATUS.ERROR);
      const errorCode = simulationResponse?.errorCode ?? null;
      const errorCodes = simulationResponse?.errorCodes ?? [];
      const errorMessage = simulationResponse?.message ?? null;
      const validationMessages = simulationResponse?.validationMessages ?? [];
      const insuranceCost =
        simulationResponse?.success_res?.insuranceCost ?? null;
      const coverageMonths =
        simulationResponse?.success_res?.costBreakdown?.coverageMonths ?? null;
      const pricingPreview =
        simulationResponse?.success_res?.pricingPreview ?? null;
      const preFilledDocument = isInsurable
        ? (simulationResponse?.success_res?.pre_filled_insurance_document ??
          null)
        : null;

      simulationCacheRef.current[cacheKey] = {
        isInsurable,
        isNotInsurable,
        errorStatus,
        errorCode,
        errorCodes,
        errorMessage,
        validationMessages,
        insuranceCost,
        coverageMonths,
        pricingPreview,
        preFilledDocument,
      };
      lastSimulationKeyRef.current = cacheKey;
      setIsInsuranceNotInsurable(isNotInsurable);
      setInsuranceErrorStatus(errorStatus);
      setInsuranceErrorCode(errorCode);
      setInsuranceErrorCodes(errorCodes);
      setInsuranceErrorMessage(errorMessage);
      setInsuranceValidationMessages(validationMessages);
      setSimulatedInsuranceCost(insuranceCost);
      setSimulatedInsuranceCoverageMonths(coverageMonths);
      setSimulatedPricingPreview(pricingPreview);
      setPreFilledInsuranceDocument(preFilledDocument);

      if (isInsurable) {
        if (!isRiskAssessment && showConfirmation) {
          // setInsuracePopupModal(true);
          setShowAwardInsurancePopup(true);
        }
        setIsInsuranceSimulationSuccess(true);
      } else if (!isRiskAssessment && showConfirmation) {
        setShowAwardInsurancePopup(true);
      }
      setSimulationDidNotRun(false);
      return { isInsurable };
    } catch (error) {
      console.log("Failed in runInsuranceSimulation", error);
      toast.error(_t("failedToRunInsuranceSimulation"));
      return { blocked: true };
    } finally {
      setSimulationLoading(false);
      if (showProcessingModal) {
        setInsuranceSimulationProcessing(false);
      }
    }
  };

  // Insurance Handler ends

  const isInsurable = user?.insurance_service_status;

  /**
   * Thin wrapper around the pure `computeFinalResult` utility.
   *
   * All business logic lives in src/utils/computeFinalResult.js so it can be
   * imported and tested independently. This wrapper simply:
   *   1. Forwards the current component state as parameters.
   *   2. Applies the returned `sideEffects` to the component's state setters.
   *   3. Returns the `result` (report payload or null) as before.
   */
  const renderFinalResult = (isReport = false) => {
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      const now = Date.now();
      if (!lastToastTime || now - lastToastTime > TOAST_BUFFER_MS) {
        toast.error(
          _t(
            "tenantSharingNotAccepted",
            "Cannot generate report. Tenant has not accepted sharing with landlord."
          )
        );
        setLastToastTime(now);
      }
      return;
    }
    const { result, sideEffects } = computeFinalResult({
      tenantResults,
      selectedTenant,
      customPolicyDetails,
      giveInsurance,
      finalEffortRate,
      enabled,
      deaWorkspace,
      user,
      lastVerdict,
      lastRecommendationFlags,
      STATUS_STYLES,
      translate: _t,
      isReport,
      guarantorResults,
    });

    if (DEBUG_CALCULATION) {
      console.log("[renderFinalResult] isReport:", isReport, "sideEffects:", {
        verdict: sideEffects.verdict,
        nextStatusStyle: sideEffects.nextStatusStyle?.text,
        showAddGuarantor: sideEffects.showAddGuarantor,
        recommendationFlags: sideEffects.recommendationFlags,
      });
    }

    // Apply side-effects returned by the pure function
    try {
      if (sideEffects.nextStatusStyle !== null) {
        setStatusStyle((prev) =>
          prev === sideEffects.nextStatusStyle
            ? prev
            : sideEffects.nextStatusStyle
        );
      }
    } catch (e) {}

    try {
      if (sideEffects.verdict !== null) setLastVerdict(sideEffects.verdict);
    } catch (e) {}

    try {
      if (sideEffects.recommendationFlags !== null)
        setLastRecommendationFlags(sideEffects.recommendationFlags);
    } catch (e) {}

    try {
      if (sideEffects.showAddGuarantor !== null)
        setLastShowAddGuarantor(sideEffects.showAddGuarantor);
    } catch (e) {}

    return result;
  };

  const renderIndividualDeaResult = (id) => {
    if (haveValue(id)) {
      const data = allDeaResult?.[id];
      const profilesHaveMissingDocs = data?.vals?.DOCUMENTATION > 0;
      const finalScore = data?.DEA_SCORE?.finalScore;

      const hasHardFailEntries =
        // data?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
        data?.errorEntries?.length > 0;

      // ✅ NEW (safe optional checks)
      const guarantors = data?.guarantors || [];

      const guarantorHasHardFail = guarantors.some(
        (g) =>
          //   g?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
          g?.errorEntries?.length > 0
      );

      const guarantorMissingDocs = guarantors.some(
        (g) => g?.vals?.DOCUMENTATION > 0
      );

      // 🔴 unchanged logic + guarantor extension
      if (hasHardFailEntries || guarantorHasHardFail) {
        return STATUS_STYLES.red;
      } else if (
        !profilesHaveMissingDocs &&
        !guarantorMissingDocs &&
        finalScore > 4
      ) {
        return STATUS_STYLES.green;
      } else {
        return STATUS_STYLES.yellow;
      }
    }
  };

  const EligibilityCard = (props) => {
    const { _t } = useTranslator();
    return (
      <div
        className={`eligibility-box d-flex flex-column gap-8px mb-2 ${props.status}`}
      >
        <div className="d-flex gap-6px align-items-center justify-content-between heading-wrapper">
          <div className="d-flex gap-6px align-items-center">
            {props.status === "conditional" ? (
              <img
                src="/images/warning.svg"
                alt="warning-icon"
                className="heading-icon"
              />
            ) : props.status === "rejected" ? (
              <img
                src="/images/notApproved.svg"
                alt="warning-icon"
                className="heading-icon"
              />
            ) : (
              <CheckIcon />
            )}
            <h3>{props.title}</h3>
          </div>
          {/* {Object?.entries(tenantResults)?.length > 0 && ( */}
          {props.status !== "rejected" && (
            <a
              onClick={(e) => {
                e.preventDefault();
                const generatedReport = renderFinalResult(true);
                setRiskReportData(generatedReport);
                setShowRiskAssessmentReportModal(true);
              }}
              className="cursor-pointer underline"
              style={{ fontSize: "0.972vw", fontWeight: "500" }}
            >
              {_t("viewDetails")}
            </a>
          )}
          {/* )} */}
        </div>

        <p className="eligibility-description">{props.description}</p>

        {props.lowEffortRate && !props.errorReasons?.length && !enabled && (
          <div className="d-flex align-items-center gap-6px">
            <span className="dot-low-effort-rate" />
            <p>
              {props.lowEffortRate.name} — {props.lowEffortRate.reason}
            </p>
          </div>
        )}

        {props.errorReasons?.length > 0 && !enabled ? (
          <div className="d-flex flex-column gap-6px">
            {props.errorReasons.map((errorReason) => (
              <div
                key={errorReason.id}
                className="d-flex align-items-center gap-6px"
              >
                <span className="dot-low-effort-rate" />
                <p>
                  {errorReason.name} — {errorReason.reason}
                </p>
              </div>
            ))}
          </div>
        ) : (
          ""
        )}

        {props.showCompleteProfile && (
          <div className="add-guarantor-wrapper d-flex align-items-center gap-6px">
            <DocIcon
              className={props.status === "rejected" ? "error-icon" : ""}
            />
            <p>
              {_t(
                "requestDocumentUploadFromTenant",
                "Shown in recommendation engine when profile is incomplete"
              )}{" "}
            </p>
          </div>
        )}

        {props.showActions && props.status !== "approved" && (
          <p className="add-guarantor-wrapper">
            {_t("recommendedActionBasedOnCurrentData")}
          </p>
        )}
        {props.showActions && (
          <div className="d-flex gap-8px">
            {props.showAddGuarantor && !enabled ? (
              <>
                <div className="d-flex align-items-center gap-6px">
                  {/* <span className="number-circle d-flex align-items-center justify-content-center">
                    1
                  </span> */}
                  <p className="add-guarantor-title add-guarantor-tag">
                    {props.addGuarantorText || "Add Guarantor"}
                  </p>
                  {/* <span className="add-guarantor-strengthen">
                    -{" "}
                    {_t(
                      "strengthenApplication",
                      "Shown in recommendation engine for guarantor addition suggestion"
                    )}
                  </span> */}
                </div>

                {props.showInsurance && !enabled && (
                  <div className="d-flex align-items-center gap-6px">
                    <span className="border-1" />
                    <span className="add-guarantor-strengthen">{_t("or")}</span>
                    <span className="border-1" />
                  </div>
                )}
              </>
            ) : (
              ""
            )}

            {props.showInsurance && (
              <div
                className={`d-flex align-items-center gap-6px justify-content-between ${props.status === "approved" ? "add-guarantor-wrapper" : ""}`}
              >
                <div className="d-flex align-items-center gap-6px">
                  {props.status === "approved" ? (
                    <ShieldIcon />
                  ) : (
                    ""
                    // <span
                    //   className="number-circle d-flex align-items-center justify-content-center"
                    //   style={{
                    //     background: "#87c71a33",
                    //     color: "#87c71a",
                    //   }}
                    // >
                    //   {props.showAddGuarantor ? 2 : 1}
                    // </span>
                  )}
                  {enabled && (
                    <p className="add-guarantor-title">
                      {_t("skorInsuranceEnabled")}
                    </p>
                  )}
                </div>
                <div
                  className={`toggle-wrapper-switch ${enabled ? "toggle-wrapper-switch--active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEnabled((prev) => !prev);
                  }}
                  role="switch"
                  aria-checked={enabled}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setEnabled((prev) => !prev);
                    }
                  }}
                >
                  <div className="track">
                    <div className="knob" />
                  </div>
                  <span className="label">{_t("enableSkorInsurance")}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const handleSkorProtect = () => {
    window.open(
      "https://www.skortorent.com/inquilino/skor-protect",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      {showRiskAssessmentReportModal ? (
        <RiskAssessmentReport
          onClose={handleCloseRiskAssessmentReportModal}
          selectedTenants={selectedTenant}
          reportData={riskReportData}
          enabled={enabled}
          finalEffortRate={finalEffortRate}
          areAllSelectedTenantsInsurable={areAllSelectedTenantsInsurable}
          setEnabled={setEnabled}
          totalCombinedIncome={totalCombinedIncome}
          handleGenerateLinkedReport={handleGenerateLinkedReport}
          isInsurableEnabledLandlord={isInsurableEnabledLandlord}
          runInsuranceSimulationHandler={runInsuranceSimulationHandler}
          simulationLoading={simulationLoading}
          insuracePopupModal={insuracePopupModal}
          isInsuranceSimulationSuccess={isInsuranceSimulationSuccess}
          isInsuranceNotInsurable={isInsuranceNotInsurable}
          insuranceErrorCode={insuranceErrorCode}
          insuranceErrorCodes={insuranceErrorCodes}
          simulationDidNotRun={simulationDidNotRun}
          simulationPropertyErrors={simulationPropertyErrors}
          simulationConsentErrors={simulationConsentErrors}
          onEditProperty={onEditProperty}
          preFilledInsuranceDocument={preFilledInsuranceDocument}
          isPropertyAwarded={isPropertyAwarded}
          isAwardSnapshotCompleted={isAwardSnapshotCompleted}
          isParentLoading={resultLoader}
        />
      ) : null}
      {detailsShow && (
        <div
          className="metermodal modal-xl wrapper-modal modalWidth_set"
          onClick={() => {
            setDetailsShow(false);
            if (setPropData) setPropData({});
            // setSelectedTenant([]);
            handleCloseRiskAssessmentReportModal();
          }}
        >
          <div
            className={`doc-history-popup rental-overview-popup total-salary-modal share-profile-modal sharedTenantProfileModal ${
              detailsShow ? "open" : ""
            }`}
            onClick={(e) => {
              setIsDownloadDocList(false);
              e.stopPropagation();
            }}
          >
            <div className="doc-history-header linked-property-popup-padding d-flex align-items-center justify-content-between">
              {showHistoryView ? (
                <>
                  <div className="d-flex align-items-center custom-gap-2">
                    <img
                      src={CloseIcon}
                      alt=""
                      className="doc-history-close-btn"
                      onClick={() => {
                        setDetailsShow(false);
                        if (setPropData) setPropData({});
                        handleCloseRiskAssessmentReportModal();
                        setShowHistoryView(false);
                      }}
                    />
                    <h4 className="custom-modal-heading">
                      {_t("propertyHistory", "Property history")}
                    </h4>
                  </div>
                  <button
                    type="button"
                    className="btn-back-to-overview text-decoration-none border-0 bg-transparent cursor-pointer d-flex align-items-center gap-1"
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    onClick={() => setShowHistoryView(false)}
                  >
                    ‹ {_t("rentalOverview", "Rental Overview")}
                  </button>
                </>
              ) : (
                <>
                  <div className="d-flex align-items-center custom-gap-2">
                    <img
                      src={CloseIcon}
                      alt=""
                      className="doc-history-close-btn"
                      onClick={() => {
                        setDetailsShow(false);
                        if (setPropData) setPropData({});
                        handleCloseRiskAssessmentReportModal();
                      }}
                    />
                    <h4 className="custom-modal-heading">
                      {_t("rentalOverview")}
                    </h4>
                  </div>
                  <button
                    type="button"
                    className="btn-property-history-toggle text-decoration-none border-0 bg-transparent cursor-pointer d-flex align-items-center gap-1"
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    onClick={() => setShowHistoryView(true)}
                  >
                    <IoStopwatchOutline style={{ fontSize: "17px" }} />
                    {_t("propertyHistory", "Property history")}
                  </button>
                </>
              )}
            </div>
            {showHistoryView ? (
              <div className="rental-overview-scroll tenant-overview-scroll">
                <PropertyHistoryTimeline
                  property={property}
                  user={user}
                  currentLang={currentLang}
                  onBack={() => setShowHistoryView(false)}
                  onViewSnapshot={async (profiles, eventId) => {
                    const processedProfiles =
                      await processSnapshotProfilesFromHistory(profiles);
                    setPropertyShareProfiles(processedProfiles);
                    setIsViewingSnapshotReport(true);
                    setHistorySnapshotEventId(eventId || null);

                    const allModel = processedProfiles.map((entry) => {
                      const hasApplication =
                        entry?.application_id?.participants?.length > 0;
                      if (hasApplication) {
                        return {
                          sharedProfileId: entry._id,
                          type: "application",
                          applicationId: entry?.application_id?._id,
                          participants: (
                            entry?.application_id?.participants || []
                          ).map((p) => ({
                            tenantId: p?.tenant_info?._id || p?.id,
                            guarantorIds:
                              p?.tenant_info?.gurantor_id?.map((g) => g._id) ||
                              [],
                          })),
                        };
                      }
                      return {
                        sharedProfileId: entry._id,
                        type: "tenant",
                        tenantId: entry?.tenantid?._id || entry?.tenant_id?._id,
                        guarantorIds:
                          entry?.tenantid?.gurantor_id?.map((g) => g._id) || [],
                      };
                    });
                    setSelectionModel(allModel);
                    setPendingSnapshotReportOpen(true);
                  }}
                />
              </div>
            ) : (
              <div className="rental-overview-scroll tenant-overview-scroll">
                {/* <div className="assigned_details_body">
                <p className="linked_p_details linked-property-sub-heading">
                  {_t("propertyTitle")}
                </p>
              </div> */}
                <div className="rental-property-summary">
                  <div className="rental-property-info">
                    <div className="rental-property-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                          fill="#253837"
                        />
                      </svg>
                    </div>

                    <div className="rental-property-text">
                      <h3>{formatPropertyAddress(property, currentLang)}</h3>
                      <p>
                        {[property?.province, property?.postcode]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                    </div>
                  </div>

                  <div className="rental-rent-card">
                    <span className="rental-rent-label">
                      {_t("propertyRent")}
                    </span>

                    <div
                      className={`rental-rent-input ${
                        propertyRentError ? "property-validation-error" : ""
                      }`}
                    >
                      <span className="rental-currency">€</span>
                      <input
                        placeholder="0"
                        type="number"
                        value={rent}
                        disabled={
                          isAwardedLocked ||
                          isPropertyBlocked ||
                          simulationLoading
                        }
                        onChange={handleChangeRent}
                        onBlur={handleBlurRent}
                      />
                      <span className="rental-period">/mo</span>
                    </div>

                    {propertyRentError && (
                      <p className="error-message">
                        {_t("pleaseEnterTheRentToProceed")}
                      </p>
                    )}
                  </div>
                </div>
                {hasMissingPropertyDetails && (
                  <div
                    className="d-flex align-items-center gap-1 cursor-pointer missing-property-details"
                    onClick={() => onEditProperty?.()}
                  >
                    <p style={{ color: "#AD3300", margin: 0 }}>
                      {_t("missingPropertyDetails", "Missing property details")}
                    </p>
                    <PencilEditIcon />
                  </div>
                )}
                <div className="assigned_details_body d-flex justify-content-between align-items-center heading-tenant-wrapper">
                  <p className="linked_p_details linked-property-sub-heading">
                    {_t("tenants")}
                  </p>
                </div>
                {isInsurableEnabledLandlord && (
                  <>
                    {isInsuranceEnabledWorkspace &&
                      isPropertyAwarded &&
                      (haveValue(property?.skor_protect_data?._id) ? ( //If property is awarded and ther is skor protect data then it means it is awarded via skor protect otherwise we generally delete the skor protect data is not awarded via skor protect
                        <div
                          className={`insurance-policy-card cursor-pointer ${
                            isCoverageUnderReview ? "under-review" : ""
                          }`}
                          onClick={() =>
                            window.open(
                              "https://www.skortorent.com/inquilino/skor-protect",
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                        >
                          <div className="insurance-policy-main">
                            <div className="insurance-policy-left">
                              <img
                                src={SkorProtectShield}
                                alt=""
                                className="sp-shield-linked-property"
                              />
                              <div className="insurance-policy-info">
                                <h1>{_t("skorProtect")}</h1>
                                <p>
                                  {_t("activeUntil")}{" "}
                                  {formatPolicyDate(policyEndDate)}
                                </p>
                              </div>
                            </div>
                            <div className="insurance-policy-right">
                              <span className="insurance-active-badge">
                                {isCoverageUnderReview && (
                                  <img
                                    src="/images/clock-icon.svg"
                                    alt=""
                                    className="insurance-review-badge-clock"
                                  />
                                )}
                                {isCoverageUnderReview
                                  ? _t("underReview")
                                  : _t("active")}
                              </span>
                            </div>
                          </div>
                          {isCoverageUnderReview && (
                            <p className="insurance-review-message">
                              {_t("coverageTenantChangeReviewMessage")}
                            </p>
                          )}
                        </div>
                      ) : haveValue(
                          property?.insurance_data?.policy_document
                        ) &&
                        property?.insurance_data?.status === "confirmed" ? (
                        <div
                          className={`insurance-policy-card ${
                            isCoverageUnderReview ? "under-review" : ""
                          }`}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="insurance-policy-main">
                            <div className="insurance-policy-left">
                              <div className="insurance-policy-icon-circle">
                                {isCoverageUnderReview ? (
                                  <SkorClockIcon size={16} color="#9A7410" />
                                ) : (
                                  <OutlineShieldIcon />
                                )}
                              </div>
                              <div className="insurance-policy-info">
                                <h1>{_t("nonPaymentInsurance")}</h1>
                                <p>
                                  {[
                                    formatPolicyDate(policyStartDate),
                                    formatPolicyDate(policyEndDate),
                                    property?.insurance_data?.payment_amount &&
                                      `€${property.insurance_data.payment_amount}/${_t("mo")}`,
                                  ]
                                    .filter(Boolean)
                                    .join(" · ")}
                                </p>
                              </div>
                            </div>
                            <div className="insurance-policy-right">
                              <span className="insurance-active-badge">
                                {isCoverageUnderReview && (
                                  <img
                                    src="/images/clock-icon.svg"
                                    alt=""
                                    className="insurance-review-badge-clock"
                                  />
                                )}
                                {isCoverageUnderReview
                                  ? _t("underReview")
                                  : _t("active")}
                              </span>
                              <div className="position-relative">
                                <button
                                  className="download-list-btn d-flex align-items-center justify-content-center"
                                  onClick={() =>
                                    setIsDownloadDocList(!isDownloadDocList)
                                  }
                                >
                                  <DownloadIcon />
                                </button>
                                {isDownloadDocList && (
                                  <div className="download-doc-list-dropdown">
                                    {[
                                      {
                                        label: _t("policyDocument"),
                                        file: property?.insurance_data
                                          ?.policy_document,
                                      },
                                      {
                                        label: _t("invoice"),
                                        file: property?.insurance_data
                                          ?.invoice_document,
                                      },
                                    ].map((item, index) => (
                                      <button
                                        key={index}
                                        className="d-flex align-items-center gap-2"
                                        onClick={() => {
                                          if (item.file) {
                                            window.open(
                                              `${item.file}`,
                                              "_blank"
                                            );
                                          }
                                        }}
                                      >
                                        <img
                                          src="/images/docIconGreen.svg"
                                          alt="Doc"
                                        />
                                        {item.label}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {isCoverageUnderReview && (
                            <p className="insurance-review-message">
                              {_t("coverageTenantChangeReviewMessage")}
                            </p>
                          )}
                        </div>
                      ) : property?.insurance_data?.status === "failed" ? (
                        <div className="non-payment-container">
                          <div className="non-payment-container-info">
                            <img
                              src={"/images/non-payment-insurance.svg"}
                              alt=""
                            />

                            <div>
                              <h1>{_t("failedToProcessInsurance")}</h1>

                              <p>
                                <a
                                  href={`https://wa.me/${localStorage.getItem("usertype") !== "landlord" ? "34911672839" : "34617662602"}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {_t("chatWithSupport")}
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : haveValue(
                          property?.insurance_data?.insurancePayload
                        ) ? (
                        <div className="insurance-policy-card">
                          <div className="insurance-policy-left">
                            <div className="insurance-policy-icon-circle">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#253837"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" />
                                <path d="M15 19l2 2l4 -4" />
                              </svg>
                            </div>
                            <div className="insurance-policy-info">
                              <h1>{_t("nonPaymentInsurance")}</h1>
                              <p>{_t("processingInsurance")}</p>
                            </div>
                          </div>
                          <div className="insurance-policy-right">
                            <div className="ins-policy-processing-spinner" />
                          </div>
                        </div>
                      ) : null)}
                  </>
                )}
                {/* Direct button to purchase insurance */}
                {/* purposely adding false because this div is not needed */}
                {isInsurableEnabledLandlord &&
                  constants.DIRECT_INSURANCE_WHITELIST?.includes(user?.email) &&
                  !isPropertyAwarded &&
                  !isPropertyBlocked &&
                  isInsuranceEnabledWorkspace &&
                  selectedTenant.length > 0 &&
                  WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                    user?.current_workspace_role
                  ) &&
                  (areAllSelectedTenantsInsurable &&
                  checkAllTenantsHaveAcceptedSharing(selectedTenant) ? (
                    <div
                      className="non-payment-container cursor-pointer"
                      onClick={() => {
                        if (
                          insuranceSimulationProcessing ||
                          simulationLoading ||
                          !areAllSelectedTenantsInsurable ||
                          !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                            user?.current_workspace_role
                          )
                        ) {
                          console.log("Not allowed");
                        } else {
                          if (!haveValue(rent)) {
                            setPropertyRentError(true);
                          } else {
                            runInsuranceSimulationHandler(
                              "purchase-insurance",
                              true
                            );
                          }
                        }
                      }}
                    >
                      <div className="non-payment-container-info">
                        <img src={"/images/non-payment-insurance.svg"} alt="" />
                        <div>
                          <h1>
                            {_t(
                              simulationLoading
                                ? "analysingFeasibility"
                                : "getNonPaymentInsurance"
                            )}
                          </h1>
                          {!simulationLoading && (
                            <p>
                              {_t("protectYourRentAgainstDefaultingTenants")}
                            </p>
                          )}
                          <span>
                            <a
                              href="/pdf/Mom_seguroimpagoalquiler.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              {_t("insurancePolicy")}
                            </a>
                          </span>
                        </div>
                      </div>
                      <img
                        className="arrow-right cursor-pointer"
                        src={
                          simulationLoading
                            ? SkorDefaultLoader
                            : "/images/arrow-right.svg"
                        }
                        alt=""
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        borderColor: "#EEEEF3",
                        backgroundColor: "white",
                      }}
                      className="non-payment-container"
                    >
                      <div className="non-payment-container-info">
                        <img src={"/images/insurance-not.svg"} alt="" />
                        <div>
                          <h1 style={{ color: "#7F7F7F" }}>
                            {_t("insuranceNotAvailable")}
                          </h1>
                          <p>{_t("someSelectedTenantsAreNotInsurable")}</p>
                        </div>
                      </div>
                    </div>
                  ))}

                {/* {selectedTenant?.length > 0 &&
                !(
                  isDeaRulesActivated
                ) &&
                (resultLoader ? (
                  <div className="d-flex justify-content-center">
                    <img
                      src={SkorDefaultLoader}
                      className="defaultSkorLoader"
                    />
                  </div>
                ) : (
                  finalRenderedResult
                ))} */}
                {!isAwardedLocked && !isPropertyBlocked && (
                  <div className="profile-page marless tab-profile-search-header w-100">
                    <div className="Search-bar searchbar_cls w-100 d-flex justify-content-between align-items-center">
                      {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                        user?.current_workspace_role
                      ) && (
                        <div className="search_bar_edit">
                          <a href="#">
                            <img src={"/images/search-icon-grey.svg"} alt="" />
                          </a>
                          <input
                            type="text"
                            className="custom-input mb-0 input01"
                            value={searchText}
                            placeholder={_t("searchTenants")}
                            onChange={(e) => {
                              // if (e.target.value.trim() === "") {
                              //   setSelectedTenantsForLink([]);
                              // }
                              setSearchText(e.target.value);
                            }}
                            disabled={
                              isAwardedLocked ||
                              isPropertyBlocked ||
                              simulationLoading
                            }
                          />
                          {haveValue(searchText) ? (
                            <img
                              src={Cancelimg}
                              alt="icon"
                              onClick={() => {
                                // setSelectedTenantsForLink([]);
                                setSearchText("");
                              }}
                              className="canceicon topRightIcon searchCrossIcon"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                      {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                        user?.current_workspace_role
                      ) && (
                        <button
                          className="addGuarantorButton d-flex mx-0 btnNext d-flex jusitfy-content-center align-items-center"
                          onClick={(e) => {
                            setShowEmailModal(true);
                            // setDetailsShow(false);
                          }}
                          disabled={
                            isAwardedLocked ||
                            isPropertyBlocked ||
                            simulationLoading
                          }
                        >
                          <img src="/images/add-white.svg" />
                          {_t("inviteTenant")}
                        </button>
                      )}
                      {(isAwardedLocked || isPropertyBlocked) && (
                        <ButtonActionTooltip />
                      )}
                    </div>
                  </div>
                )}

                {saveTanentLoading ? (
                  <Loader />
                ) : (
                  <>
                    {!saveTanentLoading &&
                      !isAwardedLocked &&
                      !isPropertyBlocked &&
                      (propertyShareProfiles?.length ?? 0) > 0 && (
                        <div
                          className=""
                          style={{
                            padding: "6px 10px",
                            margin: "12px 0 14px 0",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className={`${selectedTenant.length === 0 ? "select-all-bg-empty" : "select-all-bg"} cursor-pointer d-flex align-items-center justify-content-center`}
                              onClick={handleSelectAllLinked}
                            >
                              {selectedTenant.length ===
                                (propertyShareProfiles?.length ?? 0) &&
                              (propertyShareProfiles?.length ?? 0) > 0 ? (
                                <span className="checkmark-icon-all" />
                              ) : selectedTenant.length === 0 ? (
                                <span />
                              ) : (
                                <span className="select-border" />
                              )}
                            </div>
                            <div className="userDetails cursor-pointer">
                              <h4 style={{ fontSize: 14, margin: 0 }}>
                                {selectedTenant.length ===
                                  (propertyShareProfiles?.length ?? 0) &&
                                (propertyShareProfiles?.length ?? 0) > 0
                                  ? _t("allSelected")
                                  : `${selectedTenant.length || 0} ${_t("of")} ${propertyShareProfiles?.length || 0} ${_t("selected")}`}
                              </h4>
                            </div>
                            <div
                              data-tooltip-id="button-action-tooltip"
                              style={{ display: "inline-block" }}
                            >
                              <div
                                onClick={(e) => {
                                  if (
                                    selectedTenant.length === 0 ||
                                    isBulkUnlinking
                                  )
                                    return;
                                  handleBulkUnlink(e);
                                }}
                                className="d-flex align-items-center gap-1"
                                style={{
                                  cursor:
                                    selectedTenant.length === 0 ||
                                    isBulkUnlinking
                                      ? "not-allowed"
                                      : "pointer",
                                  opacity:
                                    selectedTenant.length === 0 ? 0.5 : 1,
                                }}
                              >
                                <img
                                  src={UnLinkIcon}
                                  alt=""
                                  width="16"
                                  height="16"
                                />
                                <span
                                  style={{
                                    color: "#D74142",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                  }}
                                >
                                  {isBulkUnlinking
                                    ? `${_t("unlinking")}...`
                                    : _t("unLink")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    <div
                      className="mobile-single-property"
                      style={
                        simulationLoading
                          ? { opacity: 0.4, pointerEvents: "none" }
                          : {}
                      }
                    >
                      <ul>
                        {getName()?.length > 0 ? (
                          getName()?.map((assignPropData) => {
                            const applicationDetails =
                              getApplicationDetails(assignPropData);
                            const isApplicationRow =
                              applicationDetails?.hasApplication === true;
                            const tenantId =
                              assignPropData?.tenantid?._id ||
                              assignPropData?.value;
                            const applicationId =
                              assignPropData?.application_id?._id;
                            const trackingId = isApplicationRow
                              ? applicationId
                              : tenantId;
                            const isLinking =
                              linkingTenantIds.includes(trackingId);
                            const isUnlinking =
                              unlinkingTenantIds.includes(trackingId);
                            const isProcessing = isLinking || isUnlinking;
                            const isLinkedToProperty = isEditingAwarded
                              ? propertyShareProfiles.some(
                                  (profile) =>
                                    getProfileEntityKey(profile) ===
                                    getProfileEntityKey(assignPropData)
                                )
                              : isApplicationRow
                                ? linkedApplicationIds.includes(applicationId)
                                : selectedTanents.includes(
                                    getTenantId(assignPropData)
                                  );
                            const shouldShowLinkAction =
                              isLinking ||
                              (!isUnlinking && !isLinkedToProperty);
                            const isSelectionDisabled = false;
                            const isOpen =
                              openApplicationIds[assignPropData?._id] === true;

                            const isProfilePending = checkIsProfilePending(
                              assignPropData?.tenantid ??
                                assignPropData?.tenant_id,
                              assignPropData
                            );
                            const isDeleted = assignPropData?.deleted === true;
                            const isOutdated =
                              assignPropData?.tenantid?.is_outdated === true;

                            const isAppFullySelected =
                              isApplicationRow &&
                              isApplicationFullySelected(
                                selectionModel,
                                assignPropData?._id,
                                assignPropData
                              );
                            const isAppPartiallySelected =
                              isApplicationRow &&
                              isApplicationPartiallySelected(
                                selectionModel,
                                assignPropData?._id,
                                assignPropData
                              );
                            const isDirectTenantInModel =
                              !isApplicationRow &&
                              selectionModel.some(
                                (e) =>
                                  e.sharedProfileId === assignPropData?._id &&
                                  e.type === "tenant"
                              );

                            return (
                              <li
                                className={`d-flex flex-column listWrapper linked_li_details linked_li_details2 ${
                                  isApplicationRow
                                    ? "linked-application-row"
                                    : ""
                                } ${isOutdated ? "outdated-profile-row" : ""} ${
                                  isSelectionDisabled
                                    ? "selection-disabled-row"
                                    : ""
                                }`}
                                style={{
                                  ...(isProfilePending || isDeleted
                                    ? {
                                        backgroundColor: "#F5F4ED",
                                        borderColor: "#BEBCBA",
                                        //   borderWidth: "1px",
                                        //   borderStyle: "solid",
                                      }
                                    : {}),
                                }}
                              >
                                <div
                                  className={`d-flex w-100 justify-content-between ${
                                    isApplicationRow
                                      ? "align-items-start flex-column"
                                      : "align-items-center"
                                  }`}
                                >
                                  <div
                                    className={`linked_li_div d-flex align-items-center custom-gap-2 w-100 px-0 ${
                                      isApplicationRow
                                        ? ""
                                        : "justify-content-center"
                                    }`}
                                  >
                                    {!haveValue(searchText) && (
                                      <div
                                        className={`checkboxWrapper d-flex align-items-center justify-content-center ${
                                          isAwardedLocked ||
                                          isPropertyBlocked ||
                                          isDeleted ||
                                          !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                            user?.current_workspace_role
                                          )
                                            ? "checkboxWrapperDisabled"
                                            : ""
                                        }
                                      ${isPropertyBlocked ? "lpp-status-dot-wrapper" : ""}
                                      `}
                                      >
                                        {isPropertyBlocked ? (
                                          <span
                                            className="lpp-status-dot"
                                            style={{
                                              background: "#2d8d07",
                                            }}
                                          />
                                        ) : (
                                          <label
                                            className={`custom-gap-3 custom-checkbox mb-0${
                                              isAppPartiallySelected
                                                ? " indeterminate"
                                                : ""
                                            }`}
                                            style={{
                                              opacity: isProfilePending
                                                ? "0"
                                                : "",
                                            }}
                                          >
                                            <input
                                              type={`checkbox`}
                                              checked={
                                                isApplicationRow
                                                  ? isAppFullySelected
                                                  : isDirectTenantInModel
                                              }
                                              onChange={
                                                isApplicationRow
                                                  ? () =>
                                                      toggleAllParticipantsInApp(
                                                        assignPropData?._id,
                                                        assignPropData
                                                      )
                                                  : handleCheckboxChange(
                                                      assignPropData
                                                    )
                                              }
                                              disabled={
                                                isAwardedLocked ||
                                                isPropertyBlocked ||
                                                isDeleted ||
                                                !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                                  user?.current_workspace_role
                                                ) ||
                                                isProfilePending
                                              }
                                            />
                                            <span
                                              className={`custom-checkmark`}
                                            ></span>
                                          </label>
                                        )}
                                      </div>
                                    )}
                                    {!isApplicationRow &&
                                      (() => {
                                        const userDisplayName =
                                          getUserDisplayName(
                                            assignPropData?.tenantid
                                          );
                                        const initials =
                                          userDisplayName
                                            ?.split(" ")
                                            ?.filter(Boolean)
                                            ?.slice(0, 2)
                                            ?.map((part) =>
                                              part?.[0]?.toUpperCase()
                                            )
                                            ?.join("") || "U";
                                        return (
                                          <div
                                            className={`earner-thumbnail-wrapper icon-initial d-flex align-items-center justify-content-center ${
                                              isOutdated
                                                ? "outdated-profile-content"
                                                : ""
                                            }`}
                                            style={{
                                              backgroundColor:
                                                isProfilePending || isDeleted
                                                  ? "#D6D4CE"
                                                  : undefined,
                                              fontSize: "10px",
                                              fontWeight: 600,
                                              color:
                                                isProfilePending || isDeleted
                                                  ? "#8B8B8B"
                                                  : "#253837",
                                            }}
                                          >
                                            {isDeleted ? (
                                              <img
                                                src="/images/deleted-user-icon.svg"
                                                alt={_t(
                                                  "deletedUser",
                                                  "Deleted user"
                                                )}
                                                width={16}
                                                height={16}
                                              />
                                            ) : (
                                              initials
                                            )}
                                          </div>
                                        );
                                      })()}
                                    <div
                                      className={`w-100 d-flex justify-content-between`}
                                    >
                                      <div>
                                        {(() => {
                                          const isApplication =
                                            applicationDetails?.hasApplication;

                                          if (isApplication) {
                                            let participantsForIncome =
                                              applicationDetails.acceptedParticipants;

                                            if (selectionModel.length > 0) {
                                              const appEntry =
                                                selectionModel.find(
                                                  (e) =>
                                                    e.sharedProfileId ===
                                                      assignPropData?._id &&
                                                    e.type === "application"
                                                );
                                              if (appEntry) {
                                                const selectedParticipantIds = (
                                                  appEntry.participants || []
                                                ).map((p) => p.tenantId);
                                                participantsForIncome =
                                                  participantsForIncome.filter(
                                                    (p) =>
                                                      selectedParticipantIds.includes(
                                                        p?.tenant_info?._id
                                                      )
                                                  );
                                              }
                                            }

                                            const combinedIncome =
                                              participantsForIncome.reduce(
                                                (sum, participant) => {
                                                  const pInfo =
                                                    participant?.tenant_info;
                                                  const incomeAmount =
                                                    getCustomIncomeDetails(
                                                      pInfo,
                                                      user,
                                                      _t,
                                                      resolveIncomeSelection(
                                                        assignPropData?.income_selection,
                                                        pInfo?._id
                                                      )?.tenant_source,
                                                      undefined,
                                                      undefined,
                                                      deaWorkspace,
                                                      assignPropData?.custom_income_sources
                                                    )?.amount ?? 0;

                                                  let gSum = 0;
                                                  if (
                                                    pInfo?.gurantor_id?.length >
                                                    0
                                                  ) {
                                                    const incomeSel =
                                                      resolveIncomeSelection(
                                                        assignPropData?.income_selection,
                                                        pInfo?._id
                                                      );
                                                    const gSrc =
                                                      incomeSel?.[pInfo?._id]
                                                        ?.guarantor_sources ??
                                                      incomeSel?.guarantor_sources;

                                                    let guarantorsToSum =
                                                      pInfo?.gurantor_id;
                                                    if (
                                                      selectionModel.length > 0
                                                    ) {
                                                      const pGIds =
                                                        getGuarantorIdsForEntry(
                                                          selectionModel,
                                                          assignPropData?._id,
                                                          pInfo?._id
                                                        );
                                                      guarantorsToSum =
                                                        guarantorsToSum.filter(
                                                          (g) =>
                                                            pGIds.includes(
                                                              g?._id
                                                            )
                                                        );
                                                    }

                                                    guarantorsToSum?.forEach(
                                                      (g) => {
                                                        gSum +=
                                                          getCustomIncomeDetails(
                                                            g,
                                                            user,
                                                            _t,
                                                            gSrc?.[g?._id],
                                                            undefined,
                                                            undefined,
                                                            deaWorkspace,
                                                            assignPropData?.custom_income_sources
                                                          )?.amount ?? 0;
                                                      }
                                                    );
                                                  }

                                                  return (
                                                    sum + incomeAmount + gSum
                                                  );
                                                },
                                                0
                                              );
                                            const applicationEffortRate =
                                              getRentPercentage(
                                                combinedIncome,
                                                rent
                                              )?.roundValue ?? 0;

                                            return (
                                              <div className="application-group-wrapper">
                                                <div
                                                  onClick={() =>
                                                    toggleApplicationAccordion(
                                                      assignPropData?._id
                                                    )
                                                  }
                                                  className="application-group-header cursor-pointer"
                                                >
                                                  <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    <span className="position-relative small-profile-box-wrapper">
                                                      <div className="mobile-profile-info-box">
                                                        <div className="userImageWrapper user-image-wrapper icon-initial">
                                                          <img
                                                            src="/images/Flatmates.svg"
                                                            alt="User Icon"
                                                          />
                                                        </div>
                                                      </div>
                                                      {applicationDetails
                                                        ?.participants?.length >
                                                        0 && (
                                                        <div className="member-count-wrapper d-flex align-items-center justify-content-center">
                                                          {
                                                            applicationDetails
                                                              ?.participants
                                                              ?.length
                                                          }
                                                        </div>
                                                      )}
                                                    </span>
                                                    <div>
                                                      <p className="linked_li_score scoreTextProperty mb-0 application-combined-income">
                                                        <div className="d-flex align-items-center gap-2">
                                                          <p className="linked_li_name mb-1 trimmed-linked-property-title">
                                                            {
                                                              applicationDetails?.title
                                                            }
                                                          </p>
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="10"
                                                            height="10"
                                                            viewBox="0 0 8 8"
                                                            fill="none"
                                                            className={`application-chevron ${
                                                              isOpen
                                                                ? "application-chevron-open"
                                                                : ""
                                                            }`}
                                                          >
                                                            <path
                                                              d="M2 1L6 4L2 7"
                                                              stroke="#253837"
                                                              strokeWidth="1.2"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                            />
                                                          </svg>
                                                          {applicationDetails?.skor_protect && (
                                                            <>
                                                              <span
                                                                data-tooltip-id={`isf-sp-badge-tooltip-${assignPropData?.tenantid?._id}`}
                                                                className="d-flex align-items-center"
                                                                onClick={(
                                                                  e
                                                                ) => {
                                                                  e.preventDefault();
                                                                  e.stopPropagation();
                                                                }}
                                                                onTouchStart={(
                                                                  e
                                                                ) => {
                                                                  e.stopPropagation();
                                                                }}
                                                              >
                                                                <SkorProtectBadge />
                                                              </span>
                                                              <ReactTooltip
                                                                id={`isf-sp-badge-tooltip-${assignPropData?.tenantid?._id}`}
                                                                place="bottom"
                                                                className="react-tooltip-styling react-tooltip-styling-skor-protect"
                                                                clickable
                                                                style={{
                                                                  maxWidth:
                                                                    "330px",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                                render={() => (
                                                                  <p
                                                                    style={{
                                                                      lineHeight: 1.2,
                                                                    }}
                                                                  >
                                                                    {_t(
                                                                      "skorProtectTooltipDescription"
                                                                    )}{" "}
                                                                    <span
                                                                      onClick={(
                                                                        e
                                                                      ) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleSkorProtect();
                                                                      }}
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                        textDecoration:
                                                                          "underline",
                                                                      }}
                                                                    >
                                                                      {_t(
                                                                        "skorProtectTooltipLink"
                                                                      )}
                                                                    </span>
                                                                  </p>
                                                                )}
                                                              />
                                                            </>
                                                          )}
                                                        </div>
                                                        {/* <div className="w-100 text-center d-flex justify-content-center custom-gap-2"> */}
                                                        <div className="w-100 text-center d-flex custom-gap-2">
                                                          <p className="linked_li_score scoreTextProperty scoreTextDivider mb-0">
                                                            {_t("income")}:{" "}
                                                            {combinedIncome} €/
                                                            {_t("mo")}
                                                          </p>
                                                          <p
                                                            className="linked_li_score scoreTextProperty mb-0"
                                                            style={{
                                                              marginLeft: "4px",
                                                            }}
                                                          >
                                                            {_t("effortRate")}:{" "}
                                                            {
                                                              applicationEffortRate
                                                            }
                                                            %
                                                          </p>
                                                        </div>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          }

                                          return (
                                            <>
                                              <p
                                                onClick={() => {
                                                  if (isDeleted) return;
                                                  handleOpenProfile(
                                                    assignPropData
                                                  );
                                                }}
                                                className={`linked_li_name d-flex gap-2 align-items-center cursor-pointer ${
                                                  isOutdated
                                                    ? "outdated-profile-content"
                                                    : ""
                                                }
                                                    ${assignPropData?.tenantid?.skor_protect ? "ellipse-name" : ""}`}
                                              >
                                                <h6>
                                                  {isDeleted
                                                    ? _t(
                                                        "deletedUser",
                                                        "Deleted user"
                                                      )
                                                    : getUserDisplayName(
                                                        assignPropData?.tenantid
                                                      )}
                                                </h6>{" "}
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="7"
                                                  height="11"
                                                  viewBox="0 0 8 13"
                                                  fill="none"
                                                  className="arrow-icon"
                                                >
                                                  <path
                                                    d="M1 12L7 6.5L1 1"
                                                    stroke="#253837"
                                                    strokeWidth="1.4"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  />
                                                </svg>
                                                {assignPropData?.tenantid
                                                  ?.skor_protect && (
                                                  <>
                                                    <span
                                                      data-tooltip-id={`isf-sp-badge-tooltip-${assignPropData?.tenantid?._id}`}
                                                      className="d-flex align-items-center"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                      }}
                                                      onTouchStart={(e) => {
                                                        e.stopPropagation();
                                                      }}
                                                    >
                                                      <SkorProtectBadge />
                                                    </span>
                                                    <ReactTooltip
                                                      id={`isf-sp-badge-tooltip-${assignPropData?.tenantid?._id}`}
                                                      place="bottom"
                                                      className="react-tooltip-styling react-tooltip-styling-skor-protect"
                                                      clickable
                                                      style={{
                                                        maxWidth: "330px",
                                                        whiteSpace: "normal",
                                                      }}
                                                      render={() => (
                                                        <p
                                                          style={{
                                                            lineHeight: 1.2,
                                                          }}
                                                        >
                                                          {_t(
                                                            "skorProtectTooltipDescription"
                                                          )}{" "}
                                                          <span
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              handleSkorProtect();
                                                            }}
                                                            style={{
                                                              cursor: "pointer",
                                                              textDecoration:
                                                                "underline",
                                                            }}
                                                          >
                                                            {_t(
                                                              "skorProtectTooltipLink"
                                                            )}
                                                          </span>
                                                        </p>
                                                      )}
                                                    />
                                                  </>
                                                )}
                                              </p>
                                            </>
                                          );
                                        })()}
                                        {isDeleted ? (
                                          <div className="profile-incomplete-card d-flex align-items-center justify-content-center gap-1">
                                            <img
                                              src="/images/deleted-user-icon.svg"
                                              alt=""
                                              width={12}
                                              height={12}
                                            />
                                            <p>
                                              {_t(
                                                "deletedUser",
                                                "Deleted user"
                                              )}
                                            </p>
                                          </div>
                                        ) : isProfilePending ? (
                                          <div className="profile-incomplete-card d-flex align-items-center justify-content-center gap-1">
                                            {/* clock icon */}
                                            <img
                                              src="/images/clock.svg"
                                              alt=""
                                            />
                                            <p>{_t("profileIncomplete")}</p>
                                          </div>
                                        ) : (
                                          <>
                                            {!getApplicationDetails(
                                              assignPropData
                                            ).hasApplication && (
                                              <>
                                                <div
                                                  className={`d-flex align-items-center justify-content-start custom-gap-3 score-text-property-margin ${isOutdated ? "outdated-profile-content" : ""}`}
                                                >
                                                  {isDeaRulesActivated ? (
                                                    haveValue(
                                                      allDeaResult?.[
                                                        assignPropData?._id
                                                      ]
                                                    ) ? (
                                                      (() => {
                                                        const result =
                                                          renderIndividualDeaResult(
                                                            assignPropData?._id
                                                          );
                                                        return (
                                                          <>
                                                            <p
                                                              className="deaIndividualStatus d-flex align-items-center custom-gap-2"
                                                              style={{
                                                                background:
                                                                  result.backgroundColor,
                                                                // border: result.border,
                                                                color:
                                                                  result.color,
                                                                fontWeight:
                                                                  result.fw,
                                                              }}
                                                            >
                                                              <img
                                                                src={result.img}
                                                              />
                                                              {
                                                                result.deaIndividualText
                                                              }
                                                            </p>
                                                            <span className="deaIndividualIncome">
                                                              •
                                                            </span>
                                                            <p className="deaIndividualIncome">
                                                              {(() => {
                                                                const tInfo =
                                                                  assignPropData?.tenantid;
                                                                const incomeSelection =
                                                                  resolveIncomeSelection(
                                                                    assignPropData?.income_selection,
                                                                    assignPropData
                                                                      ?.tenantid
                                                                      ?._id
                                                                  );
                                                                const tenantIncome =
                                                                  getCustomIncomeDetails(
                                                                    tInfo,
                                                                    user,
                                                                    _t,
                                                                    incomeSelection?.tenant_source,
                                                                    undefined,
                                                                    undefined,
                                                                    deaWorkspace,
                                                                    assignPropData?.custom_income_sources
                                                                  )?.amount ??
                                                                  0;

                                                                const gSrc =
                                                                  incomeSelection?.[
                                                                    assignPropData
                                                                      ?.tenantid
                                                                      ?._id
                                                                  ]
                                                                    ?.guarantor_sources ??
                                                                  incomeSelection?.guarantor_sources;

                                                                let allGurantors =
                                                                  tInfo?.gurantor_id ||
                                                                  [];
                                                                if (
                                                                  selectionModel.length >
                                                                  0
                                                                ) {
                                                                  const selGuarIds =
                                                                    getGuarantorIdsForEntry(
                                                                      selectionModel,
                                                                      assignPropData?._id,
                                                                      assignPropData
                                                                        ?.tenantid
                                                                        ?._id
                                                                    );
                                                                  allGurantors =
                                                                    allGurantors.filter(
                                                                      (g) =>
                                                                        selGuarIds.includes(
                                                                          g?._id
                                                                        )
                                                                    );
                                                                }
                                                                let guarantorSum = 0;
                                                                allGurantors?.forEach(
                                                                  (g) => {
                                                                    if (
                                                                      haveValue(
                                                                        g
                                                                      )
                                                                    ) {
                                                                      guarantorSum +=
                                                                        getCustomIncomeDetails(
                                                                          g,
                                                                          user,
                                                                          _t,
                                                                          gSrc?.[
                                                                            g
                                                                              ?._id
                                                                          ],
                                                                          undefined,
                                                                          undefined,
                                                                          deaWorkspace,
                                                                          assignPropData?.custom_income_sources
                                                                        )
                                                                          ?.amount ??
                                                                        0;
                                                                    }
                                                                  }
                                                                );

                                                                return (
                                                                  tenantIncome +
                                                                  guarantorSum
                                                                );
                                                              })()}{" "}
                                                              €{"/"}
                                                              {_t("mo")}
                                                            </p>
                                                          </>
                                                        );
                                                      })()
                                                    ) : !isAwardedLocked &&
                                                      !isPropertyBlocked ? (
                                                      <Loader />
                                                    ) : null
                                                  ) : (
                                                    <>
                                                      <p className="linked_li_score scoreTextProperty scoreTextDivider">
                                                        {_t("income")}:{" "}
                                                        {eachRentAmount(
                                                          assignPropData
                                                        )?.combinedIncome ??
                                                          0}{" "}
                                                        €{"/"}
                                                        {_t("mo")}
                                                      </p>
                                                      <p
                                                        className={`scoreTextProperty ${
                                                          isInsurableEnabledLandlord
                                                            ? "scoreTextDivider"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          marginLeft: "4px",
                                                        }}
                                                      >
                                                        {_t("effortRate")}:{" "}
                                                        {calculateRentAmount(
                                                          assignPropData
                                                        )}
                                                        {"% "}
                                                      </p>
                                                      {
                                                        isInsurableEnabledLandlord &&
                                                          !isOutdated &&
                                                          (() => {
                                                            const defaulter =
                                                              isDefaulter(
                                                                assignPropData
                                                                  ?.tenantid
                                                                  ?.tenant_extra_field_id
                                                                  ?.experianJson?.[
                                                                  "s:Envelope"
                                                                ]?.["s:Body"]
                                                                  ?.GenerarInformeResponse
                                                                  ?.GenerarInformeResult
                                                                  ?.InformeDelphi4A3
                                                              );
                                                            return (
                                                              <p
                                                                className="scoreTextProperty"
                                                                style={{
                                                                  color:
                                                                    !defaulter
                                                                      ? "#82cf3f"
                                                                      : "#ff3c3c",
                                                                  marginLeft:
                                                                    "4px",
                                                                }}
                                                              >
                                                                {!defaulter
                                                                  ? _t(
                                                                      "defaultFree"
                                                                    )
                                                                  : _t(
                                                                      "defaulter"
                                                                    )}
                                                              </p>
                                                            );
                                                          })()
                                                        // <p className="scoreTextProperty custom-gap-2 d-flex align-items-center">
                                                      }
                                                    </>
                                                  )}
                                                </div>
                                                {assignPropData?.tenantid
                                                  ?.is_outdated &&
                                                  renderOutdatedStatus(
                                                    assignPropData?.tenantid
                                                      ?._id
                                                  )}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {haveValue(searchText) &&
                                        WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                                          user?.current_workspace_role
                                        ) && (
                                          <div
                                            className={`share-it ${
                                              isApplicationRow
                                                ? "application-share-actions"
                                                : ""
                                            }`}
                                          >
                                            {shouldShowLinkAction ? (
                                              <Link
                                                className="share-btn shareBtnModal"
                                                onClick={() => {
                                                  if (!isProcessing) {
                                                    handleTenantSelect(
                                                      assignPropData,
                                                      "notSelected"
                                                    );
                                                  }
                                                }}
                                                style={
                                                  isProfilePending
                                                    ? {
                                                        backgroundColor:
                                                          "#F5F4ED",
                                                        borderColor: "#BEBDB6",
                                                        borderWidth: "1px",
                                                        borderStyle: "solid",
                                                      }
                                                    : {}
                                                }
                                              >
                                                <img
                                                  src="/images/share-icon.svg"
                                                  alt=""
                                                />
                                                {isLinking
                                                  ? `${_t("linking")}...`
                                                  : isUnlinking
                                                    ? `${_t("unlinking")}...`
                                                    : _t("link")}
                                              </Link>
                                            ) : searchText ? (
                                              <Link
                                                className={`share-btn shareBtnModal selected ${isProfilePending ? "profile-incomplete" : ""}`}
                                                onClick={() => {
                                                  if (!isProcessing) {
                                                    handleTenantSelect(
                                                      assignPropData,
                                                      "selected"
                                                    );
                                                  }
                                                }}
                                              >
                                                {isLinking
                                                  ? `${_t("linking")}...`
                                                  : isUnlinking
                                                    ? `${_t("unlinking")}...`
                                                    : _t("unLink")}
                                              </Link>
                                            ) : (
                                              <button
                                                className={`share-btn btnNext ${isProfilePending ? "profile-incomplete" : ""}`}
                                                onClick={(e) => {
                                                  if (!isUnlinking) {
                                                    handleUnLinkSingle(
                                                      e,
                                                      assignPropData
                                                    );
                                                  }
                                                }}
                                                disabled={isAwardedLocked}
                                              >
                                                {isUnlinking
                                                  ? `${_t("unlinking")}...`
                                                  : _t("unLink")}
                                              </button>
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                {!isApplicationRow &&
                                  assignPropData?.tenantid?.gurantor_id
                                    ?.length > 0 &&
                                  !haveValue(searchText) && (
                                    <div className="d-flex flex-column sub-row-border-line sub-row-border-line-gurantor">
                                      {assignPropData?.tenantid?.gurantor_id?.map(
                                        (guarantor, gIndex) => (
                                          <div
                                            key={`guarantor-${gIndex}`}
                                            style={{
                                              position: "relative",
                                              zIndex: 1,
                                            }}
                                          >
                                            <GuarantorSubRow
                                              isApplication={isApplicationRow}
                                              guarantor={guarantor}
                                              rent={rent}
                                              user={user}
                                              _t={_t}
                                              deaWorkspace={deaWorkspace}
                                              handleOpenProfile={
                                                handleOpenGuarantorProfile
                                              }
                                              assignPropData={assignPropData}
                                              sharedProfileId={
                                                assignPropData?._id
                                              }
                                              parentTenantId={
                                                assignPropData?.tenantid?._id
                                              }
                                              isGuarantorSelected={selectionModel
                                                .find(
                                                  (e) =>
                                                    e.sharedProfileId ===
                                                      assignPropData?._id &&
                                                    e.type === "tenant"
                                                )
                                                ?.guarantorIds?.includes(
                                                  guarantor?._id
                                                )}
                                              onToggleGuarantor={
                                                toggleGuarantor
                                              }
                                              isDisabled={
                                                isAwardedLocked ||
                                                isPropertyBlocked
                                              }
                                            />
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                {isOpen && (
                                  <div className="d-flex flex-column application-sub-tenant mb-3">
                                    <div className="application-participants-list">
                                      {applicationDetails.participants.map(
                                        (participant, index) => {
                                          const participantInfo =
                                            participant?.tenant_info;
                                          const isDeletedParticipant =
                                            participant?.is_deleted === true ||
                                            participant?.deleted;
                                          const isOutdatedParticipant =
                                            participantInfo?.is_outdated ===
                                            true;
                                          const participantName =
                                            isDeletedParticipant
                                              ? _t(
                                                  "deletedUser",
                                                  "Deleted user"
                                                )
                                              : participantInfo
                                                ? getUserDisplayName(
                                                    participantInfo
                                                  )
                                                : participant?.email;
                                          const initials =
                                            participantName
                                              ?.split(" ")
                                              ?.filter(Boolean)
                                              ?.slice(0, 2)
                                              ?.map((part) =>
                                                part?.[0]?.toUpperCase()
                                              )
                                              ?.join("") || "U";

                                          if (!participantInfo) {
                                            return (
                                              <div
                                                key={`${assignPropData?._id}-participant-${index}`}
                                                className={`application-participant-item${
                                                  isDeletedParticipant
                                                    ? ""
                                                    : " cursor-pointer"
                                                }`}
                                                style={
                                                  isDeletedParticipant
                                                    ? { opacity: 0.6 }
                                                    : undefined
                                                }
                                                onClick={() => {
                                                  if (!isDeletedParticipant) {
                                                    handleOpenParticipantProfile(
                                                      participant,
                                                      assignPropData?._id
                                                    );
                                                  }
                                                }}
                                              >
                                                {!haveValue(searchText) &&
                                                  !isAwardedLocked &&
                                                  !isPropertyBlocked && (
                                                    <div
                                                      className="checkboxWrapper checkboxWrapperDisabled d-flex align-items-center justify-content-center"
                                                      style={{ marginRight: 8 }}
                                                      onClick={(e) =>
                                                        e.stopPropagation()
                                                      }
                                                    >
                                                      <label className="custom-gap-3 custom-checkbox mb-0">
                                                        <input
                                                          type="checkbox"
                                                          checked={false}
                                                          disabled={true}
                                                          readOnly
                                                        />
                                                        <span
                                                          className="custom-checkmark"
                                                          style={{
                                                            background:
                                                              "#D6D4CE",
                                                            borderColor:
                                                              "#BEBCBA",
                                                            opacity: 1,
                                                          }}
                                                        />
                                                      </label>
                                                    </div>
                                                  )}
                                                <span
                                                  className={`application-participant-avatar${
                                                    isDeletedParticipant
                                                      ? " application-participant-avatar-deleted"
                                                      : isOutdatedParticipant
                                                        ? " outdated-profile-content"
                                                        : ""
                                                  }`}
                                                >
                                                  {isDeletedParticipant ? (
                                                    <img
                                                      src="/images/deleted-user-icon.svg"
                                                      alt={_t(
                                                        "deletedUser",
                                                        "Deleted user"
                                                      )}
                                                      width={16}
                                                      height={16}
                                                    />
                                                  ) : (
                                                    initials
                                                  )}
                                                </span>
                                                <div className="application-participant-content">
                                                  <p
                                                    className={`application-participant-name ${isOutdatedParticipant ? "outdated-profile-content" : ""}`}
                                                  >
                                                    {participantName}
                                                  </p>
                                                  {!isDeletedParticipant && (
                                                    <p
                                                      className={`application-participant-meta ${isOutdatedParticipant ? "outdated-profile-content" : ""}`}
                                                    >
                                                      {_t("pending")}
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                            );
                                          }
                                          const participantIncomeBase =
                                            getCustomIncomeDetails(
                                              participantInfo,
                                              user,
                                              _t,
                                              resolveIncomeSelection(
                                                assignPropData?.income_selection,
                                                participant?.tenant_info?._id
                                              )?.tenant_source,
                                              undefined,
                                              undefined,
                                              deaWorkspace,
                                              assignPropData?.custom_income_sources
                                            )?.amount ?? 0;

                                          let participantGuarantorIncome = 0;
                                          if (
                                            participantInfo?.gurantor_id
                                              ?.length > 0
                                          ) {
                                            const incomeSel =
                                              resolveIncomeSelection(
                                                assignPropData?.income_selection,
                                                participantInfo?._id
                                              );
                                            const gIncomeSource =
                                              incomeSel?.[participantInfo?._id]
                                                ?.guarantor_sources ??
                                              incomeSel?.guarantor_sources;

                                            let guarantorsToSum =
                                              participantInfo?.gurantor_id;
                                            if (selectionModel.length > 0) {
                                              const pGuarantorIds =
                                                getGuarantorIdsForEntry(
                                                  selectionModel,
                                                  assignPropData?._id,
                                                  participantInfo?._id
                                                );
                                              guarantorsToSum =
                                                guarantorsToSum.filter((g) =>
                                                  pGuarantorIds.includes(g?._id)
                                                );
                                            }

                                            guarantorsToSum?.forEach((g) => {
                                              participantGuarantorIncome +=
                                                getCustomIncomeDetails(
                                                  g,
                                                  user,
                                                  _t,
                                                  gIncomeSource?.[g?._id],
                                                  undefined,
                                                  undefined,
                                                  deaWorkspace,
                                                  assignPropData?.custom_income_sources
                                                )?.amount ?? 0;
                                            });
                                          }

                                          const participantIncome =
                                            participantIncomeBase +
                                            participantGuarantorIncome;
                                          const participantEffort =
                                            getRentPercentage(
                                              participantIncome,
                                              rent
                                            )?.roundValue ?? 0;

                                          return (
                                            <React.Fragment
                                              key={`${assignPropData?._id}-participant-${index}`}
                                            >
                                              <div
                                                className="application-participant-item cursor-pointer"
                                                style={
                                                  isDeletedParticipant
                                                    ? { opacity: 0.6 }
                                                    : undefined
                                                }
                                              >
                                                {!haveValue(searchText) && (
                                                  <div
                                                    className={`checkboxWrapper d-flex align-items-center justify-content-center ${
                                                      isAwardedLocked ||
                                                      isPropertyBlocked
                                                        ? "checkboxWrapperDisabled"
                                                        : ""
                                                    }`}
                                                    style={{ marginRight: 8 }}
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                  >
                                                    <label className="custom-gap-3 custom-checkbox mb-0">
                                                      <input
                                                        type="checkbox"
                                                        checked={isParticipantSelected(
                                                          selectionModel,
                                                          assignPropData?._id,
                                                          participantInfo?._id
                                                        )}
                                                        onChange={(e) => {
                                                          toggleParticipant(
                                                            assignPropData?._id,
                                                            participantInfo?._id
                                                          );
                                                        }}
                                                        disabled={
                                                          isAwardedLocked ||
                                                          isPropertyBlocked ||
                                                          isDeletedParticipant
                                                        }
                                                      />
                                                      <span className="custom-checkmark" />
                                                    </label>
                                                  </div>
                                                )}
                                                <span
                                                  className={`application-participant-avatar${
                                                    isDeletedParticipant
                                                      ? " application-participant-avatar-deleted"
                                                      : isOutdatedParticipant
                                                        ? " outdated-profile-content"
                                                        : ""
                                                  }`}
                                                >
                                                  {isDeletedParticipant ? (
                                                    <img
                                                      src="/images/deleted-user-icon.svg"
                                                      alt={_t(
                                                        "deletedUser",
                                                        "Deleted user"
                                                      )}
                                                      width={16}
                                                      height={16}
                                                    />
                                                  ) : (
                                                    initials
                                                  )}
                                                </span>
                                                <div
                                                  className="application-participant-content w-100"
                                                  onClick={() => {
                                                    if (isDeletedParticipant)
                                                      return;
                                                    handleOpenParticipantProfile(
                                                      participant,
                                                      assignPropData?._id
                                                    );
                                                  }}
                                                >
                                                  <div className="d-flex justify-content-between items-center w-100">
                                                    <p
                                                      className={`application-participant-name ${isOutdatedParticipant ? "outdated-profile-content" : ""}`}
                                                    >
                                                      {participantName}
                                                    </p>
                                                    {!isDeletedParticipant &&
                                                      (participant?.consent_status ===
                                                      "pending" ? (
                                                        <span
                                                          className="participant-status-badge participant-status-pending"
                                                          style={{
                                                            fontSize: 12,
                                                            marginTop: "-2px",
                                                          }}
                                                        >
                                                          {_t(
                                                            "pendingSharingProfile"
                                                          )}
                                                        </span>
                                                      ) : participant
                                                          ?.tenant_info
                                                          ?.forensic_status !==
                                                        "COMPLETED" ? (
                                                        <div
                                                          style={{
                                                            display:
                                                              "inline-flex",
                                                            alignItems:
                                                              "center",
                                                            gap: "5px",
                                                            borderRadius:
                                                              "999px",
                                                            padding: "3px 8px",
                                                            fontSize: "11px",
                                                            fontWeight: 600,
                                                            lineHeight: 1,
                                                            background:
                                                              "rgb(242 242 242)",
                                                            color:
                                                              "rgb(127 127 127)",
                                                            border:
                                                              "1px solid rgb(127 127 127)",
                                                          }}
                                                        >
                                                          <LoadingSpinner
                                                            size={"10px"}
                                                            color="rgb(127 127 127)"
                                                            borderWidth={2}
                                                            className={
                                                              "docs-loading-spinner"
                                                            }
                                                          />
                                                          <span
                                                            style={{
                                                              color:
                                                                "rgb(127 127 127)",
                                                            }}
                                                          >
                                                            {_t(
                                                              "processingProfile"
                                                            )}
                                                          </span>
                                                        </div>
                                                      ) : null)}
                                                  </div>
                                                  {!isDeletedParticipant && (
                                                    <>
                                                      <div
                                                        className={`d-flex align-items-center custom-gap-2 ${isOutdatedParticipant ? "outdated-profile-content" : ""}`}
                                                      >
                                                        <p className="application-participant-meta scoreTextDivider">
                                                          {_t("income")}:{" "}
                                                          {participantIncome} €/
                                                          {_t("mo")}
                                                        </p>
                                                        <p
                                                          className={`application-participant-meta ${isInsurableEnabledLandlord ? "scoreTextDivider" : ""}`}
                                                          style={{
                                                            marginLeft: "4px",
                                                          }}
                                                        >
                                                          {" "}
                                                          {_t(
                                                            "effortRate"
                                                          )}:{" "}
                                                          {participantEffort}%
                                                        </p>
                                                        {isInsurableEnabledLandlord &&
                                                          !isOutdatedParticipant &&
                                                          (() => {
                                                            const defaulter =
                                                              isDefaulter(
                                                                participant
                                                                  ?.tenant_info
                                                                  ?.tenant_extra_field_id
                                                                  ?.experianJson?.[
                                                                  "s:Envelope"
                                                                ]?.["s:Body"]
                                                                  ?.GenerarInformeResponse
                                                                  ?.GenerarInformeResult
                                                                  ?.InformeDelphi4A3
                                                              );
                                                            return (
                                                              <p
                                                                className="application-participant-meta"
                                                                style={{
                                                                  color:
                                                                    !defaulter
                                                                      ? "#82cf3f"
                                                                      : "#ff3c3c",
                                                                  marginLeft:
                                                                    "4px",
                                                                }}
                                                              >
                                                                {!defaulter
                                                                  ? _t(
                                                                      "defaultFree"
                                                                    )
                                                                  : _t(
                                                                      "defaulter"
                                                                    )}
                                                              </p>
                                                            );
                                                          })()}
                                                      </div>
                                                      {isOutdatedParticipant &&
                                                        renderOutdatedStatus(
                                                          participantInfo?._id
                                                        )}
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                              {!isDeletedParticipant &&
                                                participantInfo?.gurantor_id
                                                  ?.length > 0 &&
                                                !haveValue(searchText) && (
                                                  <div
                                                    className="d-flex flex-column sub-row-border-line sub-row-border-line-gurantor"
                                                    style={{
                                                      margin: "0px 0 0 11px",
                                                    }}
                                                  >
                                                    {participantInfo?.gurantor_id?.map(
                                                      (guarantor, gIndex) => (
                                                        <div
                                                          key={`participant-guarantor-${gIndex}`}
                                                        >
                                                          <GuarantorSubRow
                                                            isApplication={
                                                              isApplicationRow
                                                            }
                                                            guarantor={
                                                              guarantor
                                                            }
                                                            rent={rent}
                                                            user={user}
                                                            _t={_t}
                                                            deaWorkspace={
                                                              deaWorkspace
                                                            }
                                                            handleOpenProfile={
                                                              handleOpenGuarantorProfile
                                                            }
                                                            assignPropData={
                                                              assignPropData
                                                            }
                                                            sharedProfileId={
                                                              assignPropData?._id
                                                            }
                                                            parentTenantId={
                                                              participantInfo?._id
                                                            }
                                                            isGuarantorSelected={selectionModel
                                                              .find(
                                                                (e) =>
                                                                  e.sharedProfileId ===
                                                                    assignPropData?._id &&
                                                                  e.type ===
                                                                    "application"
                                                              )
                                                              ?.participants?.find(
                                                                (p) =>
                                                                  p.tenantId ===
                                                                  participantInfo?._id
                                                              )
                                                              ?.guarantorIds?.includes(
                                                                guarantor?._id
                                                              )}
                                                            onToggleGuarantor={
                                                              toggleGuarantor
                                                            }
                                                            isDisabled={
                                                              isAwardedLocked ||
                                                              isPropertyBlocked
                                                            }
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                )}
                              </li>
                            );
                          })
                        ) : (
                          <p className="notSharedText text-center">
                            {_t("noDataFound")}
                          </p>
                        )}
                      </ul>
                    </div>
                    {/* {isInsurableEnabledLandlord && selectedTenant?.length > 0 && (
                    <div className="doc-history-content doc-history-content-insurance">
                      <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                        <h4>{_t("rentalInsurance")}</h4>
                        <div className="optional-insurance">
                          {_t("optional")}
                        </div>
                      </div>

                      <div
                        style={{ flexWrap: "nowrap" }}
                        className="d-flex align-items-start custom-gap-2"
                      >
                        <div
                          className="checkmarkWrapper"
                          style={{
                            background: areAllSelectedTenantsInsurable
                              ? "transparent"
                              : "#FFE2E2",
                          }}
                        >
                          <img
                            className="commonClassImage"
                            src={
                              areAllSelectedTenantsInsurable
                                ? "/images/checkmark-grey.svg"
                                : notIcon
                            }
                            alt="checkmark-icon"
                          />
                        </div>
                        <div className="d-flex flex-column custom-gap-2">
                          {areAllSelectedTenantsInsurable ? (
                            <p>
                              {_t(
                                "allSelectedTenantsAreEligibleInsuranceWillApplyToAllOfThemIfPurchased"
                              )}
                            </p>
                          ) : (
                            <p>
                              {_t(
                                "someTenantsReuireAManualReviewBeforeRequestingTheInsurance"
                              )}
                            </p>
                          )}
                          <a
                            href="/pdf/Mom_seguroimpagoalquiler.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {_t("insurancePolicy")}
                          </a>
                        </div>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            if (
                              !areAllSelectedTenantsInsurable ||
                              !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                                user?.current_workspace_role
                              )
                            ) {
                              console.log("Not allowed");
                            } else {
                              setInsuracePopupModal(true);
                            }
                          }}
                          className="addGuarantorButton d-flex mx-0 btnNext purchaseInsuranceButton d-flex jusitfy-content-center align-items-center"
                          disabled={
                            !areAllSelectedTenantsInsurable ||
                            !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                              user?.current_workspace_role
                            )
                          }
                        >
                          {_t("requestInsurance")}
                        </button>
                      </div>
                    </div>
                  )} */}
                  </>
                )}
              </div>
            )}
            {!showHistoryView &&
              (saveTanentLoading ? (
                ""
              ) : property?.skor_protect_data?.skor_protect_status ===
                "waiting_for_payment" ? (
                <div className="sp-await-banner">
                  <div className="sp-await-row">
                    <div className="sp-await-left">
                      <div className="sp-await-text">
                        <div className="sp-await-title-row">
                          <InsuranceShieldIcon size={20} color="#D97706" />
                          <span className="sp-await-title">
                            {_t("skorProtectAwaitingPayment")}
                          </span>
                          {skorProtectCountdown && (
                            <span className="sp-await-timer-pill">
                              {/* clock icon */}
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#D97706"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 6v6l4 2" />
                              </svg>
                              {skorProtectCountdown}
                            </span>
                          )}
                        </div>
                        <span className="sp-await-sub">
                          {_t("remainingForTenantToCompletePayment")}
                        </span>
                      </div>
                    </div>
                    <button
                      className="btnNext sp-await-cancel-btn"
                      disabled={skorProtectLoading}
                      onClick={handleCancelSkorProtect}
                    >
                      {skorProtectLoading ? _t("cancelling") : _t("cancel")}
                    </button>
                  </div>
                </div>
              ) : property?.skor_protect_data?.skor_protect_status ===
                "waiting_for_rental_contract" ? (
                <div className="sp-contract-banner">
                  <div className="sp-await-row">
                    <div className="sp-await-left">
                      <OutlineShieldIcon size={20} color="#273A76" />
                      <div className="sp-await-text">
                        <span className="sp-contract-title">
                          {_t("paymentReceivedUploadRentalContract")}
                        </span>
                        <span className="sp-contract-sub">
                          {_t("onceUploadedSkorWillGeneratePolicy")}
                        </span>
                      </div>
                    </div>
                    <button
                      className="btnNext sp-contract-upload-btn"
                      type="button"
                      disabled={skorProtectInsuranceLoading}
                      onClick={handleSkorProtectUpload}
                    >
                      {skorProtectInsuranceLoading
                        ? _t("loading")
                        : _t("upload")}
                    </button>
                  </div>
                </div>
              ) : property?.insurance_beneficiary_payment_data
                  ?.payment_link_status === "waiting_for_payment" ? (
                <div className="ib-await-banner">
                  <div className="ib-await-row">
                    <div className="ib-await-left">
                      <DocIcon className="ib-await-doc-icon" />
                      <div className="ib-await-text">
                        <span className="ib-await-title">
                          {_t("defaultInsuranceAwaitingPayment")}
                        </span>
                        <span className="ib-await-sub">
                          {_t("paymentLinkSentToBeneficiaryWaitingToComplete")}
                        </span>
                        {insuranceBeneficiaryCountdown && (
                          <span className="ib-await-timer-row">
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#a16207"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <path d="M12 6v6l4 2" />
                            </svg>
                            <span>
                              {_t("linkExpiresIn")}{" "}
                              <strong>{insuranceBeneficiaryCountdown}</strong>
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="ib-await-actions">
                      <button
                        className={`ib-await-resend-btn ${beneficiaryLinkSent ? "ib-await-resend-btn--sent" : ""}`}
                        type="button"
                        disabled={
                          resendBeneficiaryLinkLoading ||
                          insuranceBeneficiaryLoading ||
                          beneficiaryLinkSent
                        }
                        onClick={handleResendInsuranceBeneficiaryPaymentLink}
                      >
                        {resendBeneficiaryLinkLoading
                          ? `${_t("sending")}...`
                          : beneficiaryLinkSent
                            ? _t("linkSent")
                            : _t("resendLink")}
                      </button>
                      <button
                        className="ib-await-cancel-btn"
                        type="button"
                        disabled={
                          insuranceBeneficiaryLoading ||
                          resendBeneficiaryLinkLoading
                        }
                        onClick={handleCancelInsuranceBeneficiaryPayment}
                      >
                        {insuranceBeneficiaryLoading
                          ? _t("cancelling")
                          : _t("cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {/* <div className="linked-property-popup-padding">
                    <div className="chat-with-sopport-bottom-fixed">
                      {isPropertyAwarded &&
                        haveValue(property?.insurance_date) &&
                        (moment().diff(
                          moment(property.insurance_payment_date),
                          "hours"
                        ) <= 24 ? (
                          // CASE 1: Insurance date within 24 hours
                          <div className="doc-history-content doc-history-content-insurance doc-history-within-24hrs">
                            <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                              <h4>{_t("processingInsurance")}</h4>
                              <div className="optional-insurance">
                                {_t("optional")}
                              </div>
                            </div>

                            <div className="d-flex align-items-start custom-gap-2">
                              <IoStopwatchOutline className="commonClassImage" />
                              <div className="d-flex flex-column custom-gap-2">
                                <p>
                                  {_t(
                                    "yourInsuraceIseingProcessedAndWillBeSentToYourEmailWithinTwentyFourHours"
                                  )}
                                </p>
                                <a
                                  href="/pdf/Mom_seguroimpagoalquiler.pdf"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {_t("insurancePolicy")}
                                </a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          // CASE 2: Older than 24 hours
                          <div className="doc-history-content">
                            <p>
                              {_t(
                                "yourInsuranceWasSuccessfullyProcessedAndNextStepsWereSentToYourEmailInCaseOfAnyQuestionsPleaseContactOurSupportChat"
                              )}
                            </p>
                            <a
                              href={`https://wa.me/${localStorage.getItem("usertype") !== "landlord" ? "34911672839" : "34617662602"}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {_t("chatWithSupport")}
                            </a>
                          </div>
                        ))}
                    </div>
                  </div> */}
                  {selectedTenant.length > 0 || isPropertyAwarded ? (
                    <div
                      className="rental-overview-footer"
                      style={{
                        borderTop: !isPropertyAwarded
                          ? statusStyle.border
                          : "2px solid #DAECC8",
                        backgroundColor: !isPropertyAwarded
                          ? statusStyle.backgroundColor
                          : "#F2FBE9",
                      }}
                    >
                      {WORKSPACE_ROLES_CAPABILITIES?.propertyManagement?.includes(
                        user?.current_workspace_role
                      ) && (
                        <div
                          className={`
                          buttonset_css bg-transparent d-flex align-items-center justify-content-between gap-2
                          ${isDeaRulesActivated || isPropertyAwarded ? "dea-buttonset_css" : ""}
                        `}
                        >
                          {resultLoader && !isAwardedLocked ? (
                            <img
                              src={SkorDefaultLoader}
                              className="defaultSkorLoader"
                              alt="Example"
                            />
                          ) : isPropertyAwarded && isEditingAwarded ? (
                            <>
                              <button
                                type="button"
                                className="btn-back-to-overview text-decoration-none border-0 bg-transparent cursor-pointer d-flex align-items-center gap-1"
                                style={{
                                  color: "#6C757D",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={handleCancelEdit}
                              >
                                ‹ {_t("back")}
                              </button>
                              <div className="d-flex align-items-center justify-content-end custom-gap-2 w-100">
                                <button
                                  onClick={handleReportAction}
                                  disabled={
                                    reportActionDisabled ||
                                    hasMissingPropertyDetails ||
                                    !rent
                                  }
                                  type="button"
                                  className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                >
                                  {_t("generateReport")}
                                </button>
                                <button
                                  onClick={handleSaveAwardedEditsClick}
                                  disabled={savingAwardEdits}
                                  type="button"
                                  className="btnNext commonButtonPropertyDark"
                                >
                                  {_t("saveChanges")}
                                </button>
                              </div>
                            </>
                          ) : isPropertyAwarded ? (
                            <>
                              <div className="rental-overview-awarded-actions d-flex align-items-center">
                                {isAwardSnapshotProcessing ? (
                                  <span
                                    style={{
                                      color: "#E1BB20",
                                      fontWeight: "600",
                                    }}
                                  >
                                    <LoadingSpinner
                                      size="14px"
                                      color="#E1BB20"
                                      borderWidth={2}
                                    />
                                    {_t("processing")}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      color: "#82CF3F",
                                      fontWeight: "600",
                                    }}
                                  >
                                    <img src={"/images/awarded.svg"} alt="" />
                                    {_t("awarded")}
                                  </span>
                                )}
                                <button
                                  onClick={handleReportAction}
                                  disabled={reportActionDisabled}
                                  type="button"
                                  className="rental-overview-report-button d-flex align-items-center justify-content-center"
                                  title={_t(
                                    "viewReport",
                                    "Ver Informe(ES)/View report(EN)"
                                  )}
                                >
                                  <DocIcon className="rental-overview-report-icon" />
                                </button>
                              </div>
                              <div className="d-flex align-items-center justify-content-end custom-gap-2 w-100">
                                {WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                                  user?.current_workspace_role
                                ) && (
                                  <>
                                    <button
                                      onClick={handleEnterEditMode}
                                      className="commonButtonPropertyDark commonButtonPropertyLight"
                                    >
                                      {_t("edit")}
                                    </button>
                                    <button
                                      onClick={handleVacatePropertyClick}
                                      disabled={isAwardSnapshotProcessing}
                                      className="commonButtonPropertyDark commonButtonPropertyLight"
                                      style={{
                                        background: "#d74142",
                                        color: "#fff",
                                      }}
                                    >
                                      {_t("unAwardProperty")}
                                    </button>
                                  </>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="d-flex w-100 align-items-start d-flex flex-column">
                                <span
                                  style={{
                                    color:
                                      statusStyle.textColor ||
                                      statusStyle.color,
                                    fontWeight: statusStyle.fw,
                                  }}
                                >
                                  {statusStyle.img && (
                                    <img src={statusStyle.img} alt="" />
                                  )}
                                  {statusStyle.text}
                                </span>

                                {/* computed description (uses verdict, enabled, recommendationFlags, showAddGuarantor) */}
                                {isRecommendationRulesActivated &&
                                  selectedTenant.length > 0 &&
                                  !isDeaRulesActivated && (
                                    <p
                                      className="status-description mt-1"
                                      style={{
                                        margin: 0,
                                        color:
                                          statusStyle.textColor ||
                                          statusStyle.color,
                                      }}
                                    >
                                      {(() => {
                                        try {
                                          if (
                                            lastVerdict === "Rejected" &&
                                            lastRecommendationFlags &&
                                            !Object.values(
                                              lastRecommendationFlags
                                            ).some(Boolean)
                                          ) {
                                            return _t("HardFailDescInOverview");
                                          }

                                          if (
                                            lastVerdict === "Approved" ||
                                            enabled
                                          )
                                            return _t(
                                              "approvedApplicationDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastRecommendationFlags?.completeProfile
                                          )
                                            return _t(
                                              "completeProfileDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastShowAddGuarantor &&
                                            lastRecommendationFlags?.buyInsurance
                                          )
                                            return _t(
                                              "addGuarantorOrInsuranceDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (lastShowAddGuarantor)
                                            return _t(
                                              "addGuarantorDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastRecommendationFlags?.buyInsurance
                                          )
                                            return _t(
                                              "buyInsuranceDescription",
                                              "Inside recommendation engine text"
                                            );
                                        } catch (e) {
                                          return "";
                                        }
                                        return "";
                                      })()}
                                    </p>
                                  )}
                              </div>
                              <div className="d-flex align-items-center justify-content-end custom-gap-2 w-100">
                                <>
                                  {isDeaRulesActivated ? (
                                    WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        onClick={generateReport}
                                        disabled={
                                          snapshotLoadFailed ||
                                          isAwardSnapshotProcessing ||
                                          hasMissingPropertyDetails ||
                                          !rent ||
                                          (isPropertyAwarded &&
                                            !isAwardSnapshotCompleted &&
                                            (!checkAllTenantsHaveAcceptedSharing(
                                              selectedTenant
                                            ) ||
                                              (selectedTenant.length === 0 &&
                                                !isPropertyAwarded &&
                                                !isPropertyBlocked)))
                                        }
                                        type="button"
                                        className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                      >
                                        {isPropertyAwarded &&
                                        isAwardSnapshotCompleted
                                          ? _t(
                                              "viewReport",
                                              "Ver Informe(ES)/View report(EN)"
                                            )
                                          : _t("generateReport")}
                                      </button>
                                    )
                                  ) : isRecommendationRulesActivated ? (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        const generatedReport =
                                          renderFinalResult(true);
                                        setRiskReportData(generatedReport);
                                        setShowRiskAssessmentReportModal(true);
                                      }}
                                      disabled={
                                        snapshotLoadFailed ||
                                        isAwardSnapshotProcessing ||
                                        hasMissingPropertyDetails ||
                                        !rent ||
                                        (isPropertyAwarded &&
                                          !isAwardSnapshotCompleted &&
                                          (!checkAllTenantsHaveAcceptedSharing(
                                            selectedTenant
                                          ) ||
                                            selectedTenant.length === 0 ||
                                            simulationLoading))
                                      }
                                      type="button"
                                      className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                    >
                                      {_t("viewDetails")}
                                    </button>
                                  ) : (
                                    WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        onClick={generateReport}
                                        disabled={
                                          snapshotLoadFailed ||
                                          isAwardSnapshotProcessing ||
                                          hasMissingPropertyDetails ||
                                          !rent ||
                                          (isPropertyAwarded &&
                                            !isAwardSnapshotCompleted &&
                                            (!checkAllTenantsHaveAcceptedSharing(
                                              selectedTenant
                                            ) ||
                                              (selectedTenant.length === 0 &&
                                                !isPropertyAwarded &&
                                                !isPropertyBlocked)))
                                        }
                                        type="button"
                                        className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                      >
                                        {isPropertyAwarded &&
                                        isAwardSnapshotCompleted
                                          ? _t(
                                              "viewReport",
                                              "Ver Informe(ES)/View report(EN)"
                                            )
                                          : _t("generateReport")}
                                      </button>
                                    )
                                  )}
                                  {!isPropertyAwarded &&
                                    !isPropertyBlocked &&
                                    WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        style={{
                                          backgroundColor: simulationLoading
                                            ? "#82CF3F"
                                            : statusStyle.color,
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "0.5556vw",
                                          flexWrap: "nowrap",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() => {
                                          if (selectedTenant.length !== 0) {
                                            if (isInsurableEnabledLandlord) {
                                              runInsuranceSimulationHandler(
                                                "award",
                                                true
                                              );
                                            } else {
                                              setShowAwardInsurancePopup(true);
                                            }
                                            setShowRiskAssessmentReportModal(
                                              false
                                            );
                                          }
                                        }}
                                        type="button"
                                        disabled={
                                          !checkAllTenantsHaveAcceptedSharing(
                                            selectedTenant
                                          ) ||
                                          selectedTenant.length === 0 ||
                                          simulationLoading ||
                                          (isRecommendationRulesActivated &&
                                            !isDeaRulesActivated &&
                                            lastVerdict === "Rejected") ||
                                          hasMissingPropertyDetails ||
                                          !rent
                                        }
                                        className="btnNext commonButtonPropertyDark"
                                      >
                                        {simulationLoading && (
                                          <LoadingSpinner
                                            size="1.1111vw"
                                            color="#253837"
                                            borderWidth={2}
                                          />
                                        )}
                                        {simulationLoading
                                          ? _t("analysingFeasibility")
                                          : _t("awardProperty")}
                                      </button>
                                    )}
                                </>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  ) : null}
                </>
              ))}
          </div>
        </div>
      )}
      <AwardPropertyPopup
        awardPopupModal={awardPopupModal}
        setAwardPopupModal={setAwardPopupModal}
        selectedTenants={
          isPropertyAwarded && !isEditingAwarded
            ? propertyAwardedSelectedTenant
            : selectedTenant
        }
        property={property}
        rentVal={rent}
        currentLang={currentLang}
        selectionModel={selectionModel}
        historyEventId={historySnapshotEventId}
        onResolutionChange={({ resolvedIds, unresolvedIds }) => {
          [...(resolvedIds || []), ...(unresolvedIds || [])].forEach((id) => {
            delete resolutionCacheRef.current[id];
          });
          runIdRef.current += 1;
          const rid = runIdRef.current;
          policyCalculate(rid);
          processAssignPropData();
        }}
        isEditingAwarded={isEditingAwarded}
      />
      <PurchaseInsurancePopup
        insuracePopupModal={insuracePopupModal}
        // insuracePopupModal={true}
        setInsuracePopupModal={(val) => {
          if (!val) {
            setUsedForPurchaseInsurance(null);
            setAwardEditProtectionData(null);
          }
          setInsuracePopupModal(val);
        }}
        selectedTenants={purchaseInsuranceSelectedTenants}
        selections={
          awardEditProtectionData
            ? awardEditProtectionData.selections
            : isPropertyAwarded
              ? property?.selections?.length > 0
                ? property.selections
                : allTenantIds
              : isPropertyBlocked
                ? blockedSelectionsForRequests
                : allTenantIds
        }
        property={property}
        rent={rent}
        insuranceCost={simulatedInsuranceCost}
        insuranceCoverageMonths={simulatedInsuranceCoverageMonths}
        preFilledInsuranceDocument={preFilledInsuranceDocument}
        usedFor={usedForPurchaseInsurance}
        onSkorProtectSuccess={handleSkorProtectInsuranceSuccess}
        onInsuranceSendPaymentLinkSuccess={
          handleonInsuranceSendPaymentLinkSuccess
        }
        onInsuranceError={({ errorCode, retry }) => {
          actualInsuranceRetryRef.current = retry;
          setInsuranceErrorStatus(constants.INSURANCE_ERROR_STATUS.ERROR);
          setInsuranceErrorCode(errorCode);
          setInsuranceErrorCodes(errorCode ? [errorCode] : []);
          setInsuranceErrorMessage(null);
          setInsuranceValidationMessages([]);
          setIsInsuranceSimulationSuccess(false);
          setShowAwardInsurancePopup(true);
        }}
        onInsuranceSuccess={() => {
          actualInsuranceRetryRef.current = null;
          setInsuranceErrorStatus(null);
          setInsuranceErrorCode(null);
          setInsuranceErrorCodes([]);
          setInsuranceErrorMessage(null);
          setInsuranceValidationMessages([]);
          setAwardEditProtectionData(null);
          setShowAwardInsurancePopup(false);
        }}
      />
      <InviteTenantModal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        propertyId={property?._id}
        property={property}
      />
      <VacatePropertyModal
        show={showVacatePropertyPopup}
        onHide={() => setShowVacatePropertyPopup(false)}
        onConfirm={handleUnAwardProperty}
        isLoading={isVacatingProperty}
        property={property}
        currentLang={currentLang}
        hasActiveInsurance={hasActiveNonPaymentInsurance}
      />
      <SaveAwardedChangesModal
        show={showSaveAwardChangesPopup}
        onHide={() => setShowSaveAwardChangesPopup(false)}
        onConfirm={handleConfirmAwardedEdits}
        isLoading={
          savingAwardEdits || simulationLoading || insuranceSimulationProcessing
        }
        hasActiveInsurance={hasActiveNonPaymentInsurance}
      />
      <Modal
        show={showUnAwardSuccessPopup}
        onHide={() => {
          setDetailsShow(false);
          setShowUnAwardSuccessPopup(false);
          onPropertyAward(property?._id);
        }}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <div
            className="cursor-pointer"
            onClick={() => {
              setDetailsShow(false);
              setShowUnAwardSuccessPopup(false);
              onPropertyAward(property?._id);
            }}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <h2>{_t("unAwardedProp")}</h2>
          <p>{_t("propertyUnawardedSuccessfully")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen add-landlord-submit"
            onClick={() => {
              setDetailsShow(false);
              setShowUnAwardSuccessPopup(false);
              onPropertyAward(property?._id);
            }}
          >
            {_t(
              "underStoodButtonAfterUnAwardProp",
              "New award property succes modal"
            )}
          </button>
        </Modal.Footer>
      </Modal>
      <SuccessAwardedPropModal
        showSuccessPopup={showSuccessPopup}
        setShowSuccessPopup={setShowSuccessPopup}
        property={property}
        successTenant={successTenant}
        onClose={() => {
          onPropertyAward(property?._id);
        }}
      />
      <ServingPromptModal
        openModal={servingPromptModal}
        profile={currentProfile}
        URL={
          servingPromptModalURL ||
          // user?.isParentLL
          //   ? `/${workspaceId}/profile-property?agencylink=${currentProfile?.agency_tenant_link_id}`
          //   :
          `/${workspaceId}/profile-property?sharedprofileid=${currentProfile?._id}`
        }
        setOpenModal={() => {
          setServingPromptModal(false);
          setServingPromptModalURL("");
        }}
      />
      <InsuranceSimulationErrorsModal
        show={Boolean(insuranceSimulationErrorModal)}
        type={insuranceSimulationErrorModal}
        onHide={() => setInsuranceSimulationErrorModal(false)}
        errors={insuranceSimulationErrors}
        onAction={() => {
          setInsuranceSimulationErrorModal(false);
        }}
      />
      <InsuranceReviewModal
        show={showInsuranceReviewModal}
        onHide={() => setShowInsuranceReviewModal(false)}
        onGotIt={() => {
          setShowInsuranceReviewModal(false);
        }}
      />
      <AwardInsuranceProcessingModal show={insuranceSimulationProcessing} />
      {showAwardInsurancePopup && (
        <AwardInsuranceConfirmPopup
          show={showAwardInsurancePopup}
          onHide={() => setShowAwardInsurancePopup(false)}
          onConfirm={async (decision) => {
            if (isEditingAwarded) {
              const protectionData = {
                selectedTenants: selectedTenant,
                selections: allTenantIds,
              };

              const editsSaved = await handleSaveAwardedEdits();
              if (!editsSaved) return false;

              if (decision === "insurance") {
                setAwardEditProtectionData(protectionData);
                setUsedForPurchaseInsurance(null);
                setInsuracePopupModal(true);
              } else if (decision === "skor_protect_flow") {
                await handleSkorProtectAward(protectionData.selections);
              }
              return;
            }

            if (decision === "insurance") {
              setUsedForPurchaseInsurance(null);
              setInsuracePopupModal(true);
            } else if (decision === "skor_protect_flow") {
              await handleSkorProtectAward();
            } else {
              await handleAwardPropFlow();
            }
          }}
          selectedTenant={selectedTenant}
          property={property}
          currentLang={currentLang}
          isInsurable={isInsuranceSimulationSuccess}
          errorStatus={insuranceErrorStatus}
          errorCode={insuranceErrorCode}
          errorCodes={insuranceErrorCodes}
          errorMessage={insuranceErrorMessage}
          validationMessages={insuranceValidationMessages}
          insuranceRetryLoading={
            simulationLoading || actualInsuranceRetryLoading
          }
          pricingPreview={simulatedPricingPreview}
          onRetryInsurance={async () => {
            if (actualInsuranceRetryRef.current) {
              setActualInsuranceRetryLoading(true);
              try {
                await actualInsuranceRetryRef.current();
              } finally {
                setActualInsuranceRetryLoading(false);
              }
              return;
            }
            await runInsuranceSimulationHandler("award", false, true);
          }}
          skorProtectLoading={skorProtectLoading}
        />
      )}
      {showSkorProtectActivatedPopup && (
        <SkorProtectActivatedPopup
          show={showSkorProtectActivatedPopup}
          onDone={() => setShowSkorProtectActivatedPopup(false)}
        />
      )}
    </>
  );
};

export default LinkedPropertiesPopup;
